import { Models } from '../../../pipeline/models/global.models';
import { IdValue } from '../../../shared/models/id-value.model';

export const statesWithNoSelect: IdValue<string>[] = [
  new IdValue('AK', 'AK', 'Alaska'),
  new IdValue('AL', 'AL', 'Alabama'),
  new IdValue('AR', 'AR', 'Arkansas'),
  new IdValue('AS', 'AS', 'American Samoa'),
  new IdValue('AZ', 'AZ', 'Arizona'),
  new IdValue('CA', 'CA', 'California'),
  new IdValue('CO', 'CO', 'Colorado'),
  new IdValue('CT', 'CT', 'Connecticut'),
  new IdValue('DC', 'DC', 'District of Columbia'),
  new IdValue('DE', 'DE', 'Delaware'),
  new IdValue('FL', 'FL', 'Florida'),
  new IdValue('GA', 'GA', 'Georgia'),
  new IdValue('GU', 'GU', 'Guam'),
  new IdValue('HI', 'HI', 'Hawaii'),
  new IdValue('IA', 'IA', 'Iowa'),
  new IdValue('ID', 'ID', 'Idaho'),
  new IdValue('IL', 'IL', 'Illinois'),
  new IdValue('IN', 'IN', 'Indiana'),
  new IdValue('KS', 'KS', 'Kansas'),
  new IdValue('KY', 'KY', 'Kentucky'),
  new IdValue('LA', 'LA', 'Louisiana'),
  new IdValue('MA', 'MA', 'Massachusetts'),
  new IdValue('MD', 'MD', 'Maryland'),
  new IdValue('ME', 'ME', 'Maine'),
  new IdValue('MI', 'MI', 'Michigan'),
  new IdValue('MN', 'MN', 'Minnesota'),
  new IdValue('MO', 'MO', 'Missouri'),
  new IdValue('MP', 'MP', 'N Mariana Islds'),
  new IdValue('MS', 'MS', 'Mississippi'),
  new IdValue('MT', 'MT', 'Montana'),
  new IdValue('NC', 'NC', 'North Carolina'),
  new IdValue('ND', 'ND', 'North Dakota'),
  new IdValue('NE', 'NE', 'Nebraska'),
  new IdValue('NH', 'NH', 'New Hampshire'),
  new IdValue('NJ', 'NJ', 'New Jersey'),
  new IdValue('NM', 'NM', 'New Mexico'),
  new IdValue('NV', 'NV', 'Nevada'),
  new IdValue('NY', 'NY', 'New York'),
  new IdValue('OH', 'OH', 'Ohio'),
  new IdValue('OK', 'OK', 'Oklahoma'),
  new IdValue('OR', 'OR', 'Oregon'),
  new IdValue('PA', 'PA', 'Pennsylvania'),
  new IdValue('PR', 'PR', 'Puerto Rico'),
  new IdValue('RI', 'RI', 'Rhode Island'),
  new IdValue('SC', 'SC', 'South Carolina'),
  new IdValue('SD', 'SD', 'South Dakota'),
  new IdValue('TN', 'TN', 'Tennessee'),
  new IdValue('TX', 'TX', 'Texas'),
  new IdValue('UT', 'UT', 'Utah'),
  new IdValue('VA', 'VA', 'Virginia'),
  new IdValue('VI', 'VI', 'Virgin Islands'),
  new IdValue('VT', 'VT', 'Vermont'),
  new IdValue('WA', 'WA', 'Washington'),
  new IdValue('WI', 'WI', 'Wisconsin'),
  new IdValue('WV', 'WV', 'West Virginia'),
  new IdValue('WY', 'WY', 'Wyoming'),
].sort((a, b) => a.name.localeCompare(b.name));

export const states: IdValue<string>[] = [new IdValue('0', '', 'Select'), ...statesWithNoSelect];

export const communityPropertyStates: IdValue<string>[] = [
  new IdValue('AZ', 'AZ', 'Arizona'),
  new IdValue('CA', 'CA', 'California'),
  new IdValue('ID', 'ID', 'Idaho'),
  new IdValue('LA', 'LA', 'Louisiana'),
  new IdValue('NM', 'NM', 'New Mexico'),
  new IdValue('NV', 'NV', 'Nevada'),
  new IdValue('TX', 'TX', 'Texas'),
  new IdValue('WI', 'WI', 'Wisconsin'),
  new IdValue('GU', 'GU', 'Guam'),
  new IdValue('PR', 'PR', 'Puerto Rico'),
];

export const timeZones: IdValue<string>[] = [
  new IdValue('0', null, 'Select'),
  new IdValue(Models.ContactTimeZone.PST, Models.ContactTimeZone.PST, 'Pacific'),
  new IdValue(Models.ContactTimeZone.MST, Models.ContactTimeZone.MST, 'Mountain'),
  new IdValue(Models.ContactTimeZone.CST, Models.ContactTimeZone.CST, 'Central'),
  new IdValue(Models.ContactTimeZone.EST, Models.ContactTimeZone.EST, 'Eastern'),
  new IdValue(Models.ContactTimeZone.HST, Models.ContactTimeZone.HST, 'Hawaii'),
];

/**
 * TBD: Remove this?
 * This is a variant of the states lookup with stateIds from Clear 1.
 * Derived from Clear 1: {
        stateId: number;
        stateName: string;
        stateCode: string;
    }
 */
export const statesClear1: IdValue[] = [
  new IdValue(2, 'AK', 'Alaska'),
  new IdValue(1, 'AL', 'Alabama'),
  new IdValue(5, 'AR', 'Arkansas'),
  new IdValue(null, 'AS', 'American Samoa'),
  new IdValue(4, 'AZ', 'Arizona'),
  new IdValue(6, 'CA', 'California'),
  new IdValue(8, 'CO', 'Colorado'),
  new IdValue(9, 'CT', 'Connecticut'),
  new IdValue(11, 'DC', 'District of Columbia'),
  new IdValue(10, 'DE', 'Delaware'),
  new IdValue(12, 'FL', 'Florida'),
  new IdValue(13, 'GA', 'Georgia'),
  new IdValue(null, 'GU', 'Guam'),
  new IdValue(15, 'HI', 'Hawaii'),
  new IdValue(19, 'IA', 'Iowa'),
  new IdValue(16, 'ID', 'Idaho'),
  new IdValue(17, 'IL', 'Illinois'),
  new IdValue(18, 'IN', 'Indiana'),
  new IdValue(20, 'KS', 'Kansas'),
  new IdValue(21, 'KY', 'Kentucky'),
  new IdValue(22, 'LA', 'Louisiana'),
  new IdValue(25, 'MA', 'Massachusetts'),
  new IdValue(24, 'MD', 'Maryland'),
  new IdValue(23, 'ME', 'Maine'),
  new IdValue(26, 'MI', 'Michigan'),
  new IdValue(27, 'MN', 'Minnesota'),
  new IdValue(29, 'MO', 'Missouri'),
  new IdValue(null, 'MP', 'N Mariana Islds'),
  new IdValue(28, 'MS', 'Mississippi'),
  new IdValue(30, 'MT', 'Montana'),
  new IdValue(37, 'NC', 'North Carolina'),
  new IdValue(38, 'ND', 'North Dakota'),
  new IdValue(31, 'NE', 'Nebraska'),
  new IdValue(33, 'NH', 'New Hampshire'),
  new IdValue(34, 'NJ', 'New Jersey'),
  new IdValue(35, 'NM', 'New Mexico'),
  new IdValue(32, 'NV', 'Nevada'),
  new IdValue(36, 'NY', 'New York'),
  new IdValue(39, 'OH', 'Ohio'),
  new IdValue(40, 'OK', 'Oklahoma'),
  new IdValue(41, 'OR', 'Oregon'),
  new IdValue(42, 'PA', 'Pennsylvania'),
  new IdValue(72, 'PR', 'Puerto Rico'),
  new IdValue(44, 'RI', 'Rhode Island'),
  new IdValue(45, 'SC', 'South Carolina'),
  new IdValue(46, 'SD', 'South Dakota'),
  new IdValue(47, 'TN', 'Tennessee'),
  new IdValue(48, 'TX', 'Texas'),
  new IdValue(49, 'UT', 'Utah'),
  new IdValue(51, 'VA', 'Virginia'),
  new IdValue(null, 'VI', 'Virgin Islands'),
  new IdValue(50, 'VT', 'Vermont'),
  new IdValue(53, 'WA', 'Washington'),
  new IdValue(55, 'WI', 'Wisconsin'),
  new IdValue(54, 'WV', 'West Virginia'),
  new IdValue(56, 'WY', 'Wyoming'),
];

// Used by leads form. VI, PR, GU are active states in Clear
export const statesClear2 = statesClear1.filter((s) => s.value !== 'AS');

// Used by leads form. Strips out non US states like guam or virgin islands. Has select for nill
export const statesClear2Select = [new IdValue(null, null, 'Select'), ...statesClear1.filter((s) => s.id)];
/**
 * Derived from Clear 1: {
        countyCode: string;
        stateAbbr: string;
        countyName: string;
    }
 */
export const counties: IdValue<string>[] = [
  new IdValue('0', '', 'Select'),
  new IdValue('13', 'AK', 'Aleutians East'),
  new IdValue('16', 'AK', 'Aleutians West'),
  new IdValue('20', 'AK', 'Anchorage'),
  new IdValue('50', 'AK', 'Bethel'),
  new IdValue('60', 'AK', 'Bristol Bay'),
  new IdValue('68', 'AK', 'Denali'),
  new IdValue('70', 'AK', 'Dillingham'),
  new IdValue('90', 'AK', 'Fairbanks North Star'),
  new IdValue('100', 'AK', 'Haines'),
  new IdValue('105', 'AK', 'Hoonah-Angoon C'),
  new IdValue('110', 'AK', 'Juneau'),
  new IdValue('122', 'AK', 'Kenai Peninsula'),
  new IdValue('130', 'AK', 'Ketchikan Gateway'),
  new IdValue('150', 'AK', 'Kodiak Island'),
  new IdValue('158', 'AK', 'Kusilvak'),
  new IdValue('164', 'AK', 'Lake and Peninsula'),
  new IdValue('170', 'AK', 'Matanuska Susitna'),
  new IdValue('180', 'AK', 'Nome'),
  new IdValue('185', 'AK', 'North Slope'),
  new IdValue('188', 'AK', 'Northwest Arctic'),
  new IdValue('195', 'AK', 'Petersburg Cens'),
  new IdValue('198', 'AK', 'Prince of Wales'),
  new IdValue('220', 'AK', 'Sitka'),
  new IdValue('230', 'AK', 'Skagway Municip'),
  new IdValue('240', 'AK', 'Southeast Fairbanks'),
  new IdValue('261', 'AK', 'Valdez-Cordova'),
  new IdValue('275', 'AK', 'Wrangell City A'),
  new IdValue('282', 'AK', 'Yakutat City'),
  new IdValue('290', 'AK', 'Yukon-Koyukuk'),
  new IdValue('1', 'AL', 'Autauga'),
  new IdValue('3', 'AL', 'Baldwin'),
  new IdValue('5', 'AL', 'Barbour'),
  new IdValue('7', 'AL', 'Bibb'),
  new IdValue('9', 'AL', 'Blount'),
  new IdValue('11', 'AL', 'Bullock'),
  new IdValue('13', 'AL', 'Butler'),
  new IdValue('15', 'AL', 'Calhoun'),
  new IdValue('17', 'AL', 'Chambers'),
  new IdValue('19', 'AL', 'Cherokee'),
  new IdValue('21', 'AL', 'Chilton'),
  new IdValue('23', 'AL', 'Choctaw'),
  new IdValue('25', 'AL', 'Clarke'),
  new IdValue('27', 'AL', 'Clay'),
  new IdValue('29', 'AL', 'Cleburne'),
  new IdValue('31', 'AL', 'Coffee'),
  new IdValue('33', 'AL', 'Colbert'),
  new IdValue('35', 'AL', 'Conecuh'),
  new IdValue('37', 'AL', 'Coosa'),
  new IdValue('39', 'AL', 'Covington'),
  new IdValue('41', 'AL', 'Crenshaw'),
  new IdValue('43', 'AL', 'Cullman'),
  new IdValue('45', 'AL', 'Dale'),
  new IdValue('47', 'AL', 'Dallas'),
  new IdValue('49', 'AL', 'DeKalb'),
  new IdValue('51', 'AL', 'Elmore'),
  new IdValue('53', 'AL', 'Escambia'),
  new IdValue('55', 'AL', 'Etowah'),
  new IdValue('57', 'AL', 'Fayette'),
  new IdValue('59', 'AL', 'Franklin'),
  new IdValue('61', 'AL', 'Geneva'),
  new IdValue('63', 'AL', 'Greene'),
  new IdValue('65', 'AL', 'Hale'),
  new IdValue('67', 'AL', 'Henry'),
  new IdValue('69', 'AL', 'Houston'),
  new IdValue('71', 'AL', 'Jackson'),
  new IdValue('73', 'AL', 'Jefferson'),
  new IdValue('75', 'AL', 'Lamar'),
  new IdValue('77', 'AL', 'Lauderdale'),
  new IdValue('79', 'AL', 'Lawrence'),
  new IdValue('81', 'AL', 'Lee'),
  new IdValue('83', 'AL', 'Limestone'),
  new IdValue('85', 'AL', 'Lowndes'),
  new IdValue('87', 'AL', 'Macon'),
  new IdValue('89', 'AL', 'Madison'),
  new IdValue('91', 'AL', 'Marengo'),
  new IdValue('93', 'AL', 'Marion'),
  new IdValue('95', 'AL', 'Marshall'),
  new IdValue('97', 'AL', 'Mobile'),
  new IdValue('99', 'AL', 'Monroe'),
  new IdValue('101', 'AL', 'Montgomery'),
  new IdValue('103', 'AL', 'Morgan'),
  new IdValue('105', 'AL', 'Perry'),
  new IdValue('107', 'AL', 'Pickens'),
  new IdValue('109', 'AL', 'Pike'),
  new IdValue('111', 'AL', 'Randolph'),
  new IdValue('113', 'AL', 'Russell'),
  new IdValue('117', 'AL', 'Shelby'),
  new IdValue('115', 'AL', 'St. Clair'),
  new IdValue('119', 'AL', 'Sumter'),
  new IdValue('121', 'AL', 'Talladega'),
  new IdValue('123', 'AL', 'Tallapoosa'),
  new IdValue('125', 'AL', 'Tuscaloosa'),
  new IdValue('127', 'AL', 'Walker'),
  new IdValue('129', 'AL', 'Washington'),
  new IdValue('131', 'AL', 'Wilcox'),
  new IdValue('133', 'AL', 'Winston'),
  new IdValue('1', 'AR', 'Arkansas'),
  new IdValue('3', 'AR', 'Ashley'),
  new IdValue('5', 'AR', 'Baxter'),
  new IdValue('7', 'AR', 'Benton'),
  new IdValue('9', 'AR', 'Boone'),
  new IdValue('11', 'AR', 'Bradley'),
  new IdValue('13', 'AR', 'Calhoun'),
  new IdValue('15', 'AR', 'Carroll'),
  new IdValue('17', 'AR', 'Chicot'),
  new IdValue('19', 'AR', 'Clark'),
  new IdValue('21', 'AR', 'Clay'),
  new IdValue('23', 'AR', 'Cleburne'),
  new IdValue('25', 'AR', 'Cleveland'),
  new IdValue('27', 'AR', 'Columbia'),
  new IdValue('29', 'AR', 'Conway'),
  new IdValue('31', 'AR', 'Craighead'),
  new IdValue('33', 'AR', 'Crawford'),
  new IdValue('35', 'AR', 'Crittenden'),
  new IdValue('37', 'AR', 'Cross'),
  new IdValue('39', 'AR', 'Dallas'),
  new IdValue('41', 'AR', 'Desha'),
  new IdValue('43', 'AR', 'Drew'),
  new IdValue('45', 'AR', 'Faulkner'),
  new IdValue('47', 'AR', 'Franklin'),
  new IdValue('49', 'AR', 'Fulton'),
  new IdValue('51', 'AR', 'Garland'),
  new IdValue('53', 'AR', 'Grant'),
  new IdValue('55', 'AR', 'Greene'),
  new IdValue('57', 'AR', 'Hempstead'),
  new IdValue('59', 'AR', 'Hot Spring'),
  new IdValue('61', 'AR', 'Howard'),
  new IdValue('63', 'AR', 'Independence'),
  new IdValue('65', 'AR', 'Izard'),
  new IdValue('67', 'AR', 'Jackson'),
  new IdValue('69', 'AR', 'Jefferson'),
  new IdValue('71', 'AR', 'Johnson'),
  new IdValue('73', 'AR', 'Lafayette'),
  new IdValue('75', 'AR', 'Lawrence'),
  new IdValue('77', 'AR', 'Lee'),
  new IdValue('79', 'AR', 'Lincoln'),
  new IdValue('81', 'AR', 'Little River'),
  new IdValue('83', 'AR', 'Logan'),
  new IdValue('85', 'AR', 'Lonoke'),
  new IdValue('87', 'AR', 'Madison'),
  new IdValue('89', 'AR', 'Marion'),
  new IdValue('91', 'AR', 'Miller'),
  new IdValue('93', 'AR', 'Mississippi'),
  new IdValue('95', 'AR', 'Monroe'),
  new IdValue('97', 'AR', 'Montgomery'),
  new IdValue('99', 'AR', 'Nevada'),
  new IdValue('101', 'AR', 'Newton'),
  new IdValue('103', 'AR', 'Ouachita'),
  new IdValue('105', 'AR', 'Perry'),
  new IdValue('107', 'AR', 'Phillips'),
  new IdValue('109', 'AR', 'Pike'),
  new IdValue('111', 'AR', 'Poinsett'),
  new IdValue('113', 'AR', 'Polk'),
  new IdValue('115', 'AR', 'Pope'),
  new IdValue('117', 'AR', 'Prairie'),
  new IdValue('119', 'AR', 'Pulaski'),
  new IdValue('121', 'AR', 'Randolph'),
  new IdValue('125', 'AR', 'Saline'),
  new IdValue('127', 'AR', 'Scott'),
  new IdValue('129', 'AR', 'Searcy'),
  new IdValue('131', 'AR', 'Sebastian'),
  new IdValue('133', 'AR', 'Sevier'),
  new IdValue('135', 'AR', 'Sharp'),
  new IdValue('123', 'AR', 'St. Francis'),
  new IdValue('137', 'AR', 'Stone'),
  new IdValue('139', 'AR', 'Union'),
  new IdValue('141', 'AR', 'Van Buren'),
  new IdValue('143', 'AR', 'Washington'),
  new IdValue('145', 'AR', 'White'),
  new IdValue('147', 'AR', 'Woodruff'),
  new IdValue('149', 'AR', 'Yell'),
  new IdValue('10', 'AS', 'Eastern'),
  new IdValue('20', 'AS', 'Manua'),
  new IdValue('30', 'AS', 'Rose Island'),
  new IdValue('40', 'AS', 'Swains Island'),
  new IdValue('50', 'AS', 'Western'),
  new IdValue('1', 'AZ', 'Apache'),
  new IdValue('3', 'AZ', 'Cochise'),
  new IdValue('5', 'AZ', 'Coconino'),
  new IdValue('7', 'AZ', 'Gila'),
  new IdValue('9', 'AZ', 'Graham'),
  new IdValue('11', 'AZ', 'Greenlee'),
  new IdValue('12', 'AZ', 'La Paz'),
  new IdValue('13', 'AZ', 'Maricopa'),
  new IdValue('15', 'AZ', 'Mohave'),
  new IdValue('17', 'AZ', 'Navajo'),
  new IdValue('19', 'AZ', 'Pima'),
  new IdValue('21', 'AZ', 'Pinal'),
  new IdValue('23', 'AZ', 'Santa Cruz'),
  new IdValue('25', 'AZ', 'Yavapai'),
  new IdValue('27', 'AZ', 'Yuma'),
  new IdValue('1', 'CA', 'Alameda'),
  new IdValue('3', 'CA', 'Alpine'),
  new IdValue('5', 'CA', 'Amador'),
  new IdValue('7', 'CA', 'Butte'),
  new IdValue('9', 'CA', 'Calaveras'),
  new IdValue('11', 'CA', 'Colusa'),
  new IdValue('13', 'CA', 'Contra Costa'),
  new IdValue('15', 'CA', 'Del Norte'),
  new IdValue('17', 'CA', 'El Dorado'),
  new IdValue('19', 'CA', 'Fresno'),
  new IdValue('21', 'CA', 'Glenn'),
  new IdValue('23', 'CA', 'Humboldt'),
  new IdValue('25', 'CA', 'Imperial'),
  new IdValue('27', 'CA', 'Inyo'),
  new IdValue('29', 'CA', 'Kern'),
  new IdValue('31', 'CA', 'Kings'),
  new IdValue('33', 'CA', 'Lake'),
  new IdValue('35', 'CA', 'Lassen'),
  new IdValue('37', 'CA', 'Los Angeles'),
  new IdValue('39', 'CA', 'Madera'),
  new IdValue('41', 'CA', 'Marin'),
  new IdValue('43', 'CA', 'Mariposa'),
  new IdValue('45', 'CA', 'Mendocino'),
  new IdValue('47', 'CA', 'Merced'),
  new IdValue('49', 'CA', 'Modoc'),
  new IdValue('51', 'CA', 'Mono'),
  new IdValue('53', 'CA', 'Monterey'),
  new IdValue('55', 'CA', 'Napa'),
  new IdValue('57', 'CA', 'Nevada'),
  new IdValue('59', 'CA', 'Orange'),
  new IdValue('61', 'CA', 'Placer'),
  new IdValue('63', 'CA', 'Plumas'),
  new IdValue('65', 'CA', 'Riverside'),
  new IdValue('67', 'CA', 'Sacramento'),
  new IdValue('69', 'CA', 'San Benito'),
  new IdValue('71', 'CA', 'San Bernardino'),
  new IdValue('73', 'CA', 'San Diego'),
  new IdValue('75', 'CA', 'San Francisco'),
  new IdValue('77', 'CA', 'San Joaquin'),
  new IdValue('79', 'CA', 'San Luis Obispo'),
  new IdValue('81', 'CA', 'San Mateo'),
  new IdValue('83', 'CA', 'Santa Barbara'),
  new IdValue('85', 'CA', 'Santa Clara'),
  new IdValue('87', 'CA', 'Santa Cruz'),
  new IdValue('89', 'CA', 'Shasta'),
  new IdValue('91', 'CA', 'Sierra'),
  new IdValue('93', 'CA', 'Siskiyou'),
  new IdValue('95', 'CA', 'Solano'),
  new IdValue('97', 'CA', 'Sonoma'),
  new IdValue('99', 'CA', 'Stanislaus'),
  new IdValue('101', 'CA', 'Sutter'),
  new IdValue('103', 'CA', 'Tehama'),
  new IdValue('105', 'CA', 'Trinity'),
  new IdValue('107', 'CA', 'Tulare'),
  new IdValue('109', 'CA', 'Tuolumne'),
  new IdValue('111', 'CA', 'Ventura'),
  new IdValue('113', 'CA', 'Yolo'),
  new IdValue('115', 'CA', 'Yuba'),
  new IdValue('1', 'CO', 'Adams'),
  new IdValue('3', 'CO', 'Alamosa'),
  new IdValue('5', 'CO', 'Arapahoe'),
  new IdValue('7', 'CO', 'Archuleta'),
  new IdValue('9', 'CO', 'Baca'),
  new IdValue('11', 'CO', 'Bent'),
  new IdValue('13', 'CO', 'Boulder'),
  new IdValue('14', 'CO', 'Broomfield'),
  new IdValue('15', 'CO', 'Chaffee'),
  new IdValue('17', 'CO', 'Cheyenne'),
  new IdValue('19', 'CO', 'Clear Creek'),
  new IdValue('21', 'CO', 'Conejos'),
  new IdValue('23', 'CO', 'Costilla'),
  new IdValue('25', 'CO', 'Crowley'),
  new IdValue('27', 'CO', 'Custer'),
  new IdValue('29', 'CO', 'Delta'),
  new IdValue('31', 'CO', 'Denver'),
  new IdValue('33', 'CO', 'Dolores'),
  new IdValue('35', 'CO', 'Douglas'),
  new IdValue('37', 'CO', 'Eagle'),
  new IdValue('41', 'CO', 'El Paso'),
  new IdValue('39', 'CO', 'Elbert'),
  new IdValue('43', 'CO', 'Fremont'),
  new IdValue('45', 'CO', 'Garfield'),
  new IdValue('47', 'CO', 'Gilpin'),
  new IdValue('49', 'CO', 'Grand'),
  new IdValue('51', 'CO', 'Gunnison'),
  new IdValue('53', 'CO', 'Hinsdale'),
  new IdValue('55', 'CO', 'Huerfano'),
  new IdValue('57', 'CO', 'Jackson'),
  new IdValue('59', 'CO', 'Jefferson'),
  new IdValue('61', 'CO', 'Kiowa'),
  new IdValue('63', 'CO', 'Kit Carson'),
  new IdValue('67', 'CO', 'La Plata'),
  new IdValue('65', 'CO', 'Lake'),
  new IdValue('69', 'CO', 'Larimer'),
  new IdValue('71', 'CO', 'Las Animas'),
  new IdValue('73', 'CO', 'Lincoln'),
  new IdValue('75', 'CO', 'Logan'),
  new IdValue('77', 'CO', 'Mesa'),
  new IdValue('79', 'CO', 'Mineral'),
  new IdValue('81', 'CO', 'Moffat'),
  new IdValue('83', 'CO', 'Montezuma'),
  new IdValue('85', 'CO', 'Montrose'),
  new IdValue('87', 'CO', 'Morgan'),
  new IdValue('89', 'CO', 'Otero'),
  new IdValue('91', 'CO', 'Ouray'),
  new IdValue('93', 'CO', 'Park'),
  new IdValue('95', 'CO', 'Phillips'),
  new IdValue('97', 'CO', 'Pitkin'),
  new IdValue('99', 'CO', 'Prowers'),
  new IdValue('101', 'CO', 'Pueblo'),
  new IdValue('103', 'CO', 'Rio Blanco'),
  new IdValue('105', 'CO', 'Rio Grande'),
  new IdValue('107', 'CO', 'Routt'),
  new IdValue('109', 'CO', 'Saguache'),
  new IdValue('111', 'CO', 'San Juan'),
  new IdValue('113', 'CO', 'San Miguel'),
  new IdValue('115', 'CO', 'Sedgwick'),
  new IdValue('117', 'CO', 'Summit'),
  new IdValue('119', 'CO', 'Teller'),
  new IdValue('121', 'CO', 'Washington'),
  new IdValue('123', 'CO', 'Weld'),
  new IdValue('125', 'CO', 'Yuma'),
  new IdValue('1', 'CT', 'Fairfield'),
  new IdValue('3', 'CT', 'Hartford'),
  new IdValue('5', 'CT', 'Litchfield'),
  new IdValue('7', 'CT', 'Middlesex'),
  new IdValue('9', 'CT', 'New Haven'),
  new IdValue('11', 'CT', 'New London'),
  new IdValue('13', 'CT', 'Tolland'),
  new IdValue('15', 'CT', 'Windham'),
  new IdValue('1', 'DC', 'District of Columbia'),
  new IdValue('1', 'DE', 'Kent'),
  new IdValue('3', 'DE', 'New Castle'),
  new IdValue('5', 'DE', 'Sussex'),
  new IdValue('1', 'FL', 'Alachua'),
  new IdValue('3', 'FL', 'Baker'),
  new IdValue('5', 'FL', 'Bay'),
  new IdValue('7', 'FL', 'Bradford'),
  new IdValue('9', 'FL', 'Brevard'),
  new IdValue('11', 'FL', 'Broward'),
  new IdValue('13', 'FL', 'Calhoun'),
  new IdValue('15', 'FL', 'Charlotte'),
  new IdValue('17', 'FL', 'Citrus'),
  new IdValue('19', 'FL', 'Clay'),
  new IdValue('21', 'FL', 'Collier'),
  new IdValue('23', 'FL', 'Columbia'),
  new IdValue('27', 'FL', 'DeSoto'),
  new IdValue('29', 'FL', 'Dixie'),
  new IdValue('31', 'FL', 'Duval'),
  new IdValue('33', 'FL', 'Escambia'),
  new IdValue('35', 'FL', 'Flagler'),
  new IdValue('37', 'FL', 'Franklin'),
  new IdValue('39', 'FL', 'Gadsden'),
  new IdValue('41', 'FL', 'Gilchrist'),
  new IdValue('43', 'FL', 'Glades'),
  new IdValue('45', 'FL', 'Gulf'),
  new IdValue('47', 'FL', 'Hamilton'),
  new IdValue('49', 'FL', 'Hardee'),
  new IdValue('51', 'FL', 'Hendry'),
  new IdValue('53', 'FL', 'Hernando'),
  new IdValue('55', 'FL', 'Highlands'),
  new IdValue('57', 'FL', 'Hillsborough'),
  new IdValue('59', 'FL', 'Holmes'),
  new IdValue('61', 'FL', 'Indian River'),
  new IdValue('63', 'FL', 'Jackson'),
  new IdValue('65', 'FL', 'Jefferson'),
  new IdValue('67', 'FL', 'Lafayette'),
  new IdValue('69', 'FL', 'Lake'),
  new IdValue('71', 'FL', 'Lee'),
  new IdValue('73', 'FL', 'Leon'),
  new IdValue('75', 'FL', 'Levy'),
  new IdValue('77', 'FL', 'Liberty'),
  new IdValue('79', 'FL', 'Madison'),
  new IdValue('81', 'FL', 'Manatee'),
  new IdValue('83', 'FL', 'Marion'),
  new IdValue('85', 'FL', 'Martin'),
  new IdValue('86', 'FL', 'Miami-Dade'),
  new IdValue('87', 'FL', 'Monroe'),
  new IdValue('89', 'FL', 'Nassau'),
  new IdValue('91', 'FL', 'Okaloosa'),
  new IdValue('93', 'FL', 'Okeechobee'),
  new IdValue('95', 'FL', 'Orange'),
  new IdValue('97', 'FL', 'Osceola'),
  new IdValue('99', 'FL', 'Palm Beach'),
  new IdValue('101', 'FL', 'Pasco'),
  new IdValue('103', 'FL', 'Pinellas'),
  new IdValue('105', 'FL', 'Polk'),
  new IdValue('107', 'FL', 'Putnam'),
  new IdValue('113', 'FL', 'Santa Rosa'),
  new IdValue('115', 'FL', 'Sarasota'),
  new IdValue('117', 'FL', 'Seminole'),
  new IdValue('109', 'FL', 'St. Johns'),
  new IdValue('111', 'FL', 'St. Lucie'),
  new IdValue('119', 'FL', 'Sumter'),
  new IdValue('121', 'FL', 'Suwannee'),
  new IdValue('123', 'FL', 'Taylor'),
  new IdValue('125', 'FL', 'Union'),
  new IdValue('127', 'FL', 'Volusia'),
  new IdValue('129', 'FL', 'Wakulla'),
  new IdValue('131', 'FL', 'Walton'),
  new IdValue('133', 'FL', 'Washington'),
  new IdValue('1', 'GA', 'Appling'),
  new IdValue('3', 'GA', 'Atkinson'),
  new IdValue('5', 'GA', 'Bacon'),
  new IdValue('7', 'GA', 'Baker'),
  new IdValue('9', 'GA', 'Baldwin'),
  new IdValue('11', 'GA', 'Banks'),
  new IdValue('13', 'GA', 'Barrow'),
  new IdValue('15', 'GA', 'Bartow'),
  new IdValue('17', 'GA', 'Ben Hill'),
  new IdValue('19', 'GA', 'Berrien'),
  new IdValue('21', 'GA', 'Bibb'),
  new IdValue('23', 'GA', 'Bleckley'),
  new IdValue('25', 'GA', 'Brantley'),
  new IdValue('27', 'GA', 'Brooks'),
  new IdValue('29', 'GA', 'Bryan'),
  new IdValue('31', 'GA', 'Bulloch'),
  new IdValue('33', 'GA', 'Burke'),
  new IdValue('35', 'GA', 'Butts'),
  new IdValue('37', 'GA', 'Calhoun'),
  new IdValue('39', 'GA', 'Camden'),
  new IdValue('43', 'GA', 'Candler'),
  new IdValue('45', 'GA', 'Carroll'),
  new IdValue('47', 'GA', 'Catoosa'),
  new IdValue('49', 'GA', 'Charlton'),
  new IdValue('51', 'GA', 'Chatham'),
  new IdValue('53', 'GA', 'Chattahoochee'),
  new IdValue('55', 'GA', 'Chattooga'),
  new IdValue('57', 'GA', 'Cherokee'),
  new IdValue('59', 'GA', 'Clarke'),
  new IdValue('61', 'GA', 'Clay'),
  new IdValue('63', 'GA', 'Clayton'),
  new IdValue('65', 'GA', 'Clinch'),
  new IdValue('67', 'GA', 'Cobb'),
  new IdValue('69', 'GA', 'Coffee'),
  new IdValue('71', 'GA', 'Colquitt'),
  new IdValue('73', 'GA', 'Columbia'),
  new IdValue('75', 'GA', 'Cook'),
  new IdValue('77', 'GA', 'Coweta'),
  new IdValue('79', 'GA', 'Crawford'),
  new IdValue('81', 'GA', 'Crisp'),
  new IdValue('83', 'GA', 'Dade'),
  new IdValue('85', 'GA', 'Dawson'),
  new IdValue('87', 'GA', 'Decatur'),
  new IdValue('89', 'GA', 'DeKalb'),
  new IdValue('91', 'GA', 'Dodge'),
  new IdValue('93', 'GA', 'Dooly'),
  new IdValue('95', 'GA', 'Dougherty'),
  new IdValue('97', 'GA', 'Douglas'),
  new IdValue('99', 'GA', 'Early'),
  new IdValue('101', 'GA', 'Echols'),
  new IdValue('103', 'GA', 'Effingham'),
  new IdValue('105', 'GA', 'Elbert'),
  new IdValue('107', 'GA', 'Emanuel'),
  new IdValue('109', 'GA', 'Evans'),
  new IdValue('111', 'GA', 'Fannin'),
  new IdValue('113', 'GA', 'Fayette'),
  new IdValue('115', 'GA', 'Floyd'),
  new IdValue('117', 'GA', 'Forsyth'),
  new IdValue('119', 'GA', 'Franklin'),
  new IdValue('121', 'GA', 'Fulton'),
  new IdValue('123', 'GA', 'Gilmer'),
  new IdValue('125', 'GA', 'Glascock'),
  new IdValue('127', 'GA', 'Glynn'),
  new IdValue('129', 'GA', 'Gordon'),
  new IdValue('131', 'GA', 'Grady'),
  new IdValue('133', 'GA', 'Greene'),
  new IdValue('135', 'GA', 'Gwinnett'),
  new IdValue('137', 'GA', 'Habersham'),
  new IdValue('139', 'GA', 'Hall'),
  new IdValue('141', 'GA', 'Hancock'),
  new IdValue('143', 'GA', 'Haralson'),
  new IdValue('145', 'GA', 'Harris'),
  new IdValue('147', 'GA', 'Hart'),
  new IdValue('149', 'GA', 'Heard'),
  new IdValue('151', 'GA', 'Henry'),
  new IdValue('153', 'GA', 'Houston'),
  new IdValue('155', 'GA', 'Irwin'),
  new IdValue('157', 'GA', 'Jackson'),
  new IdValue('159', 'GA', 'Jasper'),
  new IdValue('161', 'GA', 'Jeff Davis'),
  new IdValue('163', 'GA', 'Jefferson'),
  new IdValue('165', 'GA', 'Jenkins'),
  new IdValue('167', 'GA', 'Johnson'),
  new IdValue('169', 'GA', 'Jones'),
  new IdValue('171', 'GA', 'Lamar'),
  new IdValue('173', 'GA', 'Lanier'),
  new IdValue('175', 'GA', 'Laurens'),
  new IdValue('177', 'GA', 'Lee'),
  new IdValue('179', 'GA', 'Liberty'),
  new IdValue('181', 'GA', 'Lincoln'),
  new IdValue('183', 'GA', 'Long'),
  new IdValue('185', 'GA', 'Lowndes'),
  new IdValue('187', 'GA', 'Lumpkin'),
  new IdValue('193', 'GA', 'Macon'),
  new IdValue('195', 'GA', 'Madison'),
  new IdValue('197', 'GA', 'Marion'),
  new IdValue('189', 'GA', 'McDuffie'),
  new IdValue('191', 'GA', 'McIntosh'),
  new IdValue('199', 'GA', 'Meriwether'),
  new IdValue('201', 'GA', 'Miller'),
  new IdValue('205', 'GA', 'Mitchell'),
  new IdValue('207', 'GA', 'Monroe'),
  new IdValue('209', 'GA', 'Montgomery'),
  new IdValue('211', 'GA', 'Morgan'),
  new IdValue('213', 'GA', 'Murray'),
  new IdValue('215', 'GA', 'Muscogee'),
  new IdValue('217', 'GA', 'Newton'),
  new IdValue('219', 'GA', 'Oconee'),
  new IdValue('221', 'GA', 'Oglethorpe'),
  new IdValue('223', 'GA', 'Paulding'),
  new IdValue('225', 'GA', 'Peach'),
  new IdValue('227', 'GA', 'Pickens'),
  new IdValue('229', 'GA', 'Pierce'),
  new IdValue('231', 'GA', 'Pike'),
  new IdValue('233', 'GA', 'Polk'),
  new IdValue('235', 'GA', 'Pulaski'),
  new IdValue('237', 'GA', 'Putnam'),
  new IdValue('239', 'GA', 'Quitman'),
  new IdValue('241', 'GA', 'Rabun'),
  new IdValue('243', 'GA', 'Randolph'),
  new IdValue('245', 'GA', 'Richmond'),
  new IdValue('247', 'GA', 'Rockdale'),
  new IdValue('249', 'GA', 'Schley'),
  new IdValue('251', 'GA', 'Screven'),
  new IdValue('253', 'GA', 'Seminole'),
  new IdValue('255', 'GA', 'Spalding'),
  new IdValue('257', 'GA', 'Stephens'),
  new IdValue('259', 'GA', 'Stewart'),
  new IdValue('261', 'GA', 'Sumter'),
  new IdValue('263', 'GA', 'Talbot'),
  new IdValue('265', 'GA', 'Taliaferro'),
  new IdValue('267', 'GA', 'Tattnall'),
  new IdValue('269', 'GA', 'Taylor'),
  new IdValue('271', 'GA', 'Telfair'),
  new IdValue('273', 'GA', 'Terrell'),
  new IdValue('275', 'GA', 'Thomas'),
  new IdValue('277', 'GA', 'Tift'),
  new IdValue('279', 'GA', 'Toombs'),
  new IdValue('281', 'GA', 'Towns'),
  new IdValue('283', 'GA', 'Treutlen'),
  new IdValue('285', 'GA', 'Troup'),
  new IdValue('287', 'GA', 'Turner'),
  new IdValue('289', 'GA', 'Twiggs'),
  new IdValue('291', 'GA', 'Union'),
  new IdValue('293', 'GA', 'Upson'),
  new IdValue('295', 'GA', 'Walker'),
  new IdValue('297', 'GA', 'Walton'),
  new IdValue('299', 'GA', 'Ware'),
  new IdValue('301', 'GA', 'Warren'),
  new IdValue('303', 'GA', 'Washington'),
  new IdValue('305', 'GA', 'Wayne'),
  new IdValue('307', 'GA', 'Webster'),
  new IdValue('309', 'GA', 'Wheeler'),
  new IdValue('311', 'GA', 'White'),
  new IdValue('313', 'GA', 'Whitfield'),
  new IdValue('315', 'GA', 'Wilcox'),
  new IdValue('317', 'GA', 'Wilkes'),
  new IdValue('319', 'GA', 'Wilkinson'),
  new IdValue('321', 'GA', 'Worth'),
  new IdValue('10', 'GU', 'Guam'),
  new IdValue('1', 'HI', 'Hawaii'),
  new IdValue('3', 'HI', 'Honolulu'),
  new IdValue('5', 'HI', 'Kalawao'),
  new IdValue('7', 'HI', 'Kauai'),
  new IdValue('9', 'HI', 'Maui'),
  new IdValue('1', 'IA', 'Adair'),
  new IdValue('3', 'IA', 'Adams'),
  new IdValue('5', 'IA', 'Allamakee'),
  new IdValue('7', 'IA', 'Appanoose'),
  new IdValue('9', 'IA', 'Audubon'),
  new IdValue('11', 'IA', 'Benton'),
  new IdValue('13', 'IA', 'Black Hawk'),
  new IdValue('15', 'IA', 'Boone'),
  new IdValue('17', 'IA', 'Bremer'),
  new IdValue('19', 'IA', 'Buchanan'),
  new IdValue('21', 'IA', 'Buena Vista'),
  new IdValue('23', 'IA', 'Butler'),
  new IdValue('25', 'IA', 'Calhoun'),
  new IdValue('27', 'IA', 'Carroll'),
  new IdValue('29', 'IA', 'Cass'),
  new IdValue('31', 'IA', 'Cedar'),
  new IdValue('33', 'IA', 'Cerro Gordo'),
  new IdValue('35', 'IA', 'Cherokee'),
  new IdValue('37', 'IA', 'Chickasaw'),
  new IdValue('39', 'IA', 'Clarke'),
  new IdValue('41', 'IA', 'Clay'),
  new IdValue('43', 'IA', 'Clayton'),
  new IdValue('45', 'IA', 'Clinton'),
  new IdValue('47', 'IA', 'Crawford'),
  new IdValue('49', 'IA', 'Dallas'),
  new IdValue('51', 'IA', 'Davis'),
  new IdValue('53', 'IA', 'Decatur'),
  new IdValue('55', 'IA', 'Delaware'),
  new IdValue('57', 'IA', 'Des Moines'),
  new IdValue('59', 'IA', 'Dickinson'),
  new IdValue('61', 'IA', 'Dubuque'),
  new IdValue('63', 'IA', 'Emmet'),
  new IdValue('65', 'IA', 'Fayette'),
  new IdValue('67', 'IA', 'Floyd'),
  new IdValue('69', 'IA', 'Franklin'),
  new IdValue('71', 'IA', 'Fremont'),
  new IdValue('73', 'IA', 'Greene'),
  new IdValue('75', 'IA', 'Grundy'),
  new IdValue('77', 'IA', 'Guthrie'),
  new IdValue('79', 'IA', 'Hamilton'),
  new IdValue('81', 'IA', 'Hancock'),
  new IdValue('83', 'IA', 'Hardin'),
  new IdValue('85', 'IA', 'Harrison'),
  new IdValue('87', 'IA', 'Henry'),
  new IdValue('89', 'IA', 'Howard'),
  new IdValue('91', 'IA', 'Humboldt'),
  new IdValue('93', 'IA', 'Ida'),
  new IdValue('95', 'IA', 'Iowa'),
  new IdValue('97', 'IA', 'Jackson'),
  new IdValue('99', 'IA', 'Jasper'),
  new IdValue('101', 'IA', 'Jefferson'),
  new IdValue('103', 'IA', 'Johnson'),
  new IdValue('105', 'IA', 'Jones'),
  new IdValue('107', 'IA', 'Keokuk'),
  new IdValue('109', 'IA', 'Kossuth'),
  new IdValue('111', 'IA', 'Lee'),
  new IdValue('113', 'IA', 'Linn'),
  new IdValue('115', 'IA', 'Louisa'),
  new IdValue('117', 'IA', 'Lucas'),
  new IdValue('119', 'IA', 'Lyon'),
  new IdValue('121', 'IA', 'Madison'),
  new IdValue('123', 'IA', 'Mahaska'),
  new IdValue('125', 'IA', 'Marion'),
  new IdValue('127', 'IA', 'Marshall'),
  new IdValue('129', 'IA', 'Mills'),
  new IdValue('131', 'IA', 'Mitchell'),
  new IdValue('133', 'IA', 'Monona'),
  new IdValue('135', 'IA', 'Monroe'),
  new IdValue('137', 'IA', 'Montgomery'),
  new IdValue('139', 'IA', 'Muscatine'),
  // eslint-disable-next-line quotes
  new IdValue('141', 'IA', "O'Brien"),
  new IdValue('143', 'IA', 'Osceola'),
  new IdValue('145', 'IA', 'Page'),
  new IdValue('147', 'IA', 'Palo Alto'),
  new IdValue('149', 'IA', 'Plymouth'),
  new IdValue('151', 'IA', 'Pocahontas'),
  new IdValue('153', 'IA', 'Polk'),
  new IdValue('155', 'IA', 'Pottawattamie'),
  new IdValue('157', 'IA', 'Poweshiek'),
  new IdValue('159', 'IA', 'Ringgold'),
  new IdValue('161', 'IA', 'Sac'),
  new IdValue('163', 'IA', 'Scott'),
  new IdValue('165', 'IA', 'Shelby'),
  new IdValue('167', 'IA', 'Sioux'),
  new IdValue('169', 'IA', 'Story'),
  new IdValue('171', 'IA', 'Tama'),
  new IdValue('173', 'IA', 'Taylor'),
  new IdValue('175', 'IA', 'Union'),
  new IdValue('177', 'IA', 'Van Buren'),
  new IdValue('179', 'IA', 'Wapello'),
  new IdValue('181', 'IA', 'Warren'),
  new IdValue('183', 'IA', 'Washington'),
  new IdValue('185', 'IA', 'Wayne'),
  new IdValue('187', 'IA', 'Webster'),
  new IdValue('189', 'IA', 'Winnebago'),
  new IdValue('191', 'IA', 'Winneshiek'),
  new IdValue('193', 'IA', 'Woodbury'),
  new IdValue('195', 'IA', 'Worth'),
  new IdValue('197', 'IA', 'Wright'),
  new IdValue('1', 'ID', 'Ada'),
  new IdValue('3', 'ID', 'Adams'),
  new IdValue('5', 'ID', 'Bannock'),
  new IdValue('7', 'ID', 'Bear Lake'),
  new IdValue('9', 'ID', 'Benewah'),
  new IdValue('11', 'ID', 'Bingham'),
  new IdValue('13', 'ID', 'Blaine'),
  new IdValue('15', 'ID', 'Boise'),
  new IdValue('17', 'ID', 'Bonner'),
  new IdValue('19', 'ID', 'Bonneville'),
  new IdValue('21', 'ID', 'Boundary'),
  new IdValue('23', 'ID', 'Butte'),
  new IdValue('25', 'ID', 'Camas'),
  new IdValue('27', 'ID', 'Canyon'),
  new IdValue('29', 'ID', 'Caribou'),
  new IdValue('31', 'ID', 'Cassia'),
  new IdValue('33', 'ID', 'Clark'),
  new IdValue('35', 'ID', 'Clearwater'),
  new IdValue('37', 'ID', 'Custer'),
  new IdValue('39', 'ID', 'Elmore'),
  new IdValue('41', 'ID', 'Franklin'),
  new IdValue('43', 'ID', 'Fremont'),
  new IdValue('45', 'ID', 'Gem'),
  new IdValue('47', 'ID', 'Gooding'),
  new IdValue('49', 'ID', 'Idaho'),
  new IdValue('51', 'ID', 'Jefferson'),
  new IdValue('53', 'ID', 'Jerome'),
  new IdValue('55', 'ID', 'Kootenai'),
  new IdValue('57', 'ID', 'Latah'),
  new IdValue('59', 'ID', 'Lemhi'),
  new IdValue('61', 'ID', 'Lewis'),
  new IdValue('63', 'ID', 'Lincoln'),
  new IdValue('65', 'ID', 'Madison'),
  new IdValue('67', 'ID', 'Minidoka'),
  new IdValue('69', 'ID', 'Nez Perce'),
  new IdValue('71', 'ID', 'Oneida'),
  new IdValue('73', 'ID', 'Owyhee'),
  new IdValue('75', 'ID', 'Payette'),
  new IdValue('77', 'ID', 'Power'),
  new IdValue('79', 'ID', 'Shoshone'),
  new IdValue('81', 'ID', 'Teton'),
  new IdValue('83', 'ID', 'Twin Falls'),
  new IdValue('85', 'ID', 'Valley'),
  new IdValue('87', 'ID', 'Washington'),
  new IdValue('1', 'IL', 'Adams'),
  new IdValue('3', 'IL', 'Alexander'),
  new IdValue('5', 'IL', 'Bond'),
  new IdValue('7', 'IL', 'Boone'),
  new IdValue('9', 'IL', 'Brown'),
  new IdValue('11', 'IL', 'Bureau'),
  new IdValue('13', 'IL', 'Calhoun'),
  new IdValue('15', 'IL', 'Carroll'),
  new IdValue('17', 'IL', 'Cass'),
  new IdValue('19', 'IL', 'Champaign'),
  new IdValue('21', 'IL', 'Christian'),
  new IdValue('23', 'IL', 'Clark'),
  new IdValue('25', 'IL', 'Clay'),
  new IdValue('27', 'IL', 'Clinton'),
  new IdValue('29', 'IL', 'Coles'),
  new IdValue('31', 'IL', 'Cook'),
  new IdValue('33', 'IL', 'Crawford'),
  new IdValue('35', 'IL', 'Cumberland'),
  new IdValue('39', 'IL', 'De Witt'),
  new IdValue('37', 'IL', 'Dekalb'),
  new IdValue('41', 'IL', 'Douglas'),
  new IdValue('43', 'IL', 'DuPage'),
  new IdValue('45', 'IL', 'Edgar'),
  new IdValue('47', 'IL', 'Edwards'),
  new IdValue('49', 'IL', 'Effingham'),
  new IdValue('51', 'IL', 'Fayette'),
  new IdValue('53', 'IL', 'Ford'),
  new IdValue('55', 'IL', 'Franklin'),
  new IdValue('57', 'IL', 'Fulton'),
  new IdValue('59', 'IL', 'Gallatin'),
  new IdValue('61', 'IL', 'Greene'),
  new IdValue('63', 'IL', 'Grundy'),
  new IdValue('65', 'IL', 'Hamilton'),
  new IdValue('67', 'IL', 'Hancock'),
  new IdValue('69', 'IL', 'Hardin'),
  new IdValue('71', 'IL', 'Henderson'),
  new IdValue('73', 'IL', 'Henry'),
  new IdValue('75', 'IL', 'Iroquois'),
  new IdValue('77', 'IL', 'Jackson'),
  new IdValue('79', 'IL', 'Jasper'),
  new IdValue('81', 'IL', 'Jefferson'),
  new IdValue('83', 'IL', 'Jersey'),
  new IdValue('85', 'IL', 'Jo Daviess'),
  new IdValue('87', 'IL', 'Johnson'),
  new IdValue('89', 'IL', 'Kane'),
  new IdValue('91', 'IL', 'Kankakee'),
  new IdValue('93', 'IL', 'Kendall'),
  new IdValue('95', 'IL', 'Knox'),
  new IdValue('97', 'IL', 'Lake'),
  new IdValue('99', 'IL', 'LaSalle'),
  new IdValue('101', 'IL', 'Lawrence'),
  new IdValue('103', 'IL', 'Lee'),
  new IdValue('105', 'IL', 'Livingston'),
  new IdValue('107', 'IL', 'Logan'),
  new IdValue('115', 'IL', 'Macon'),
  new IdValue('117', 'IL', 'Macoupin'),
  new IdValue('119', 'IL', 'Madison'),
  new IdValue('121', 'IL', 'Marion'),
  new IdValue('123', 'IL', 'Marshall'),
  new IdValue('125', 'IL', 'Mason'),
  new IdValue('127', 'IL', 'Massac'),
  new IdValue('109', 'IL', 'McDonough'),
  new IdValue('111', 'IL', 'McHenry'),
  new IdValue('113', 'IL', 'McLean'),
  new IdValue('129', 'IL', 'Menard'),
  new IdValue('131', 'IL', 'Mercer'),
  new IdValue('133', 'IL', 'Monroe'),
  new IdValue('135', 'IL', 'Montgomery'),
  new IdValue('137', 'IL', 'Morgan'),
  new IdValue('139', 'IL', 'Moultrie'),
  new IdValue('141', 'IL', 'Ogle'),
  new IdValue('143', 'IL', 'Peoria'),
  new IdValue('145', 'IL', 'Perry'),
  new IdValue('147', 'IL', 'Piatt'),
  new IdValue('149', 'IL', 'Pike'),
  new IdValue('151', 'IL', 'Pope'),
  new IdValue('153', 'IL', 'Pulaski'),
  new IdValue('155', 'IL', 'Putnam'),
  new IdValue('157', 'IL', 'Randolph'),
  new IdValue('159', 'IL', 'Richland'),
  new IdValue('161', 'IL', 'Rock Island'),
  new IdValue('165', 'IL', 'Saline'),
  new IdValue('167', 'IL', 'Sangamon'),
  new IdValue('169', 'IL', 'Schuyler'),
  new IdValue('171', 'IL', 'Scott'),
  new IdValue('173', 'IL', 'Shelby'),
  new IdValue('163', 'IL', 'St. Clair'),
  new IdValue('175', 'IL', 'Stark'),
  new IdValue('177', 'IL', 'Stephenson'),
  new IdValue('179', 'IL', 'Tazewell'),
  new IdValue('181', 'IL', 'Union'),
  new IdValue('183', 'IL', 'Vermilion'),
  new IdValue('185', 'IL', 'Wabash'),
  new IdValue('187', 'IL', 'Warren'),
  new IdValue('189', 'IL', 'Washington'),
  new IdValue('191', 'IL', 'Wayne'),
  new IdValue('193', 'IL', 'White'),
  new IdValue('195', 'IL', 'Whiteside'),
  new IdValue('197', 'IL', 'Will'),
  new IdValue('199', 'IL', 'Williamson'),
  new IdValue('201', 'IL', 'Winnebago'),
  new IdValue('203', 'IL', 'Woodford'),
  new IdValue('1', 'IN', 'Adams'),
  new IdValue('3', 'IN', 'Allen'),
  new IdValue('5', 'IN', 'Bartholomew'),
  new IdValue('7', 'IN', 'Benton'),
  new IdValue('9', 'IN', 'Blackford'),
  new IdValue('11', 'IN', 'Boone'),
  new IdValue('13', 'IN', 'Brown'),
  new IdValue('15', 'IN', 'Carroll'),
  new IdValue('17', 'IN', 'Cass'),
  new IdValue('19', 'IN', 'Clark'),
  new IdValue('21', 'IN', 'Clay'),
  new IdValue('23', 'IN', 'Clinton'),
  new IdValue('25', 'IN', 'Crawford'),
  new IdValue('27', 'IN', 'Daviess'),
  new IdValue('29', 'IN', 'Dearborn'),
  new IdValue('31', 'IN', 'Decatur'),
  new IdValue('33', 'IN', 'DeKalb'),
  new IdValue('35', 'IN', 'Delaware'),
  new IdValue('37', 'IN', 'Dubois'),
  new IdValue('39', 'IN', 'Elkhart'),
  new IdValue('41', 'IN', 'Fayette'),
  new IdValue('43', 'IN', 'Floyd'),
  new IdValue('45', 'IN', 'Fountain'),
  new IdValue('47', 'IN', 'Franklin'),
  new IdValue('49', 'IN', 'Fulton'),
  new IdValue('51', 'IN', 'Gibson'),
  new IdValue('53', 'IN', 'Grant'),
  new IdValue('55', 'IN', 'Greene'),
  new IdValue('57', 'IN', 'Hamilton'),
  new IdValue('59', 'IN', 'Hancock'),
  new IdValue('61', 'IN', 'Harrison'),
  new IdValue('63', 'IN', 'Hendricks'),
  new IdValue('65', 'IN', 'Henry'),
  new IdValue('67', 'IN', 'Howard'),
  new IdValue('69', 'IN', 'Huntington'),
  new IdValue('71', 'IN', 'Jackson'),
  new IdValue('73', 'IN', 'Jasper'),
  new IdValue('75', 'IN', 'Jay'),
  new IdValue('77', 'IN', 'Jefferson'),
  new IdValue('79', 'IN', 'Jennings'),
  new IdValue('81', 'IN', 'Johnson'),
  new IdValue('83', 'IN', 'Knox'),
  new IdValue('85', 'IN', 'Kosciusko'),
  new IdValue('87', 'IN', 'Lagrange'),
  new IdValue('89', 'IN', 'Lake'),
  new IdValue('91', 'IN', 'LaPorte'),
  new IdValue('93', 'IN', 'Lawrence'),
  new IdValue('95', 'IN', 'Madison'),
  new IdValue('97', 'IN', 'Marion'),
  new IdValue('99', 'IN', 'Marshall'),
  new IdValue('101', 'IN', 'Martin'),
  new IdValue('103', 'IN', 'Miami'),
  new IdValue('105', 'IN', 'Monroe'),
  new IdValue('107', 'IN', 'Montgomery'),
  new IdValue('109', 'IN', 'Morgan'),
  new IdValue('111', 'IN', 'Newton'),
  new IdValue('113', 'IN', 'Noble'),
  new IdValue('115', 'IN', 'Ohio'),
  new IdValue('117', 'IN', 'Orange'),
  new IdValue('119', 'IN', 'Owen'),
  new IdValue('121', 'IN', 'Parke'),
  new IdValue('123', 'IN', 'Perry'),
  new IdValue('125', 'IN', 'Pike'),
  new IdValue('127', 'IN', 'Porter'),
  new IdValue('129', 'IN', 'Posey'),
  new IdValue('131', 'IN', 'Pulaski'),
  new IdValue('133', 'IN', 'Putnam'),
  new IdValue('135', 'IN', 'Randolph'),
  new IdValue('137', 'IN', 'Ripley'),
  new IdValue('139', 'IN', 'Rush'),
  new IdValue('143', 'IN', 'Scott'),
  new IdValue('145', 'IN', 'Shelby'),
  new IdValue('147', 'IN', 'Spencer'),
  new IdValue('141', 'IN', 'St. Joseph'),
  new IdValue('149', 'IN', 'Starke'),
  new IdValue('151', 'IN', 'Steuben'),
  new IdValue('153', 'IN', 'Sullivan'),
  new IdValue('155', 'IN', 'Switzerland'),
  new IdValue('157', 'IN', 'Tippecanoe'),
  new IdValue('159', 'IN', 'Tipton'),
  new IdValue('161', 'IN', 'Union'),
  new IdValue('163', 'IN', 'Vanderburgh'),
  new IdValue('165', 'IN', 'Vermillion'),
  new IdValue('167', 'IN', 'Vigo'),
  new IdValue('169', 'IN', 'Wabash'),
  new IdValue('171', 'IN', 'Warren'),
  new IdValue('173', 'IN', 'Warrick'),
  new IdValue('175', 'IN', 'Washington'),
  new IdValue('177', 'IN', 'Wayne'),
  new IdValue('179', 'IN', 'Wells'),
  new IdValue('181', 'IN', 'White'),
  new IdValue('183', 'IN', 'Whitley'),
  new IdValue('1', 'KS', 'Allen'),
  new IdValue('3', 'KS', 'Anderson'),
  new IdValue('5', 'KS', 'Atchison'),
  new IdValue('7', 'KS', 'Barber'),
  new IdValue('9', 'KS', 'Barton'),
  new IdValue('11', 'KS', 'Bourbon'),
  new IdValue('13', 'KS', 'Brown'),
  new IdValue('15', 'KS', 'Butler'),
  new IdValue('17', 'KS', 'Chase'),
  new IdValue('19', 'KS', 'Chautauqua'),
  new IdValue('21', 'KS', 'Cherokee'),
  new IdValue('23', 'KS', 'Cheyenne'),
  new IdValue('25', 'KS', 'Clark'),
  new IdValue('27', 'KS', 'Clay'),
  new IdValue('29', 'KS', 'Cloud'),
  new IdValue('31', 'KS', 'Coffey'),
  new IdValue('33', 'KS', 'Comanche'),
  new IdValue('35', 'KS', 'Cowley'),
  new IdValue('37', 'KS', 'Crawford'),
  new IdValue('39', 'KS', 'Decatur'),
  new IdValue('41', 'KS', 'Dickinson'),
  new IdValue('43', 'KS', 'Doniphan'),
  new IdValue('45', 'KS', 'Douglas'),
  new IdValue('47', 'KS', 'Edwards'),
  new IdValue('49', 'KS', 'Elk'),
  new IdValue('51', 'KS', 'Ellis'),
  new IdValue('53', 'KS', 'Ellsworth'),
  new IdValue('55', 'KS', 'Finney'),
  new IdValue('57', 'KS', 'Ford'),
  new IdValue('59', 'KS', 'Franklin'),
  new IdValue('61', 'KS', 'Geary'),
  new IdValue('63', 'KS', 'Gove'),
  new IdValue('65', 'KS', 'Graham'),
  new IdValue('67', 'KS', 'Grant'),
  new IdValue('69', 'KS', 'Gray'),
  new IdValue('71', 'KS', 'Greeley'),
  new IdValue('73', 'KS', 'Greenwood'),
  new IdValue('75', 'KS', 'Hamilton'),
  new IdValue('77', 'KS', 'Harper'),
  new IdValue('79', 'KS', 'Harvey'),
  new IdValue('81', 'KS', 'Haskell'),
  new IdValue('83', 'KS', 'Hodgeman'),
  new IdValue('85', 'KS', 'Jackson'),
  new IdValue('87', 'KS', 'Jefferson'),
  new IdValue('89', 'KS', 'Jewell'),
  new IdValue('91', 'KS', 'Johnson'),
  new IdValue('93', 'KS', 'Kearny'),
  new IdValue('95', 'KS', 'Kingman'),
  new IdValue('97', 'KS', 'Kiowa'),
  new IdValue('99', 'KS', 'Labette'),
  new IdValue('101', 'KS', 'Lane'),
  new IdValue('103', 'KS', 'Leavenworth'),
  new IdValue('105', 'KS', 'Lincoln'),
  new IdValue('107', 'KS', 'Linn'),
  new IdValue('109', 'KS', 'Logan'),
  new IdValue('111', 'KS', 'Lyon'),
  new IdValue('115', 'KS', 'Marion'),
  new IdValue('117', 'KS', 'Marshall'),
  new IdValue('113', 'KS', 'McPherson'),
  new IdValue('119', 'KS', 'Meade'),
  new IdValue('121', 'KS', 'Miami'),
  new IdValue('123', 'KS', 'Mitchell'),
  new IdValue('125', 'KS', 'Montgomery'),
  new IdValue('127', 'KS', 'Morris'),
  new IdValue('129', 'KS', 'Morton'),
  new IdValue('131', 'KS', 'Nemaha'),
  new IdValue('133', 'KS', 'Neosho'),
  new IdValue('135', 'KS', 'Ness'),
  new IdValue('137', 'KS', 'Norton'),
  new IdValue('139', 'KS', 'Osage'),
  new IdValue('141', 'KS', 'Osborne'),
  new IdValue('143', 'KS', 'Ottawa'),
  new IdValue('145', 'KS', 'Pawnee'),
  new IdValue('147', 'KS', 'Phillips'),
  new IdValue('149', 'KS', 'Pottawatomie'),
  new IdValue('151', 'KS', 'Pratt'),
  new IdValue('153', 'KS', 'Rawlins'),
  new IdValue('155', 'KS', 'Reno'),
  new IdValue('157', 'KS', 'Republic'),
  new IdValue('159', 'KS', 'Rice'),
  new IdValue('161', 'KS', 'Riley'),
  new IdValue('163', 'KS', 'Rooks'),
  new IdValue('165', 'KS', 'Rush'),
  new IdValue('167', 'KS', 'Russell'),
  new IdValue('169', 'KS', 'Saline'),
  new IdValue('171', 'KS', 'Scott'),
  new IdValue('173', 'KS', 'Sedgwick'),
  new IdValue('175', 'KS', 'Seward'),
  new IdValue('177', 'KS', 'Shawnee'),
  new IdValue('179', 'KS', 'Sheridan'),
  new IdValue('181', 'KS', 'Sherman'),
  new IdValue('183', 'KS', 'Smith'),
  new IdValue('185', 'KS', 'Stafford'),
  new IdValue('187', 'KS', 'Stanton'),
  new IdValue('189', 'KS', 'Stevens'),
  new IdValue('191', 'KS', 'Sumner'),
  new IdValue('193', 'KS', 'Thomas'),
  new IdValue('195', 'KS', 'Trego'),
  new IdValue('197', 'KS', 'Wabaunsee'),
  new IdValue('199', 'KS', 'Wallace'),
  new IdValue('201', 'KS', 'Washington'),
  new IdValue('203', 'KS', 'Wichita'),
  new IdValue('205', 'KS', 'Wilson'),
  new IdValue('207', 'KS', 'Woodson'),
  new IdValue('209', 'KS', 'Wyandotte'),
  new IdValue('1', 'KY', 'Adair'),
  new IdValue('3', 'KY', 'Allen'),
  new IdValue('5', 'KY', 'Anderson'),
  new IdValue('7', 'KY', 'Ballard'),
  new IdValue('9', 'KY', 'Barren'),
  new IdValue('11', 'KY', 'Bath'),
  new IdValue('13', 'KY', 'Bell'),
  new IdValue('15', 'KY', 'Boone'),
  new IdValue('17', 'KY', 'Bourbon'),
  new IdValue('19', 'KY', 'Boyd'),
  new IdValue('21', 'KY', 'Boyle'),
  new IdValue('23', 'KY', 'Bracken'),
  new IdValue('25', 'KY', 'Breathitt'),
  new IdValue('27', 'KY', 'Breckinridge'),
  new IdValue('29', 'KY', 'Bullitt'),
  new IdValue('31', 'KY', 'Butler'),
  new IdValue('33', 'KY', 'Caldwell'),
  new IdValue('35', 'KY', 'Calloway'),
  new IdValue('37', 'KY', 'Campbell'),
  new IdValue('39', 'KY', 'Carlisle'),
  new IdValue('41', 'KY', 'Carroll'),
  new IdValue('43', 'KY', 'Carter'),
  new IdValue('45', 'KY', 'Casey'),
  new IdValue('47', 'KY', 'Christian'),
  new IdValue('49', 'KY', 'Clark'),
  new IdValue('51', 'KY', 'Clay'),
  new IdValue('53', 'KY', 'Clinton'),
  new IdValue('55', 'KY', 'Crittenden'),
  new IdValue('57', 'KY', 'Cumberland'),
  new IdValue('59', 'KY', 'Daviess'),
  new IdValue('61', 'KY', 'Edmonson'),
  new IdValue('63', 'KY', 'Elliott'),
  new IdValue('65', 'KY', 'Estill'),
  new IdValue('67', 'KY', 'Fayette'),
  new IdValue('69', 'KY', 'Fleming'),
  new IdValue('71', 'KY', 'Floyd'),
  new IdValue('73', 'KY', 'Franklin'),
  new IdValue('75', 'KY', 'Fulton'),
  new IdValue('77', 'KY', 'Gallatin'),
  new IdValue('79', 'KY', 'Garrard'),
  new IdValue('81', 'KY', 'Grant'),
  new IdValue('83', 'KY', 'Graves'),
  new IdValue('85', 'KY', 'Grayson'),
  new IdValue('87', 'KY', 'Green'),
  new IdValue('89', 'KY', 'Greenup'),
  new IdValue('91', 'KY', 'Hancock'),
  new IdValue('93', 'KY', 'Hardin'),
  new IdValue('95', 'KY', 'Harlan'),
  new IdValue('97', 'KY', 'Harrison'),
  new IdValue('99', 'KY', 'Hart'),
  new IdValue('101', 'KY', 'Henderson'),
  new IdValue('103', 'KY', 'Henry'),
  new IdValue('105', 'KY', 'Hickman'),
  new IdValue('107', 'KY', 'Hopkins'),
  new IdValue('109', 'KY', 'Jackson'),
  new IdValue('111', 'KY', 'Jefferson'),
  new IdValue('113', 'KY', 'Jessamine'),
  new IdValue('115', 'KY', 'Johnson'),
  new IdValue('117', 'KY', 'Kenton'),
  new IdValue('119', 'KY', 'Knott'),
  new IdValue('121', 'KY', 'Knox'),
  new IdValue('123', 'KY', 'Larue'),
  new IdValue('125', 'KY', 'Laurel'),
  new IdValue('127', 'KY', 'Lawrence'),
  new IdValue('129', 'KY', 'Lee'),
  new IdValue('131', 'KY', 'Leslie'),
  new IdValue('133', 'KY', 'Letcher'),
  new IdValue('135', 'KY', 'Lewis'),
  new IdValue('137', 'KY', 'Lincoln'),
  new IdValue('139', 'KY', 'Livingston'),
  new IdValue('141', 'KY', 'Logan'),
  new IdValue('143', 'KY', 'Lyon'),
  new IdValue('151', 'KY', 'Madison'),
  new IdValue('153', 'KY', 'Magoffin'),
  new IdValue('155', 'KY', 'Marion'),
  new IdValue('157', 'KY', 'Marshall'),
  new IdValue('159', 'KY', 'Martin'),
  new IdValue('161', 'KY', 'Mason'),
  new IdValue('145', 'KY', 'McCracken'),
  new IdValue('147', 'KY', 'McCreary'),
  new IdValue('149', 'KY', 'McLean'),
  new IdValue('163', 'KY', 'Meade'),
  new IdValue('165', 'KY', 'Menifee'),
  new IdValue('167', 'KY', 'Mercer'),
  new IdValue('169', 'KY', 'Metcalfe'),
  new IdValue('171', 'KY', 'Monroe'),
  new IdValue('173', 'KY', 'Montgomery'),
  new IdValue('175', 'KY', 'Morgan'),
  new IdValue('177', 'KY', 'Muhlenberg'),
  new IdValue('179', 'KY', 'Nelson'),
  new IdValue('181', 'KY', 'Nicholas'),
  new IdValue('183', 'KY', 'Ohio'),
  new IdValue('185', 'KY', 'Oldham'),
  new IdValue('187', 'KY', 'Owen'),
  new IdValue('189', 'KY', 'Owsley'),
  new IdValue('191', 'KY', 'Pendleton'),
  new IdValue('193', 'KY', 'Perry'),
  new IdValue('195', 'KY', 'Pike'),
  new IdValue('197', 'KY', 'Powell'),
  new IdValue('199', 'KY', 'Pulaski'),
  new IdValue('201', 'KY', 'Robertson'),
  new IdValue('203', 'KY', 'Rockcastle'),
  new IdValue('205', 'KY', 'Rowan'),
  new IdValue('207', 'KY', 'Russell'),
  new IdValue('209', 'KY', 'Scott'),
  new IdValue('211', 'KY', 'Shelby'),
  new IdValue('213', 'KY', 'Simpson'),
  new IdValue('215', 'KY', 'Spencer'),
  new IdValue('217', 'KY', 'Taylor'),
  new IdValue('219', 'KY', 'Todd'),
  new IdValue('221', 'KY', 'Trigg'),
  new IdValue('223', 'KY', 'Trimble'),
  new IdValue('225', 'KY', 'Union'),
  new IdValue('227', 'KY', 'Warren'),
  new IdValue('229', 'KY', 'Washington'),
  new IdValue('231', 'KY', 'Wayne'),
  new IdValue('233', 'KY', 'Webster'),
  new IdValue('235', 'KY', 'Whitley'),
  new IdValue('237', 'KY', 'Wolfe'),
  new IdValue('239', 'KY', 'Woodford'),
  new IdValue('1', 'LA', 'Acadia'),
  new IdValue('3', 'LA', 'Allen'),
  new IdValue('5', 'LA', 'Ascension'),
  new IdValue('7', 'LA', 'Assumption'),
  new IdValue('9', 'LA', 'Avoyelles'),
  new IdValue('11', 'LA', 'Beauregard'),
  new IdValue('13', 'LA', 'Bienville'),
  new IdValue('15', 'LA', 'Bossier'),
  new IdValue('17', 'LA', 'Caddo'),
  new IdValue('19', 'LA', 'Calcasieu'),
  new IdValue('21', 'LA', 'Caldwell'),
  new IdValue('23', 'LA', 'Cameron'),
  new IdValue('25', 'LA', 'Catahoula'),
  new IdValue('27', 'LA', 'Claiborne'),
  new IdValue('29', 'LA', 'Concordia'),
  new IdValue('31', 'LA', 'De Soto'),
  new IdValue('33', 'LA', 'East Baton Rouge'),
  new IdValue('35', 'LA', 'East Carroll'),
  new IdValue('37', 'LA', 'East Feliciana'),
  new IdValue('39', 'LA', 'Evangeline'),
  new IdValue('41', 'LA', 'Franklin'),
  new IdValue('43', 'LA', 'Grant'),
  new IdValue('45', 'LA', 'Iberia'),
  new IdValue('47', 'LA', 'Iberville'),
  new IdValue('49', 'LA', 'Jackson'),
  new IdValue('51', 'LA', 'Jefferson'),
  new IdValue('53', 'LA', 'Jefferson Davis'),
  new IdValue('55', 'LA', 'Lafayette'),
  new IdValue('57', 'LA', 'Lafourche'),
  new IdValue('59', 'LA', 'LaSalle'),
  new IdValue('61', 'LA', 'Lincoln'),
  new IdValue('63', 'LA', 'Livingston'),
  new IdValue('65', 'LA', 'Madison'),
  new IdValue('67', 'LA', 'Morehouse'),
  new IdValue('69', 'LA', 'Natchitoches'),
  new IdValue('71', 'LA', 'Orleans'),
  new IdValue('73', 'LA', 'Ouachita'),
  new IdValue('75', 'LA', 'Plaquemines'),
  new IdValue('77', 'LA', 'Pointe Coupee'),
  new IdValue('79', 'LA', 'Rapides'),
  new IdValue('81', 'LA', 'Red River'),
  new IdValue('83', 'LA', 'Richland'),
  new IdValue('85', 'LA', 'Sabine'),
  new IdValue('87', 'LA', 'St. Bernard'),
  new IdValue('89', 'LA', 'St. Charles'),
  new IdValue('91', 'LA', 'St. Helena'),
  new IdValue('93', 'LA', 'St. James'),
  new IdValue('95', 'LA', 'St. John the Baptist'),
  new IdValue('97', 'LA', 'St. Landry'),
  new IdValue('99', 'LA', 'St. Martin'),
  new IdValue('101', 'LA', 'St. Mary'),
  new IdValue('103', 'LA', 'St. Tammany'),
  new IdValue('105', 'LA', 'Tangipahoa'),
  new IdValue('107', 'LA', 'Tensas'),
  new IdValue('109', 'LA', 'Terrebonne'),
  new IdValue('111', 'LA', 'Union'),
  new IdValue('113', 'LA', 'Vermilion'),
  new IdValue('115', 'LA', 'Vernon'),
  new IdValue('117', 'LA', 'Washington'),
  new IdValue('119', 'LA', 'Webster'),
  new IdValue('121', 'LA', 'West Baton Rouge'),
  new IdValue('123', 'LA', 'West Carroll'),
  new IdValue('125', 'LA', 'West Feliciana'),
  new IdValue('127', 'LA', 'Winn'),
  new IdValue('1', 'MA', 'Barnstable'),
  new IdValue('3', 'MA', 'Berkshire'),
  new IdValue('5', 'MA', 'Bristol'),
  new IdValue('7', 'MA', 'Dukes'),
  new IdValue('9', 'MA', 'Essex'),
  new IdValue('11', 'MA', 'Franklin'),
  new IdValue('13', 'MA', 'Hampden'),
  new IdValue('15', 'MA', 'Hampshire'),
  new IdValue('17', 'MA', 'Middlesex'),
  new IdValue('19', 'MA', 'Nantucket'),
  new IdValue('21', 'MA', 'Norfolk'),
  new IdValue('23', 'MA', 'Plymouth'),
  new IdValue('25', 'MA', 'Suffolk'),
  new IdValue('27', 'MA', 'Worcester'),
  new IdValue('1', 'MD', 'Allegany'),
  new IdValue('3', 'MD', 'Anne Arundel'),
  new IdValue('5', 'MD', 'Baltimore'),
  new IdValue('510', 'MD', 'Baltimore City'),
  new IdValue('9', 'MD', 'Calvert'),
  new IdValue('11', 'MD', 'Caroline'),
  new IdValue('13', 'MD', 'Carroll'),
  new IdValue('15', 'MD', 'Cecil'),
  new IdValue('17', 'MD', 'Charles'),
  new IdValue('19', 'MD', 'Dorchester'),
  new IdValue('21', 'MD', 'Frederick'),
  new IdValue('23', 'MD', 'Garrett'),
  new IdValue('25', 'MD', 'Harford'),
  new IdValue('27', 'MD', 'Howard'),
  new IdValue('29', 'MD', 'Kent'),
  new IdValue('31', 'MD', 'Montgomery'),
  // eslint-disable-next-line quotes
  new IdValue('33', 'MD', "Prince George's"),
  // eslint-disable-next-line quotes
  new IdValue('35', 'MD', "Queen Anne's"),
  new IdValue('39', 'MD', 'Somerset'),
  // eslint-disable-next-line quotes
  new IdValue('37', 'MD', "St. Mary's"),
  new IdValue('41', 'MD', 'Talbot'),
  new IdValue('43', 'MD', 'Washington'),
  new IdValue('45', 'MD', 'Wicomico'),
  new IdValue('47', 'MD', 'Worcester'),
  new IdValue('1', 'ME', 'Androscoggin'),
  new IdValue('3', 'ME', 'Aroostook'),
  new IdValue('5', 'ME', 'Cumberland'),
  new IdValue('7', 'ME', 'Franklin'),
  new IdValue('9', 'ME', 'Hancock'),
  new IdValue('11', 'ME', 'Kennebec'),
  new IdValue('13', 'ME', 'Knox'),
  new IdValue('15', 'ME', 'Lincoln'),
  new IdValue('17', 'ME', 'Oxford'),
  new IdValue('19', 'ME', 'Penobscot'),
  new IdValue('21', 'ME', 'Piscataquis'),
  new IdValue('23', 'ME', 'Sagadahoc'),
  new IdValue('25', 'ME', 'Somerset'),
  new IdValue('27', 'ME', 'Waldo'),
  new IdValue('29', 'ME', 'Washington'),
  new IdValue('31', 'ME', 'York'),
  new IdValue('1', 'MI', 'Alcona'),
  new IdValue('3', 'MI', 'Alger'),
  new IdValue('5', 'MI', 'Allegan'),
  new IdValue('7', 'MI', 'Alpena'),
  new IdValue('9', 'MI', 'Antrim'),
  new IdValue('11', 'MI', 'Arenac'),
  new IdValue('13', 'MI', 'Baraga'),
  new IdValue('15', 'MI', 'Barry'),
  new IdValue('17', 'MI', 'Bay'),
  new IdValue('19', 'MI', 'Benzie'),
  new IdValue('21', 'MI', 'Berrien'),
  new IdValue('23', 'MI', 'Branch'),
  new IdValue('25', 'MI', 'Calhoun'),
  new IdValue('27', 'MI', 'Cass'),
  new IdValue('29', 'MI', 'Charlevoix'),
  new IdValue('31', 'MI', 'Cheboygan'),
  new IdValue('33', 'MI', 'Chippewa'),
  new IdValue('35', 'MI', 'Clare'),
  new IdValue('37', 'MI', 'Clinton'),
  new IdValue('39', 'MI', 'Crawford'),
  new IdValue('41', 'MI', 'Delta'),
  new IdValue('43', 'MI', 'Dickinson'),
  new IdValue('45', 'MI', 'Eaton'),
  new IdValue('47', 'MI', 'Emmet'),
  new IdValue('49', 'MI', 'Genesee'),
  new IdValue('51', 'MI', 'Gladwin'),
  new IdValue('53', 'MI', 'Gogebic'),
  new IdValue('55', 'MI', 'Grand Traverse'),
  new IdValue('57', 'MI', 'Gratiot'),
  new IdValue('59', 'MI', 'Hillsdale'),
  new IdValue('61', 'MI', 'Houghton'),
  new IdValue('63', 'MI', 'Huron'),
  new IdValue('65', 'MI', 'Ingham'),
  new IdValue('67', 'MI', 'Ionia'),
  new IdValue('69', 'MI', 'Iosco'),
  new IdValue('71', 'MI', 'Iron'),
  new IdValue('73', 'MI', 'Isabella'),
  new IdValue('75', 'MI', 'Jackson'),
  new IdValue('77', 'MI', 'Kalamazoo'),
  new IdValue('79', 'MI', 'Kalkaska'),
  new IdValue('81', 'MI', 'Kent'),
  new IdValue('83', 'MI', 'Keweenaw'),
  new IdValue('85', 'MI', 'Lake'),
  new IdValue('87', 'MI', 'Lapeer'),
  new IdValue('89', 'MI', 'Leelanau'),
  new IdValue('91', 'MI', 'Lenawee'),
  new IdValue('93', 'MI', 'Livingston'),
  new IdValue('95', 'MI', 'Luce'),
  new IdValue('97', 'MI', 'Mackinac'),
  new IdValue('99', 'MI', 'Macomb'),
  new IdValue('101', 'MI', 'Manistee'),
  new IdValue('103', 'MI', 'Marquette'),
  new IdValue('105', 'MI', 'Mason'),
  new IdValue('107', 'MI', 'Mecosta'),
  new IdValue('109', 'MI', 'Menominee'),
  new IdValue('111', 'MI', 'Midland'),
  new IdValue('113', 'MI', 'Missaukee'),
  new IdValue('115', 'MI', 'Monroe'),
  new IdValue('117', 'MI', 'Montcalm'),
  new IdValue('119', 'MI', 'Montmorency'),
  new IdValue('121', 'MI', 'Muskegon'),
  new IdValue('123', 'MI', 'Newaygo'),
  new IdValue('125', 'MI', 'Oakland'),
  new IdValue('127', 'MI', 'Oceana'),
  new IdValue('129', 'MI', 'Ogemaw'),
  new IdValue('131', 'MI', 'Ontonagon'),
  new IdValue('133', 'MI', 'Osceola'),
  new IdValue('135', 'MI', 'Oscoda'),
  new IdValue('137', 'MI', 'Otsego'),
  new IdValue('139', 'MI', 'Ottawa'),
  new IdValue('141', 'MI', 'Presque Isle'),
  new IdValue('143', 'MI', 'Roscommon'),
  new IdValue('145', 'MI', 'Saginaw'),
  new IdValue('151', 'MI', 'Sanilac'),
  new IdValue('153', 'MI', 'Schoolcraft'),
  new IdValue('155', 'MI', 'Shiawassee'),
  new IdValue('147', 'MI', 'St. Clair'),
  new IdValue('149', 'MI', 'St. Joseph'),
  new IdValue('157', 'MI', 'Tuscola'),
  new IdValue('159', 'MI', 'Van Buren'),
  new IdValue('161', 'MI', 'Washtenaw'),
  new IdValue('163', 'MI', 'Wayne'),
  new IdValue('165', 'MI', 'Wexford'),
  new IdValue('1', 'MN', 'Aitkin'),
  new IdValue('3', 'MN', 'Anoka'),
  new IdValue('5', 'MN', 'Becker'),
  new IdValue('7', 'MN', 'Beltrami'),
  new IdValue('9', 'MN', 'Benton'),
  new IdValue('11', 'MN', 'Big Stone'),
  new IdValue('13', 'MN', 'Blue Earth'),
  new IdValue('15', 'MN', 'Brown'),
  new IdValue('17', 'MN', 'Carlton'),
  new IdValue('19', 'MN', 'Carver'),
  new IdValue('21', 'MN', 'Cass'),
  new IdValue('23', 'MN', 'Chippewa'),
  new IdValue('25', 'MN', 'Chisago'),
  new IdValue('27', 'MN', 'Clay'),
  new IdValue('29', 'MN', 'Clearwater'),
  new IdValue('31', 'MN', 'Cook'),
  new IdValue('33', 'MN', 'Cottonwood'),
  new IdValue('35', 'MN', 'Crow Wing'),
  new IdValue('37', 'MN', 'Dakota'),
  new IdValue('39', 'MN', 'Dodge'),
  new IdValue('41', 'MN', 'Douglas'),
  new IdValue('43', 'MN', 'Faribault'),
  new IdValue('45', 'MN', 'Fillmore'),
  new IdValue('47', 'MN', 'Freeborn'),
  new IdValue('49', 'MN', 'Goodhue'),
  new IdValue('51', 'MN', 'Grant'),
  new IdValue('53', 'MN', 'Hennepin'),
  new IdValue('55', 'MN', 'Houston'),
  new IdValue('57', 'MN', 'Hubbard'),
  new IdValue('59', 'MN', 'Isanti'),
  new IdValue('61', 'MN', 'Itasca'),
  new IdValue('63', 'MN', 'Jackson'),
  new IdValue('65', 'MN', 'Kanabec'),
  new IdValue('67', 'MN', 'Kandiyohi'),
  new IdValue('69', 'MN', 'Kittson'),
  new IdValue('71', 'MN', 'Koochiching'),
  new IdValue('73', 'MN', 'Lac qui Parle'),
  new IdValue('75', 'MN', 'Lake'),
  new IdValue('77', 'MN', 'Lake of the Woods'),
  new IdValue('79', 'MN', 'Le Sueur'),
  new IdValue('81', 'MN', 'Lincoln'),
  new IdValue('83', 'MN', 'Lyon'),
  new IdValue('87', 'MN', 'Mahnomen'),
  new IdValue('89', 'MN', 'Marshall'),
  new IdValue('91', 'MN', 'Martin'),
  new IdValue('85', 'MN', 'McLeod'),
  new IdValue('93', 'MN', 'Meeker'),
  new IdValue('95', 'MN', 'Mille Lacs'),
  new IdValue('97', 'MN', 'Morrison'),
  new IdValue('99', 'MN', 'Mower'),
  new IdValue('101', 'MN', 'Murray'),
  new IdValue('103', 'MN', 'Nicollet'),
  new IdValue('105', 'MN', 'Nobles'),
  new IdValue('107', 'MN', 'Norman'),
  new IdValue('109', 'MN', 'Olmsted'),
  new IdValue('111', 'MN', 'Otter Tail'),
  new IdValue('113', 'MN', 'Pennington'),
  new IdValue('115', 'MN', 'Pine'),
  new IdValue('117', 'MN', 'Pipestone'),
  new IdValue('119', 'MN', 'Polk'),
  new IdValue('121', 'MN', 'Pope'),
  new IdValue('123', 'MN', 'Ramsey'),
  new IdValue('125', 'MN', 'Red Lake'),
  new IdValue('127', 'MN', 'Redwood'),
  new IdValue('129', 'MN', 'Renville'),
  new IdValue('131', 'MN', 'Rice'),
  new IdValue('133', 'MN', 'Rock'),
  new IdValue('135', 'MN', 'Roseau'),
  new IdValue('139', 'MN', 'Scott'),
  new IdValue('141', 'MN', 'Sherburne'),
  new IdValue('143', 'MN', 'Sibley'),
  new IdValue('137', 'MN', 'St. Louis'),
  new IdValue('145', 'MN', 'Stearns'),
  new IdValue('147', 'MN', 'Steele'),
  new IdValue('149', 'MN', 'Stevens'),
  new IdValue('151', 'MN', 'Swift'),
  new IdValue('153', 'MN', 'Todd'),
  new IdValue('155', 'MN', 'Traverse'),
  new IdValue('157', 'MN', 'Wabasha'),
  new IdValue('159', 'MN', 'Wadena'),
  new IdValue('161', 'MN', 'Waseca'),
  new IdValue('163', 'MN', 'Washington'),
  new IdValue('165', 'MN', 'Watonwan'),
  new IdValue('167', 'MN', 'Wilkin'),
  new IdValue('169', 'MN', 'Winona'),
  new IdValue('171', 'MN', 'Wright'),
  new IdValue('173', 'MN', 'Yellow Medicine'),
  new IdValue('1', 'MO', 'Adair'),
  new IdValue('3', 'MO', 'Andrew'),
  new IdValue('5', 'MO', 'Atchison'),
  new IdValue('7', 'MO', 'Audrain'),
  new IdValue('9', 'MO', 'Barry'),
  new IdValue('11', 'MO', 'Barton'),
  new IdValue('13', 'MO', 'Bates'),
  new IdValue('15', 'MO', 'Benton'),
  new IdValue('17', 'MO', 'Bollinger'),
  new IdValue('19', 'MO', 'Boone'),
  new IdValue('21', 'MO', 'Buchanan'),
  new IdValue('23', 'MO', 'Butler'),
  new IdValue('25', 'MO', 'Caldwell'),
  new IdValue('27', 'MO', 'Callaway'),
  new IdValue('29', 'MO', 'Camden'),
  new IdValue('31', 'MO', 'Cape Girardeau'),
  new IdValue('33', 'MO', 'Carroll'),
  new IdValue('35', 'MO', 'Carter'),
  new IdValue('37', 'MO', 'Cass'),
  new IdValue('39', 'MO', 'Cedar'),
  new IdValue('41', 'MO', 'Chariton'),
  new IdValue('43', 'MO', 'Christian'),
  new IdValue('45', 'MO', 'Clark'),
  new IdValue('47', 'MO', 'Clay'),
  new IdValue('49', 'MO', 'Clinton'),
  new IdValue('51', 'MO', 'Cole'),
  new IdValue('53', 'MO', 'Cooper'),
  new IdValue('55', 'MO', 'Crawford'),
  new IdValue('57', 'MO', 'Dade'),
  new IdValue('59', 'MO', 'Dallas'),
  new IdValue('61', 'MO', 'Daviess'),
  new IdValue('63', 'MO', 'DeKalb'),
  new IdValue('65', 'MO', 'Dent'),
  new IdValue('67', 'MO', 'Douglas'),
  new IdValue('69', 'MO', 'Dunklin'),
  new IdValue('71', 'MO', 'Franklin'),
  new IdValue('73', 'MO', 'Gasconade'),
  new IdValue('75', 'MO', 'Gentry'),
  new IdValue('77', 'MO', 'Greene'),
  new IdValue('79', 'MO', 'Grundy'),
  new IdValue('81', 'MO', 'Harrison'),
  new IdValue('83', 'MO', 'Henry'),
  new IdValue('85', 'MO', 'Hickory'),
  new IdValue('87', 'MO', 'Holt'),
  new IdValue('89', 'MO', 'Howard'),
  new IdValue('91', 'MO', 'Howell'),
  new IdValue('93', 'MO', 'Iron'),
  new IdValue('95', 'MO', 'Jackson'),
  new IdValue('97', 'MO', 'Jasper'),
  new IdValue('99', 'MO', 'Jefferson'),
  new IdValue('101', 'MO', 'Johnson'),
  new IdValue('103', 'MO', 'Knox'),
  new IdValue('105', 'MO', 'Laclede'),
  new IdValue('107', 'MO', 'Lafayette'),
  new IdValue('109', 'MO', 'Lawrence'),
  new IdValue('111', 'MO', 'Lewis'),
  new IdValue('113', 'MO', 'Lincoln'),
  new IdValue('115', 'MO', 'Linn'),
  new IdValue('117', 'MO', 'Livingston'),
  new IdValue('121', 'MO', 'Macon'),
  new IdValue('123', 'MO', 'Madison'),
  new IdValue('125', 'MO', 'Maries'),
  new IdValue('127', 'MO', 'Marion'),
  new IdValue('119', 'MO', 'McDonald'),
  new IdValue('129', 'MO', 'Mercer'),
  new IdValue('131', 'MO', 'Miller'),
  new IdValue('133', 'MO', 'Mississippi'),
  new IdValue('135', 'MO', 'Moniteau'),
  new IdValue('137', 'MO', 'Monroe'),
  new IdValue('139', 'MO', 'Montgomery'),
  new IdValue('141', 'MO', 'Morgan'),
  new IdValue('143', 'MO', 'New Madrid'),
  new IdValue('145', 'MO', 'Newton'),
  new IdValue('147', 'MO', 'Nodaway'),
  new IdValue('149', 'MO', 'Oregon'),
  new IdValue('151', 'MO', 'Osage'),
  new IdValue('153', 'MO', 'Ozark'),
  new IdValue('155', 'MO', 'Pemiscot'),
  new IdValue('157', 'MO', 'Perry'),
  new IdValue('159', 'MO', 'Pettis'),
  new IdValue('161', 'MO', 'Phelps'),
  new IdValue('163', 'MO', 'Pike'),
  new IdValue('165', 'MO', 'Platte'),
  new IdValue('167', 'MO', 'Polk'),
  new IdValue('169', 'MO', 'Pulaski'),
  new IdValue('171', 'MO', 'Putnam'),
  new IdValue('173', 'MO', 'Ralls'),
  new IdValue('175', 'MO', 'Randolph'),
  new IdValue('177', 'MO', 'Ray'),
  new IdValue('179', 'MO', 'Reynolds'),
  new IdValue('181', 'MO', 'Ripley'),
  new IdValue('195', 'MO', 'Saline'),
  new IdValue('197', 'MO', 'Schuyler'),
  new IdValue('199', 'MO', 'Scotland'),
  new IdValue('201', 'MO', 'Scott'),
  new IdValue('203', 'MO', 'Shannon'),
  new IdValue('205', 'MO', 'Shelby'),
  new IdValue('183', 'MO', 'St. Charles'),
  new IdValue('185', 'MO', 'St. Clair'),
  new IdValue('187', 'MO', 'St. Francois'),
  new IdValue('189', 'MO', 'St. Louis'),
  new IdValue('510', 'MO', 'St. Louis City'),
  new IdValue('186', 'MO', 'Ste. Genevieve'),
  new IdValue('207', 'MO', 'Stoddard'),
  new IdValue('209', 'MO', 'Stone'),
  new IdValue('211', 'MO', 'Sullivan'),
  new IdValue('213', 'MO', 'Taney'),
  new IdValue('215', 'MO', 'Texas'),
  new IdValue('217', 'MO', 'Vernon'),
  new IdValue('219', 'MO', 'Warren'),
  new IdValue('221', 'MO', 'Washington'),
  new IdValue('223', 'MO', 'Wayne'),
  new IdValue('225', 'MO', 'Webster'),
  new IdValue('227', 'MO', 'Worth'),
  new IdValue('229', 'MO', 'Wright'),
  new IdValue('85', 'MP', 'Northern Mariana Islands'),
  new IdValue('100', 'MP', 'Rota'),
  new IdValue('110', 'MP', 'Saipan'),
  new IdValue('120', 'MP', 'Tinian'),
  new IdValue('1', 'MS', 'Adams'),
  new IdValue('3', 'MS', 'Alcorn'),
  new IdValue('5', 'MS', 'Amite'),
  new IdValue('7', 'MS', 'Attala'),
  new IdValue('9', 'MS', 'Benton'),
  new IdValue('11', 'MS', 'Bolivar'),
  new IdValue('13', 'MS', 'Calhoun'),
  new IdValue('15', 'MS', 'Carroll'),
  new IdValue('17', 'MS', 'Chickasaw'),
  new IdValue('19', 'MS', 'Choctaw'),
  new IdValue('21', 'MS', 'Claiborne'),
  new IdValue('23', 'MS', 'Clarke'),
  new IdValue('25', 'MS', 'Clay'),
  new IdValue('27', 'MS', 'Coahoma'),
  new IdValue('29', 'MS', 'Copiah'),
  new IdValue('31', 'MS', 'Covington'),
  new IdValue('33', 'MS', 'DeSoto'),
  new IdValue('35', 'MS', 'Forrest'),
  new IdValue('37', 'MS', 'Franklin'),
  new IdValue('39', 'MS', 'George'),
  new IdValue('41', 'MS', 'Greene'),
  new IdValue('43', 'MS', 'Grenada'),
  new IdValue('45', 'MS', 'Hancock'),
  new IdValue('47', 'MS', 'Harrison'),
  new IdValue('49', 'MS', 'Hinds'),
  new IdValue('51', 'MS', 'Holmes'),
  new IdValue('53', 'MS', 'Humphreys'),
  new IdValue('55', 'MS', 'Issaquena'),
  new IdValue('57', 'MS', 'Itawamba'),
  new IdValue('59', 'MS', 'Jackson'),
  new IdValue('61', 'MS', 'Jasper'),
  new IdValue('63', 'MS', 'Jefferson'),
  new IdValue('65', 'MS', 'Jefferson Davis'),
  new IdValue('67', 'MS', 'Jones'),
  new IdValue('69', 'MS', 'Kemper'),
  new IdValue('71', 'MS', 'Lafayette'),
  new IdValue('73', 'MS', 'Lamar'),
  new IdValue('75', 'MS', 'Lauderdale'),
  new IdValue('77', 'MS', 'Lawrence'),
  new IdValue('79', 'MS', 'Leake'),
  new IdValue('81', 'MS', 'Lee'),
  new IdValue('83', 'MS', 'Leflore'),
  new IdValue('85', 'MS', 'Lincoln'),
  new IdValue('87', 'MS', 'Lowndes'),
  new IdValue('89', 'MS', 'Madison'),
  new IdValue('91', 'MS', 'Marion'),
  new IdValue('93', 'MS', 'Marshall'),
  new IdValue('95', 'MS', 'Monroe'),
  new IdValue('97', 'MS', 'Montgomery'),
  new IdValue('99', 'MS', 'Neshoba'),
  new IdValue('101', 'MS', 'Newton'),
  new IdValue('103', 'MS', 'Noxubee'),
  new IdValue('105', 'MS', 'Oktibbeha'),
  new IdValue('107', 'MS', 'Panola'),
  new IdValue('109', 'MS', 'Pearl River'),
  new IdValue('111', 'MS', 'Perry'),
  new IdValue('113', 'MS', 'Pike'),
  new IdValue('115', 'MS', 'Pontotoc'),
  new IdValue('117', 'MS', 'Prentiss'),
  new IdValue('119', 'MS', 'Quitman'),
  new IdValue('121', 'MS', 'Rankin'),
  new IdValue('123', 'MS', 'Scott'),
  new IdValue('125', 'MS', 'Sharkey'),
  new IdValue('127', 'MS', 'Simpson'),
  new IdValue('129', 'MS', 'Smith'),
  new IdValue('131', 'MS', 'Stone'),
  new IdValue('133', 'MS', 'Sunflower'),
  new IdValue('135', 'MS', 'Tallahatchie'),
  new IdValue('137', 'MS', 'Tate'),
  new IdValue('139', 'MS', 'Tippah'),
  new IdValue('141', 'MS', 'Tishomingo'),
  new IdValue('143', 'MS', 'Tunica'),
  new IdValue('145', 'MS', 'Union'),
  new IdValue('147', 'MS', 'Walthall'),
  new IdValue('149', 'MS', 'Warren'),
  new IdValue('151', 'MS', 'Washington'),
  new IdValue('153', 'MS', 'Wayne'),
  new IdValue('155', 'MS', 'Webster'),
  new IdValue('157', 'MS', 'Wilkinson'),
  new IdValue('159', 'MS', 'Winston'),
  new IdValue('161', 'MS', 'Yalobusha'),
  new IdValue('163', 'MS', 'Yazoo'),
  new IdValue('1', 'MT', 'Beaverhead'),
  new IdValue('3', 'MT', 'Big Horn'),
  new IdValue('5', 'MT', 'Blaine'),
  new IdValue('7', 'MT', 'Broadwater'),
  new IdValue('9', 'MT', 'Carbon'),
  new IdValue('11', 'MT', 'Carter'),
  new IdValue('13', 'MT', 'Cascade'),
  new IdValue('15', 'MT', 'Chouteau'),
  new IdValue('17', 'MT', 'Custer'),
  new IdValue('19', 'MT', 'Daniels'),
  new IdValue('21', 'MT', 'Dawson'),
  new IdValue('23', 'MT', 'Deer Lodge'),
  new IdValue('25', 'MT', 'Fallon'),
  new IdValue('27', 'MT', 'Fergus'),
  new IdValue('29', 'MT', 'Flathead'),
  new IdValue('31', 'MT', 'Gallatin'),
  new IdValue('33', 'MT', 'Garfield'),
  new IdValue('35', 'MT', 'Glacier'),
  new IdValue('37', 'MT', 'Golden Valley'),
  new IdValue('39', 'MT', 'Granite'),
  new IdValue('41', 'MT', 'Hill'),
  new IdValue('43', 'MT', 'Jefferson'),
  new IdValue('45', 'MT', 'Judith Basin'),
  new IdValue('47', 'MT', 'Lake'),
  new IdValue('49', 'MT', 'Lewis and Clark'),
  new IdValue('51', 'MT', 'Liberty'),
  new IdValue('53', 'MT', 'Lincoln'),
  new IdValue('57', 'MT', 'Madison'),
  new IdValue('55', 'MT', 'McCone'),
  new IdValue('59', 'MT', 'Meagher'),
  new IdValue('61', 'MT', 'Mineral'),
  new IdValue('63', 'MT', 'Missoula'),
  new IdValue('65', 'MT', 'Musselshell'),
  new IdValue('67', 'MT', 'Park'),
  new IdValue('69', 'MT', 'Petroleum'),
  new IdValue('71', 'MT', 'Phillips'),
  new IdValue('73', 'MT', 'Pondera'),
  new IdValue('75', 'MT', 'Powder River'),
  new IdValue('77', 'MT', 'Powell'),
  new IdValue('79', 'MT', 'Prairie'),
  new IdValue('81', 'MT', 'Ravalli'),
  new IdValue('83', 'MT', 'Richland'),
  new IdValue('85', 'MT', 'Roosevelt'),
  new IdValue('87', 'MT', 'Rosebud'),
  new IdValue('89', 'MT', 'Sanders'),
  new IdValue('91', 'MT', 'Sheridan'),
  new IdValue('93', 'MT', 'Silver Bow'),
  new IdValue('95', 'MT', 'Stillwater'),
  new IdValue('97', 'MT', 'Sweet Grass'),
  new IdValue('99', 'MT', 'Teton'),
  new IdValue('101', 'MT', 'Toole'),
  new IdValue('103', 'MT', 'Treasure'),
  new IdValue('105', 'MT', 'Valley'),
  new IdValue('107', 'MT', 'Wheatland'),
  new IdValue('109', 'MT', 'Wibaux'),
  new IdValue('111', 'MT', 'Yellowstone'),
  new IdValue('1', 'NC', 'Alamance'),
  new IdValue('3', 'NC', 'Alexander'),
  new IdValue('5', 'NC', 'Alleghany'),
  new IdValue('7', 'NC', 'Anson'),
  new IdValue('9', 'NC', 'Ashe'),
  new IdValue('11', 'NC', 'Avery'),
  new IdValue('13', 'NC', 'Beaufort'),
  new IdValue('15', 'NC', 'Bertie'),
  new IdValue('17', 'NC', 'Bladen'),
  new IdValue('19', 'NC', 'Brunswick'),
  new IdValue('21', 'NC', 'Buncombe'),
  new IdValue('23', 'NC', 'Burke'),
  new IdValue('25', 'NC', 'Cabarrus'),
  new IdValue('27', 'NC', 'Caldwell'),
  new IdValue('29', 'NC', 'Camden'),
  new IdValue('31', 'NC', 'Carteret'),
  new IdValue('33', 'NC', 'Caswell'),
  new IdValue('35', 'NC', 'Catawba'),
  new IdValue('37', 'NC', 'Chatham'),
  new IdValue('39', 'NC', 'Cherokee'),
  new IdValue('41', 'NC', 'Chowan'),
  new IdValue('43', 'NC', 'Clay'),
  new IdValue('45', 'NC', 'Cleveland'),
  new IdValue('47', 'NC', 'Columbus'),
  new IdValue('49', 'NC', 'Craven'),
  new IdValue('51', 'NC', 'Cumberland'),
  new IdValue('53', 'NC', 'Currituck'),
  new IdValue('55', 'NC', 'Dare'),
  new IdValue('57', 'NC', 'Davidson'),
  new IdValue('59', 'NC', 'Davie'),
  new IdValue('61', 'NC', 'Duplin'),
  new IdValue('63', 'NC', 'Durham'),
  new IdValue('65', 'NC', 'Edgecombe'),
  new IdValue('67', 'NC', 'Forsyth'),
  new IdValue('69', 'NC', 'Franklin'),
  new IdValue('71', 'NC', 'Gaston'),
  new IdValue('73', 'NC', 'Gates'),
  new IdValue('75', 'NC', 'Graham'),
  new IdValue('77', 'NC', 'Granville'),
  new IdValue('79', 'NC', 'Greene'),
  new IdValue('81', 'NC', 'Guilford'),
  new IdValue('83', 'NC', 'Halifax'),
  new IdValue('85', 'NC', 'Harnett'),
  new IdValue('87', 'NC', 'Haywood'),
  new IdValue('89', 'NC', 'Henderson'),
  new IdValue('91', 'NC', 'Hertford'),
  new IdValue('93', 'NC', 'Hoke'),
  new IdValue('95', 'NC', 'Hyde'),
  new IdValue('97', 'NC', 'Iredell'),
  new IdValue('99', 'NC', 'Jackson'),
  new IdValue('101', 'NC', 'Johnston'),
  new IdValue('103', 'NC', 'Jones'),
  new IdValue('105', 'NC', 'Lee'),
  new IdValue('107', 'NC', 'Lenoir'),
  new IdValue('109', 'NC', 'Lincoln'),
  new IdValue('113', 'NC', 'Macon'),
  new IdValue('115', 'NC', 'Madison'),
  new IdValue('117', 'NC', 'Martin'),
  new IdValue('111', 'NC', 'McDowell'),
  new IdValue('119', 'NC', 'Mecklenburg'),
  new IdValue('121', 'NC', 'Mitchell'),
  new IdValue('123', 'NC', 'Montgomery'),
  new IdValue('125', 'NC', 'Moore'),
  new IdValue('127', 'NC', 'Nash'),
  new IdValue('129', 'NC', 'New Hanover'),
  new IdValue('131', 'NC', 'Northampton'),
  new IdValue('133', 'NC', 'Onslow'),
  new IdValue('135', 'NC', 'Orange'),
  new IdValue('137', 'NC', 'Pamlico'),
  new IdValue('139', 'NC', 'Pasquotank'),
  new IdValue('141', 'NC', 'Pender'),
  new IdValue('143', 'NC', 'Perquimans'),
  new IdValue('145', 'NC', 'Person'),
  new IdValue('147', 'NC', 'Pitt'),
  new IdValue('149', 'NC', 'Polk'),
  new IdValue('151', 'NC', 'Randolph'),
  new IdValue('153', 'NC', 'Richmond'),
  new IdValue('155', 'NC', 'Robeson'),
  new IdValue('157', 'NC', 'Rockingham'),
  new IdValue('159', 'NC', 'Rowan'),
  new IdValue('161', 'NC', 'Rutherford'),
  new IdValue('163', 'NC', 'Sampson'),
  new IdValue('165', 'NC', 'Scotland'),
  new IdValue('167', 'NC', 'Stanly'),
  new IdValue('169', 'NC', 'Stokes'),
  new IdValue('171', 'NC', 'Surry'),
  new IdValue('173', 'NC', 'Swain'),
  new IdValue('175', 'NC', 'Transylvania'),
  new IdValue('177', 'NC', 'Tyrrell'),
  new IdValue('179', 'NC', 'Union'),
  new IdValue('181', 'NC', 'Vance'),
  new IdValue('183', 'NC', 'Wake'),
  new IdValue('185', 'NC', 'Warren'),
  new IdValue('187', 'NC', 'Washington'),
  new IdValue('189', 'NC', 'Watauga'),
  new IdValue('191', 'NC', 'Wayne'),
  new IdValue('193', 'NC', 'Wilkes'),
  new IdValue('195', 'NC', 'Wilson'),
  new IdValue('197', 'NC', 'Yadkin'),
  new IdValue('199', 'NC', 'Yancey'),
  new IdValue('1', 'ND', 'Adams'),
  new IdValue('3', 'ND', 'Barnes'),
  new IdValue('5', 'ND', 'Benson'),
  new IdValue('7', 'ND', 'Billings'),
  new IdValue('9', 'ND', 'Bottineau'),
  new IdValue('11', 'ND', 'Bowman'),
  new IdValue('13', 'ND', 'Burke'),
  new IdValue('15', 'ND', 'Burleigh'),
  new IdValue('17', 'ND', 'Cass'),
  new IdValue('19', 'ND', 'Cavalier'),
  new IdValue('21', 'ND', 'Dickey'),
  new IdValue('23', 'ND', 'Divide'),
  new IdValue('25', 'ND', 'Dunn'),
  new IdValue('27', 'ND', 'Eddy'),
  new IdValue('29', 'ND', 'Emmons'),
  new IdValue('31', 'ND', 'Foster'),
  new IdValue('33', 'ND', 'Golden Valley'),
  new IdValue('35', 'ND', 'Grand Forks'),
  new IdValue('37', 'ND', 'Grant'),
  new IdValue('39', 'ND', 'Griggs'),
  new IdValue('41', 'ND', 'Hettinger'),
  new IdValue('43', 'ND', 'Kidder'),
  new IdValue('45', 'ND', 'LaMoure'),
  new IdValue('47', 'ND', 'Logan'),
  new IdValue('49', 'ND', 'McHenry'),
  new IdValue('51', 'ND', 'McIntosh'),
  new IdValue('53', 'ND', 'McKenzie'),
  new IdValue('55', 'ND', 'McLean'),
  new IdValue('57', 'ND', 'Mercer'),
  new IdValue('59', 'ND', 'Morton'),
  new IdValue('61', 'ND', 'Mountrail'),
  new IdValue('63', 'ND', 'Nelson'),
  new IdValue('65', 'ND', 'Oliver'),
  new IdValue('67', 'ND', 'Pembina'),
  new IdValue('69', 'ND', 'Pierce'),
  new IdValue('71', 'ND', 'Ramsey'),
  new IdValue('73', 'ND', 'Ransom'),
  new IdValue('75', 'ND', 'Renville'),
  new IdValue('77', 'ND', 'Richland'),
  new IdValue('79', 'ND', 'Rolette'),
  new IdValue('81', 'ND', 'Sargent'),
  new IdValue('83', 'ND', 'Sheridan'),
  new IdValue('85', 'ND', 'Sioux'),
  new IdValue('87', 'ND', 'Slope'),
  new IdValue('89', 'ND', 'Stark'),
  new IdValue('91', 'ND', 'Steele'),
  new IdValue('93', 'ND', 'Stutsman'),
  new IdValue('95', 'ND', 'Towner'),
  new IdValue('97', 'ND', 'Traill'),
  new IdValue('99', 'ND', 'Walsh'),
  new IdValue('101', 'ND', 'Ward'),
  new IdValue('103', 'ND', 'Wells'),
  new IdValue('105', 'ND', 'Williams'),
  new IdValue('1', 'NE', 'Adams'),
  new IdValue('3', 'NE', 'Antelope'),
  new IdValue('5', 'NE', 'Arthur'),
  new IdValue('7', 'NE', 'Banner'),
  new IdValue('9', 'NE', 'Blaine'),
  new IdValue('11', 'NE', 'Boone'),
  new IdValue('13', 'NE', 'Box Butte'),
  new IdValue('15', 'NE', 'Boyd'),
  new IdValue('17', 'NE', 'Brown'),
  new IdValue('19', 'NE', 'Buffalo'),
  new IdValue('21', 'NE', 'Burt'),
  new IdValue('23', 'NE', 'Butler'),
  new IdValue('25', 'NE', 'Cass'),
  new IdValue('27', 'NE', 'Cedar'),
  new IdValue('29', 'NE', 'Chase'),
  new IdValue('31', 'NE', 'Cherry'),
  new IdValue('33', 'NE', 'Cheyenne'),
  new IdValue('35', 'NE', 'Clay'),
  new IdValue('37', 'NE', 'Colfax'),
  new IdValue('39', 'NE', 'Cuming'),
  new IdValue('41', 'NE', 'Custer'),
  new IdValue('43', 'NE', 'Dakota'),
  new IdValue('45', 'NE', 'Dawes'),
  new IdValue('47', 'NE', 'Dawson'),
  new IdValue('49', 'NE', 'Deuel'),
  new IdValue('51', 'NE', 'Dixon'),
  new IdValue('53', 'NE', 'Dodge'),
  new IdValue('55', 'NE', 'Douglas'),
  new IdValue('57', 'NE', 'Dundy'),
  new IdValue('59', 'NE', 'Fillmore'),
  new IdValue('61', 'NE', 'Franklin'),
  new IdValue('63', 'NE', 'Frontier'),
  new IdValue('65', 'NE', 'Furnas'),
  new IdValue('67', 'NE', 'Gage'),
  new IdValue('69', 'NE', 'Garden'),
  new IdValue('71', 'NE', 'Garfield'),
  new IdValue('73', 'NE', 'Gosper'),
  new IdValue('75', 'NE', 'Grant'),
  new IdValue('77', 'NE', 'Greeley'),
  new IdValue('79', 'NE', 'Hall'),
  new IdValue('81', 'NE', 'Hamilton'),
  new IdValue('83', 'NE', 'Harlan'),
  new IdValue('85', 'NE', 'Hayes'),
  new IdValue('87', 'NE', 'Hitchcock'),
  new IdValue('89', 'NE', 'Holt'),
  new IdValue('91', 'NE', 'Hooker'),
  new IdValue('93', 'NE', 'Howard'),
  new IdValue('95', 'NE', 'Jefferson'),
  new IdValue('97', 'NE', 'Johnson'),
  new IdValue('99', 'NE', 'Kearney'),
  new IdValue('101', 'NE', 'Keith'),
  new IdValue('103', 'NE', 'Keya Paha'),
  new IdValue('105', 'NE', 'Kimball'),
  new IdValue('107', 'NE', 'Knox'),
  new IdValue('109', 'NE', 'Lancaster'),
  new IdValue('111', 'NE', 'Lincoln'),
  new IdValue('113', 'NE', 'Logan'),
  new IdValue('115', 'NE', 'Loup'),
  new IdValue('119', 'NE', 'Madison'),
  new IdValue('117', 'NE', 'McPherson'),
  new IdValue('121', 'NE', 'Merrick'),
  new IdValue('123', 'NE', 'Morrill'),
  new IdValue('125', 'NE', 'Nance'),
  new IdValue('127', 'NE', 'Nemaha'),
  new IdValue('129', 'NE', 'Nuckolls'),
  new IdValue('131', 'NE', 'Otoe'),
  new IdValue('133', 'NE', 'Pawnee'),
  new IdValue('135', 'NE', 'Perkins'),
  new IdValue('137', 'NE', 'Phelps'),
  new IdValue('139', 'NE', 'Pierce'),
  new IdValue('141', 'NE', 'Platte'),
  new IdValue('143', 'NE', 'Polk'),
  new IdValue('145', 'NE', 'Red Willow'),
  new IdValue('147', 'NE', 'Richardson'),
  new IdValue('149', 'NE', 'Rock'),
  new IdValue('151', 'NE', 'Saline'),
  new IdValue('153', 'NE', 'Sarpy'),
  new IdValue('155', 'NE', 'Saunders'),
  new IdValue('157', 'NE', 'Scotts Bluff'),
  new IdValue('159', 'NE', 'Seward'),
  new IdValue('161', 'NE', 'Sheridan'),
  new IdValue('163', 'NE', 'Sherman'),
  new IdValue('165', 'NE', 'Sioux'),
  new IdValue('167', 'NE', 'Stanton'),
  new IdValue('169', 'NE', 'Thayer'),
  new IdValue('171', 'NE', 'Thomas'),
  new IdValue('173', 'NE', 'Thurston'),
  new IdValue('175', 'NE', 'Valley'),
  new IdValue('177', 'NE', 'Washington'),
  new IdValue('179', 'NE', 'Wayne'),
  new IdValue('181', 'NE', 'Webster'),
  new IdValue('183', 'NE', 'Wheeler'),
  new IdValue('185', 'NE', 'York'),
  new IdValue('1', 'NH', 'Belknap'),
  new IdValue('3', 'NH', 'Carroll'),
  new IdValue('5', 'NH', 'Cheshire'),
  new IdValue('7', 'NH', 'Coos'),
  new IdValue('9', 'NH', 'Grafton'),
  new IdValue('11', 'NH', 'Hillsborough'),
  new IdValue('13', 'NH', 'Merrimack'),
  new IdValue('15', 'NH', 'Rockingham'),
  new IdValue('17', 'NH', 'Strafford'),
  new IdValue('19', 'NH', 'Sullivan'),
  new IdValue('1', 'NJ', 'Atlantic'),
  new IdValue('3', 'NJ', 'Bergen'),
  new IdValue('5', 'NJ', 'Burlington'),
  new IdValue('7', 'NJ', 'Camden'),
  new IdValue('9', 'NJ', 'Cape May'),
  new IdValue('11', 'NJ', 'Cumberland'),
  new IdValue('13', 'NJ', 'Essex'),
  new IdValue('15', 'NJ', 'Gloucester'),
  new IdValue('17', 'NJ', 'Hudson'),
  new IdValue('19', 'NJ', 'Hunterdon'),
  new IdValue('21', 'NJ', 'Mercer'),
  new IdValue('23', 'NJ', 'Middlesex'),
  new IdValue('25', 'NJ', 'Monmouth'),
  new IdValue('27', 'NJ', 'Morris'),
  new IdValue('29', 'NJ', 'Ocean'),
  new IdValue('31', 'NJ', 'Passaic'),
  new IdValue('33', 'NJ', 'Salem'),
  new IdValue('35', 'NJ', 'Somerset'),
  new IdValue('37', 'NJ', 'Sussex'),
  new IdValue('39', 'NJ', 'Union'),
  new IdValue('41', 'NJ', 'Warren'),
  new IdValue('1', 'NM', 'Bernalillo'),
  new IdValue('3', 'NM', 'Catron'),
  new IdValue('5', 'NM', 'Chaves'),
  new IdValue('6', 'NM', 'Cibola'),
  new IdValue('7', 'NM', 'Colfax'),
  new IdValue('9', 'NM', 'Curry'),
  new IdValue('11', 'NM', 'De Baca'),
  new IdValue('13', 'NM', 'Dona Ana'),
  new IdValue('15', 'NM', 'Eddy'),
  new IdValue('17', 'NM', 'Grant'),
  new IdValue('19', 'NM', 'Guadalupe'),
  new IdValue('21', 'NM', 'Harding'),
  new IdValue('23', 'NM', 'Hidalgo'),
  new IdValue('25', 'NM', 'Lea'),
  new IdValue('27', 'NM', 'Lincoln'),
  new IdValue('28', 'NM', 'Los Alamos'),
  new IdValue('29', 'NM', 'Luna'),
  new IdValue('31', 'NM', 'McKinley'),
  new IdValue('33', 'NM', 'Mora'),
  new IdValue('35', 'NM', 'Otero'),
  new IdValue('37', 'NM', 'Quay'),
  new IdValue('39', 'NM', 'Rio Arriba'),
  new IdValue('41', 'NM', 'Roosevelt'),
  new IdValue('45', 'NM', 'San Juan'),
  new IdValue('47', 'NM', 'San Miguel'),
  new IdValue('43', 'NM', 'Sandoval'),
  new IdValue('49', 'NM', 'Santa Fe'),
  new IdValue('51', 'NM', 'Sierra'),
  new IdValue('53', 'NM', 'Socorro'),
  new IdValue('55', 'NM', 'Taos'),
  new IdValue('57', 'NM', 'Torrance'),
  new IdValue('59', 'NM', 'Union'),
  new IdValue('61', 'NM', 'Valencia'),
  new IdValue('510', 'NV', 'Carson City'),
  new IdValue('1', 'NV', 'Churchill'),
  new IdValue('3', 'NV', 'Clark'),
  new IdValue('5', 'NV', 'Douglas'),
  new IdValue('7', 'NV', 'Elko'),
  new IdValue('9', 'NV', 'Esmeralda'),
  new IdValue('11', 'NV', 'Eureka'),
  new IdValue('13', 'NV', 'Humboldt'),
  new IdValue('15', 'NV', 'Lander'),
  new IdValue('17', 'NV', 'Lincoln'),
  new IdValue('19', 'NV', 'Lyon'),
  new IdValue('21', 'NV', 'Mineral'),
  new IdValue('23', 'NV', 'Nye'),
  new IdValue('27', 'NV', 'Pershing'),
  new IdValue('29', 'NV', 'Storey'),
  new IdValue('31', 'NV', 'Washoe'),
  new IdValue('33', 'NV', 'White Pine'),
  new IdValue('1', 'NY', 'Albany'),
  new IdValue('3', 'NY', 'Allegany'),
  new IdValue('5', 'NY', 'Bronx'),
  new IdValue('7', 'NY', 'Broome'),
  new IdValue('9', 'NY', 'Cattaraugus'),
  new IdValue('11', 'NY', 'Cayuga'),
  new IdValue('13', 'NY', 'Chautauqua'),
  new IdValue('15', 'NY', 'Chemung'),
  new IdValue('17', 'NY', 'Chenango'),
  new IdValue('19', 'NY', 'Clinton'),
  new IdValue('21', 'NY', 'Columbia'),
  new IdValue('23', 'NY', 'Cortland'),
  new IdValue('25', 'NY', 'Delaware'),
  new IdValue('27', 'NY', 'Dutchess'),
  new IdValue('29', 'NY', 'Erie'),
  new IdValue('31', 'NY', 'Essex'),
  new IdValue('33', 'NY', 'Franklin'),
  new IdValue('35', 'NY', 'Fulton'),
  new IdValue('37', 'NY', 'Genesee'),
  new IdValue('39', 'NY', 'Greene'),
  new IdValue('41', 'NY', 'Hamilton'),
  new IdValue('43', 'NY', 'Herkimer'),
  new IdValue('45', 'NY', 'Jefferson'),
  new IdValue('47', 'NY', 'Kings'),
  new IdValue('49', 'NY', 'Lewis'),
  new IdValue('51', 'NY', 'Livingston'),
  new IdValue('53', 'NY', 'Madison'),
  new IdValue('55', 'NY', 'Monroe'),
  new IdValue('57', 'NY', 'Montgomery'),
  new IdValue('59', 'NY', 'Nassau'),
  new IdValue('61', 'NY', 'New York'),
  new IdValue('63', 'NY', 'Niagara'),
  new IdValue('65', 'NY', 'Oneida'),
  new IdValue('67', 'NY', 'Onondaga'),
  new IdValue('69', 'NY', 'Ontario'),
  new IdValue('71', 'NY', 'Orange'),
  new IdValue('73', 'NY', 'Orleans'),
  new IdValue('75', 'NY', 'Oswego'),
  new IdValue('77', 'NY', 'Otsego'),
  new IdValue('79', 'NY', 'Putnam'),
  new IdValue('81', 'NY', 'Queens'),
  new IdValue('83', 'NY', 'Rensselaer'),
  new IdValue('85', 'NY', 'Richmond'),
  new IdValue('87', 'NY', 'Rockland'),
  new IdValue('91', 'NY', 'Saratoga'),
  new IdValue('93', 'NY', 'Schenectady'),
  new IdValue('95', 'NY', 'Schoharie'),
  new IdValue('97', 'NY', 'Schuyler'),
  new IdValue('99', 'NY', 'Seneca'),
  new IdValue('89', 'NY', 'St. Lawrence'),
  new IdValue('101', 'NY', 'Steuben'),
  new IdValue('103', 'NY', 'Suffolk'),
  new IdValue('105', 'NY', 'Sullivan'),
  new IdValue('107', 'NY', 'Tioga'),
  new IdValue('109', 'NY', 'Tompkins'),
  new IdValue('111', 'NY', 'Ulster'),
  new IdValue('113', 'NY', 'Warren'),
  new IdValue('115', 'NY', 'Washington'),
  new IdValue('117', 'NY', 'Wayne'),
  new IdValue('119', 'NY', 'Westchester'),
  new IdValue('121', 'NY', 'Wyoming'),
  new IdValue('123', 'NY', 'Yates'),
  new IdValue('1', 'OH', 'Adams'),
  new IdValue('3', 'OH', 'Allen'),
  new IdValue('5', 'OH', 'Ashland'),
  new IdValue('7', 'OH', 'Ashtabula'),
  new IdValue('9', 'OH', 'Athens'),
  new IdValue('11', 'OH', 'Auglaize'),
  new IdValue('13', 'OH', 'Belmont'),
  new IdValue('15', 'OH', 'Brown'),
  new IdValue('17', 'OH', 'Butler'),
  new IdValue('19', 'OH', 'Carroll'),
  new IdValue('21', 'OH', 'Champaign'),
  new IdValue('23', 'OH', 'Clark'),
  new IdValue('25', 'OH', 'Clermont'),
  new IdValue('27', 'OH', 'Clinton'),
  new IdValue('29', 'OH', 'Columbiana'),
  new IdValue('31', 'OH', 'Coshocton'),
  new IdValue('33', 'OH', 'Crawford'),
  new IdValue('35', 'OH', 'Cuyahoga'),
  new IdValue('37', 'OH', 'Darke'),
  new IdValue('39', 'OH', 'Defiance'),
  new IdValue('41', 'OH', 'Delaware'),
  new IdValue('43', 'OH', 'Erie'),
  new IdValue('45', 'OH', 'Fairfield'),
  new IdValue('47', 'OH', 'Fayette'),
  new IdValue('49', 'OH', 'Franklin'),
  new IdValue('51', 'OH', 'Fulton'),
  new IdValue('53', 'OH', 'Gallia'),
  new IdValue('55', 'OH', 'Geauga'),
  new IdValue('57', 'OH', 'Greene'),
  new IdValue('59', 'OH', 'Guernsey'),
  new IdValue('61', 'OH', 'Hamilton'),
  new IdValue('63', 'OH', 'Hancock'),
  new IdValue('65', 'OH', 'Hardin'),
  new IdValue('67', 'OH', 'Harrison'),
  new IdValue('69', 'OH', 'Henry'),
  new IdValue('71', 'OH', 'Highland'),
  new IdValue('73', 'OH', 'Hocking'),
  new IdValue('75', 'OH', 'Holmes'),
  new IdValue('77', 'OH', 'Huron'),
  new IdValue('79', 'OH', 'Jackson'),
  new IdValue('81', 'OH', 'Jefferson'),
  new IdValue('83', 'OH', 'Knox'),
  new IdValue('85', 'OH', 'Lake'),
  new IdValue('87', 'OH', 'Lawrence'),
  new IdValue('89', 'OH', 'Licking'),
  new IdValue('91', 'OH', 'Logan'),
  new IdValue('93', 'OH', 'Lorain'),
  new IdValue('95', 'OH', 'Lucas'),
  new IdValue('97', 'OH', 'Madison'),
  new IdValue('99', 'OH', 'Mahoning'),
  new IdValue('101', 'OH', 'Marion'),
  new IdValue('103', 'OH', 'Medina'),
  new IdValue('105', 'OH', 'Meigs'),
  new IdValue('107', 'OH', 'Mercer'),
  new IdValue('109', 'OH', 'Miami'),
  new IdValue('111', 'OH', 'Monroe'),
  new IdValue('113', 'OH', 'Montgomery'),
  new IdValue('115', 'OH', 'Morgan'),
  new IdValue('117', 'OH', 'Morrow'),
  new IdValue('119', 'OH', 'Muskingum'),
  new IdValue('121', 'OH', 'Noble'),
  new IdValue('123', 'OH', 'Ottawa'),
  new IdValue('125', 'OH', 'Paulding'),
  new IdValue('127', 'OH', 'Perry'),
  new IdValue('129', 'OH', 'Pickaway'),
  new IdValue('131', 'OH', 'Pike'),
  new IdValue('133', 'OH', 'Portage'),
  new IdValue('135', 'OH', 'Preble'),
  new IdValue('137', 'OH', 'Putnam'),
  new IdValue('139', 'OH', 'Richland'),
  new IdValue('141', 'OH', 'Ross'),
  new IdValue('143', 'OH', 'Sandusky'),
  new IdValue('145', 'OH', 'Scioto'),
  new IdValue('147', 'OH', 'Seneca'),
  new IdValue('149', 'OH', 'Shelby'),
  new IdValue('151', 'OH', 'Stark'),
  new IdValue('153', 'OH', 'Summit'),
  new IdValue('155', 'OH', 'Trumbull'),
  new IdValue('157', 'OH', 'Tuscarawas'),
  new IdValue('159', 'OH', 'Union'),
  new IdValue('161', 'OH', 'Van Wert'),
  new IdValue('163', 'OH', 'Vinton'),
  new IdValue('165', 'OH', 'Warren'),
  new IdValue('167', 'OH', 'Washington'),
  new IdValue('169', 'OH', 'Wayne'),
  new IdValue('171', 'OH', 'Williams'),
  new IdValue('173', 'OH', 'Wood'),
  new IdValue('175', 'OH', 'Wyandot'),
  new IdValue('1', 'OK', 'Adair'),
  new IdValue('3', 'OK', 'Alfalfa'),
  new IdValue('5', 'OK', 'Atoka'),
  new IdValue('7', 'OK', 'Beaver'),
  new IdValue('9', 'OK', 'Beckham'),
  new IdValue('11', 'OK', 'Blaine'),
  new IdValue('13', 'OK', 'Bryan'),
  new IdValue('15', 'OK', 'Caddo'),
  new IdValue('17', 'OK', 'Canadian'),
  new IdValue('19', 'OK', 'Carter'),
  new IdValue('21', 'OK', 'Cherokee'),
  new IdValue('23', 'OK', 'Choctaw'),
  new IdValue('25', 'OK', 'Cimarron'),
  new IdValue('27', 'OK', 'Cleveland'),
  new IdValue('29', 'OK', 'Coal'),
  new IdValue('31', 'OK', 'Comanche'),
  new IdValue('33', 'OK', 'Cotton'),
  new IdValue('35', 'OK', 'Craig'),
  new IdValue('37', 'OK', 'Creek'),
  new IdValue('39', 'OK', 'Custer'),
  new IdValue('41', 'OK', 'Delaware'),
  new IdValue('43', 'OK', 'Dewey'),
  new IdValue('45', 'OK', 'Ellis'),
  new IdValue('47', 'OK', 'Garfield'),
  new IdValue('49', 'OK', 'Garvin'),
  new IdValue('51', 'OK', 'Grady'),
  new IdValue('53', 'OK', 'Grant'),
  new IdValue('55', 'OK', 'Greer'),
  new IdValue('57', 'OK', 'Harmon'),
  new IdValue('59', 'OK', 'Harper'),
  new IdValue('61', 'OK', 'Haskell'),
  new IdValue('63', 'OK', 'Hughes'),
  new IdValue('65', 'OK', 'Jackson'),
  new IdValue('67', 'OK', 'Jefferson'),
  new IdValue('69', 'OK', 'Johnston'),
  new IdValue('71', 'OK', 'Kay'),
  new IdValue('73', 'OK', 'Kingfisher'),
  new IdValue('75', 'OK', 'Kiowa'),
  new IdValue('77', 'OK', 'Latimer'),
  new IdValue('79', 'OK', 'Le Flore'),
  new IdValue('81', 'OK', 'Lincoln'),
  new IdValue('83', 'OK', 'Logan'),
  new IdValue('85', 'OK', 'Love'),
  new IdValue('93', 'OK', 'Major'),
  new IdValue('95', 'OK', 'Marshall'),
  new IdValue('97', 'OK', 'Mayes'),
  new IdValue('87', 'OK', 'McClain'),
  new IdValue('89', 'OK', 'McCurtain'),
  new IdValue('91', 'OK', 'McIntosh'),
  new IdValue('99', 'OK', 'Murray'),
  new IdValue('101', 'OK', 'Muskogee'),
  new IdValue('103', 'OK', 'Noble'),
  new IdValue('105', 'OK', 'Nowata'),
  new IdValue('107', 'OK', 'Okfuskee'),
  new IdValue('109', 'OK', 'Oklahoma'),
  new IdValue('111', 'OK', 'Okmulgee'),
  new IdValue('113', 'OK', 'Osage'),
  new IdValue('115', 'OK', 'Ottawa'),
  new IdValue('117', 'OK', 'Pawnee'),
  new IdValue('119', 'OK', 'Payne'),
  new IdValue('121', 'OK', 'Pittsburg'),
  new IdValue('123', 'OK', 'Pontotoc'),
  new IdValue('125', 'OK', 'Pottawatomie'),
  new IdValue('127', 'OK', 'Pushmataha'),
  new IdValue('129', 'OK', 'Roger Mills'),
  new IdValue('131', 'OK', 'Rogers'),
  new IdValue('133', 'OK', 'Seminole'),
  new IdValue('135', 'OK', 'Sequoyah'),
  new IdValue('137', 'OK', 'Stephens'),
  new IdValue('139', 'OK', 'Texas'),
  new IdValue('141', 'OK', 'Tillman'),
  new IdValue('143', 'OK', 'Tulsa'),
  new IdValue('145', 'OK', 'Wagoner'),
  new IdValue('147', 'OK', 'Washington'),
  new IdValue('149', 'OK', 'Washita'),
  new IdValue('151', 'OK', 'Woods'),
  new IdValue('153', 'OK', 'Woodward'),
  new IdValue('1', 'OR', 'Baker'),
  new IdValue('3', 'OR', 'Benton'),
  new IdValue('5', 'OR', 'Clackamas'),
  new IdValue('7', 'OR', 'Clatsop'),
  new IdValue('9', 'OR', 'Columbia'),
  new IdValue('11', 'OR', 'Coos'),
  new IdValue('13', 'OR', 'Crook'),
  new IdValue('15', 'OR', 'Curry'),
  new IdValue('17', 'OR', 'Deschutes'),
  new IdValue('19', 'OR', 'Douglas'),
  new IdValue('21', 'OR', 'Gilliam'),
  new IdValue('23', 'OR', 'Grant'),
  new IdValue('25', 'OR', 'Harney'),
  new IdValue('27', 'OR', 'Hood River'),
  new IdValue('29', 'OR', 'Jackson'),
  new IdValue('31', 'OR', 'Jefferson'),
  new IdValue('33', 'OR', 'Josephine'),
  new IdValue('35', 'OR', 'Klamath'),
  new IdValue('37', 'OR', 'Lake'),
  new IdValue('39', 'OR', 'Lane'),
  new IdValue('41', 'OR', 'Lincoln'),
  new IdValue('43', 'OR', 'Linn'),
  new IdValue('45', 'OR', 'Malheur'),
  new IdValue('47', 'OR', 'Marion'),
  new IdValue('49', 'OR', 'Morrow'),
  new IdValue('51', 'OR', 'Multnomah'),
  new IdValue('53', 'OR', 'Polk'),
  new IdValue('55', 'OR', 'Sherman'),
  new IdValue('57', 'OR', 'Tillamook'),
  new IdValue('59', 'OR', 'Umatilla'),
  new IdValue('61', 'OR', 'Union'),
  new IdValue('63', 'OR', 'Wallowa'),
  new IdValue('65', 'OR', 'Wasco'),
  new IdValue('67', 'OR', 'Washington'),
  new IdValue('69', 'OR', 'Wheeler'),
  new IdValue('71', 'OR', 'Yamhill'),
  new IdValue('1', 'PA', 'Adams'),
  new IdValue('3', 'PA', 'Allegheny'),
  new IdValue('5', 'PA', 'Armstrong'),
  new IdValue('7', 'PA', 'Beaver'),
  new IdValue('9', 'PA', 'Bedford'),
  new IdValue('11', 'PA', 'Berks'),
  new IdValue('13', 'PA', 'Blair'),
  new IdValue('15', 'PA', 'Bradford'),
  new IdValue('17', 'PA', 'Bucks'),
  new IdValue('19', 'PA', 'Butler'),
  new IdValue('21', 'PA', 'Cambria'),
  new IdValue('23', 'PA', 'Cameron'),
  new IdValue('25', 'PA', 'Carbon'),
  new IdValue('27', 'PA', 'Centre'),
  new IdValue('29', 'PA', 'Chester'),
  new IdValue('31', 'PA', 'Clarion'),
  new IdValue('33', 'PA', 'Clearfield'),
  new IdValue('35', 'PA', 'Clinton'),
  new IdValue('37', 'PA', 'Columbia'),
  new IdValue('39', 'PA', 'Crawford'),
  new IdValue('41', 'PA', 'Cumberland'),
  new IdValue('43', 'PA', 'Dauphin'),
  new IdValue('45', 'PA', 'Delaware'),
  new IdValue('47', 'PA', 'Elk'),
  new IdValue('49', 'PA', 'Erie'),
  new IdValue('51', 'PA', 'Fayette'),
  new IdValue('53', 'PA', 'Forest'),
  new IdValue('55', 'PA', 'Franklin'),
  new IdValue('57', 'PA', 'Fulton'),
  new IdValue('59', 'PA', 'Greene'),
  new IdValue('61', 'PA', 'Huntingdon'),
  new IdValue('63', 'PA', 'Indiana'),
  new IdValue('65', 'PA', 'Jefferson'),
  new IdValue('67', 'PA', 'Juniata'),
  new IdValue('69', 'PA', 'Lackawanna'),
  new IdValue('71', 'PA', 'Lancaster'),
  new IdValue('73', 'PA', 'Lawrence'),
  new IdValue('75', 'PA', 'Lebanon'),
  new IdValue('77', 'PA', 'Lehigh'),
  new IdValue('79', 'PA', 'Luzerne'),
  new IdValue('81', 'PA', 'Lycoming'),
  new IdValue('83', 'PA', 'McKean'),
  new IdValue('85', 'PA', 'Mercer'),
  new IdValue('87', 'PA', 'Mifflin'),
  new IdValue('89', 'PA', 'Monroe'),
  new IdValue('91', 'PA', 'Montgomery'),
  new IdValue('93', 'PA', 'Montour'),
  new IdValue('95', 'PA', 'Northampton'),
  new IdValue('97', 'PA', 'Northumberland'),
  new IdValue('99', 'PA', 'Perry'),
  new IdValue('101', 'PA', 'Philadelphia'),
  new IdValue('103', 'PA', 'Pike'),
  new IdValue('105', 'PA', 'Potter'),
  new IdValue('107', 'PA', 'Schuylkill'),
  new IdValue('109', 'PA', 'Snyder'),
  new IdValue('111', 'PA', 'Somerset'),
  new IdValue('113', 'PA', 'Sullivan'),
  new IdValue('115', 'PA', 'Susquehanna'),
  new IdValue('117', 'PA', 'Tioga'),
  new IdValue('119', 'PA', 'Union'),
  new IdValue('121', 'PA', 'Venango'),
  new IdValue('123', 'PA', 'Warren'),
  new IdValue('125', 'PA', 'Washington'),
  new IdValue('127', 'PA', 'Wayne'),
  new IdValue('129', 'PA', 'Westmoreland'),
  new IdValue('131', 'PA', 'Wyoming'),
  new IdValue('133', 'PA', 'York'),
  new IdValue('1', 'PR', 'Adjuntas'),
  new IdValue('3', 'PR', 'Aguada'),
  new IdValue('5', 'PR', 'Aguadilla'),
  new IdValue('7', 'PR', 'Aguas Buenas'),
  new IdValue('9', 'PR', 'Aibonito'),
  new IdValue('11', 'PR', 'Anasco'),
  new IdValue('13', 'PR', 'Arecibo'),
  new IdValue('15', 'PR', 'Arroyo'),
  new IdValue('17', 'PR', 'Barceloneta'),
  new IdValue('19', 'PR', 'Barranquitas'),
  new IdValue('21', 'PR', 'Bayamon'),
  new IdValue('23', 'PR', 'Cabo Rojo'),
  new IdValue('25', 'PR', 'Caguas'),
  new IdValue('27', 'PR', 'Camuy'),
  new IdValue('29', 'PR', 'Canovanas'),
  new IdValue('31', 'PR', 'Carolina'),
  new IdValue('33', 'PR', 'Catano'),
  new IdValue('35', 'PR', 'Cayey'),
  new IdValue('37', 'PR', 'Ceiba'),
  new IdValue('39', 'PR', 'Ciales'),
  new IdValue('41', 'PR', 'Cidra'),
  new IdValue('43', 'PR', 'Coamo'),
  new IdValue('45', 'PR', 'Comerio'),
  new IdValue('47', 'PR', 'Corozal'),
  new IdValue('49', 'PR', 'Culebra'),
  new IdValue('51', 'PR', 'Dorado'),
  new IdValue('53', 'PR', 'Fajardo'),
  new IdValue('54', 'PR', 'Florida'),
  new IdValue('55', 'PR', 'Guanica'),
  new IdValue('57', 'PR', 'Guayama'),
  new IdValue('59', 'PR', 'Guayanilla'),
  new IdValue('61', 'PR', 'Guaynabo'),
  new IdValue('63', 'PR', 'Gurabo'),
  new IdValue('65', 'PR', 'Hatillo'),
  new IdValue('67', 'PR', 'Hormigueros'),
  new IdValue('69', 'PR', 'Humacao'),
  new IdValue('71', 'PR', 'Isabela'),
  new IdValue('73', 'PR', 'Jayuya'),
  new IdValue('75', 'PR', 'Juana Diaz'),
  new IdValue('77', 'PR', 'Juncos'),
  new IdValue('79', 'PR', 'Lajas'),
  new IdValue('81', 'PR', 'Lares'),
  new IdValue('83', 'PR', 'Las Marias'),
  new IdValue('85', 'PR', 'Las Piedras'),
  new IdValue('87', 'PR', 'Loiza'),
  new IdValue('89', 'PR', 'Luquillo'),
  new IdValue('91', 'PR', 'Manati'),
  new IdValue('93', 'PR', 'Maricao'),
  new IdValue('95', 'PR', 'Maunabo'),
  new IdValue('97', 'PR', 'Mayaguez'),
  new IdValue('99', 'PR', 'Moca'),
  new IdValue('101', 'PR', 'Morovis'),
  new IdValue('103', 'PR', 'Naguabo'),
  new IdValue('105', 'PR', 'Naranjito'),
  new IdValue('107', 'PR', 'Orocovis'),
  new IdValue('109', 'PR', 'Patillas'),
  new IdValue('111', 'PR', 'Penuelas'),
  new IdValue('113', 'PR', 'Ponce'),
  new IdValue('115', 'PR', 'Quebradillas'),
  new IdValue('117', 'PR', 'Rincon'),
  new IdValue('119', 'PR', 'Rio Grande'),
  new IdValue('121', 'PR', 'Sabana Grande'),
  new IdValue('123', 'PR', 'Salinas'),
  new IdValue('125', 'PR', 'San German'),
  new IdValue('127', 'PR', 'San Juan'),
  new IdValue('129', 'PR', 'San Lorenzo'),
  new IdValue('131', 'PR', 'San Sebastian'),
  new IdValue('133', 'PR', 'Santa Isabel'),
  new IdValue('135', 'PR', 'Toa Alta'),
  new IdValue('137', 'PR', 'Toa Baja'),
  new IdValue('139', 'PR', 'Trujillo Alto'),
  new IdValue('141', 'PR', 'Utuado'),
  new IdValue('143', 'PR', 'Vega Alta'),
  new IdValue('145', 'PR', 'Vega Baja'),
  new IdValue('147', 'PR', 'Vieques'),
  new IdValue('149', 'PR', 'Villalba'),
  new IdValue('151', 'PR', 'Yabucoa'),
  new IdValue('153', 'PR', 'Yauco'),
  new IdValue('1', 'RI', 'Bristol'),
  new IdValue('3', 'RI', 'Kent'),
  new IdValue('5', 'RI', 'Newport'),
  new IdValue('7', 'RI', 'Providence'),
  new IdValue('9', 'RI', 'Washington'),
  new IdValue('1', 'SC', 'Abbeville'),
  new IdValue('3', 'SC', 'Aiken'),
  new IdValue('5', 'SC', 'Allendale'),
  new IdValue('7', 'SC', 'Anderson'),
  new IdValue('9', 'SC', 'Bamberg'),
  new IdValue('11', 'SC', 'Barnwell'),
  new IdValue('13', 'SC', 'Beaufort'),
  new IdValue('15', 'SC', 'Berkeley'),
  new IdValue('17', 'SC', 'Calhoun'),
  new IdValue('19', 'SC', 'Charleston'),
  new IdValue('21', 'SC', 'Cherokee'),
  new IdValue('23', 'SC', 'Chester'),
  new IdValue('25', 'SC', 'Chesterfield'),
  new IdValue('27', 'SC', 'Clarendon'),
  new IdValue('29', 'SC', 'Colleton'),
  new IdValue('31', 'SC', 'Darlington'),
  new IdValue('33', 'SC', 'Dillon'),
  new IdValue('35', 'SC', 'Dorchester'),
  new IdValue('37', 'SC', 'Edgefield'),
  new IdValue('39', 'SC', 'Fairfield'),
  new IdValue('41', 'SC', 'Florence'),
  new IdValue('43', 'SC', 'Georgetown'),
  new IdValue('45', 'SC', 'Greenville'),
  new IdValue('47', 'SC', 'Greenwood'),
  new IdValue('49', 'SC', 'Hampton'),
  new IdValue('51', 'SC', 'Horry'),
  new IdValue('53', 'SC', 'Jasper'),
  new IdValue('55', 'SC', 'Kershaw'),
  new IdValue('57', 'SC', 'Lancaster'),
  new IdValue('59', 'SC', 'Laurens'),
  new IdValue('61', 'SC', 'Lee'),
  new IdValue('63', 'SC', 'Lexington'),
  new IdValue('67', 'SC', 'Marion'),
  new IdValue('69', 'SC', 'Marlboro'),
  new IdValue('65', 'SC', 'McCormick'),
  new IdValue('71', 'SC', 'Newberry'),
  new IdValue('73', 'SC', 'Oconee'),
  new IdValue('75', 'SC', 'Orangeburg'),
  new IdValue('77', 'SC', 'Pickens'),
  new IdValue('79', 'SC', 'Richland'),
  new IdValue('81', 'SC', 'Saluda'),
  new IdValue('83', 'SC', 'Spartanburg'),
  new IdValue('85', 'SC', 'Sumter'),
  new IdValue('87', 'SC', 'Union'),
  new IdValue('89', 'SC', 'Williamsburg'),
  new IdValue('91', 'SC', 'York'),
  new IdValue('3', 'SD', 'Aurora'),
  new IdValue('5', 'SD', 'Beadle'),
  new IdValue('7', 'SD', 'Bennett'),
  new IdValue('9', 'SD', 'Bon Homme'),
  new IdValue('11', 'SD', 'Brookings'),
  new IdValue('13', 'SD', 'Brown'),
  new IdValue('15', 'SD', 'Brule'),
  new IdValue('17', 'SD', 'Buffalo'),
  new IdValue('19', 'SD', 'Butte'),
  new IdValue('21', 'SD', 'Campbell'),
  new IdValue('23', 'SD', 'Charles Mix'),
  new IdValue('25', 'SD', 'Clark'),
  new IdValue('27', 'SD', 'Clay'),
  new IdValue('29', 'SD', 'Codington'),
  new IdValue('31', 'SD', 'Corson'),
  new IdValue('33', 'SD', 'Custer'),
  new IdValue('35', 'SD', 'Davison'),
  new IdValue('37', 'SD', 'Day'),
  new IdValue('39', 'SD', 'Deuel'),
  new IdValue('41', 'SD', 'Dewey'),
  new IdValue('43', 'SD', 'Douglas'),
  new IdValue('45', 'SD', 'Edmunds'),
  new IdValue('47', 'SD', 'Fall River'),
  new IdValue('49', 'SD', 'Faulk'),
  new IdValue('51', 'SD', 'Grant'),
  new IdValue('53', 'SD', 'Gregory'),
  new IdValue('55', 'SD', 'Haakon'),
  new IdValue('57', 'SD', 'Hamlin'),
  new IdValue('59', 'SD', 'Hand'),
  new IdValue('61', 'SD', 'Hanson'),
  new IdValue('63', 'SD', 'Harding'),
  new IdValue('65', 'SD', 'Hughes'),
  new IdValue('67', 'SD', 'Hutchinson'),
  new IdValue('69', 'SD', 'Hyde'),
  new IdValue('71', 'SD', 'Jackson'),
  new IdValue('73', 'SD', 'Jerauld'),
  new IdValue('75', 'SD', 'Jones'),
  new IdValue('77', 'SD', 'Kingsbury'),
  new IdValue('79', 'SD', 'Lake'),
  new IdValue('81', 'SD', 'Lawrence'),
  new IdValue('83', 'SD', 'Lincoln'),
  new IdValue('85', 'SD', 'Lyman'),
  new IdValue('91', 'SD', 'Marshall'),
  new IdValue('87', 'SD', 'McCook'),
  new IdValue('89', 'SD', 'McPherson'),
  new IdValue('93', 'SD', 'Meade'),
  new IdValue('95', 'SD', 'Mellette'),
  new IdValue('97', 'SD', 'Miner'),
  new IdValue('99', 'SD', 'Minnehaha'),
  new IdValue('101', 'SD', 'Moody'),
  new IdValue('102', 'SD', 'Oglala Lakota'),
  new IdValue('103', 'SD', 'Pennington'),
  new IdValue('105', 'SD', 'Perkins'),
  new IdValue('107', 'SD', 'Potter'),
  new IdValue('109', 'SD', 'Roberts'),
  new IdValue('111', 'SD', 'Sanborn'),
  new IdValue('115', 'SD', 'Spink'),
  new IdValue('117', 'SD', 'Stanley'),
  new IdValue('119', 'SD', 'Sully'),
  new IdValue('121', 'SD', 'Todd'),
  new IdValue('123', 'SD', 'Tripp'),
  new IdValue('125', 'SD', 'Turner'),
  new IdValue('127', 'SD', 'Union'),
  new IdValue('129', 'SD', 'Walworth'),
  new IdValue('135', 'SD', 'Yankton'),
  new IdValue('137', 'SD', 'Ziebach'),
  new IdValue('1', 'TN', 'Anderson'),
  new IdValue('3', 'TN', 'Bedford'),
  new IdValue('5', 'TN', 'Benton'),
  new IdValue('7', 'TN', 'Bledsoe'),
  new IdValue('9', 'TN', 'Blount'),
  new IdValue('11', 'TN', 'Bradley'),
  new IdValue('13', 'TN', 'Campbell'),
  new IdValue('15', 'TN', 'Cannon'),
  new IdValue('17', 'TN', 'Carroll'),
  new IdValue('19', 'TN', 'Carter'),
  new IdValue('21', 'TN', 'Cheatham'),
  new IdValue('23', 'TN', 'Chester'),
  new IdValue('25', 'TN', 'Claiborne'),
  new IdValue('27', 'TN', 'Clay'),
  new IdValue('29', 'TN', 'Cocke'),
  new IdValue('31', 'TN', 'Coffee'),
  new IdValue('33', 'TN', 'Crockett'),
  new IdValue('35', 'TN', 'Cumberland'),
  new IdValue('37', 'TN', 'Davidson'),
  new IdValue('39', 'TN', 'Decatur'),
  new IdValue('41', 'TN', 'DeKalb'),
  new IdValue('43', 'TN', 'Dickson'),
  new IdValue('45', 'TN', 'Dyer'),
  new IdValue('47', 'TN', 'Fayette'),
  new IdValue('49', 'TN', 'Fentress'),
  new IdValue('51', 'TN', 'Franklin'),
  new IdValue('53', 'TN', 'Gibson'),
  new IdValue('55', 'TN', 'Giles'),
  new IdValue('57', 'TN', 'Grainger'),
  new IdValue('59', 'TN', 'Greene'),
  new IdValue('61', 'TN', 'Grundy'),
  new IdValue('63', 'TN', 'Hamblen'),
  new IdValue('65', 'TN', 'Hamilton'),
  new IdValue('67', 'TN', 'Hancock'),
  new IdValue('69', 'TN', 'Hardeman'),
  new IdValue('71', 'TN', 'Hardin'),
  new IdValue('73', 'TN', 'Hawkins'),
  new IdValue('75', 'TN', 'Haywood'),
  new IdValue('77', 'TN', 'Henderson'),
  new IdValue('79', 'TN', 'Henry'),
  new IdValue('81', 'TN', 'Hickman'),
  new IdValue('83', 'TN', 'Houston'),
  new IdValue('85', 'TN', 'Humphreys'),
  new IdValue('87', 'TN', 'Jackson'),
  new IdValue('89', 'TN', 'Jefferson'),
  new IdValue('91', 'TN', 'Johnson'),
  new IdValue('93', 'TN', 'Knox'),
  new IdValue('95', 'TN', 'Lake'),
  new IdValue('97', 'TN', 'Lauderdale'),
  new IdValue('99', 'TN', 'Lawrence'),
  new IdValue('101', 'TN', 'Lewis'),
  new IdValue('103', 'TN', 'Lincoln'),
  new IdValue('105', 'TN', 'Loudon'),
  new IdValue('111', 'TN', 'Macon'),
  new IdValue('113', 'TN', 'Madison'),
  new IdValue('115', 'TN', 'Marion'),
  new IdValue('117', 'TN', 'Marshall'),
  new IdValue('119', 'TN', 'Maury'),
  new IdValue('107', 'TN', 'McMinn'),
  new IdValue('109', 'TN', 'McNairy'),
  new IdValue('121', 'TN', 'Meigs'),
  new IdValue('123', 'TN', 'Monroe'),
  new IdValue('125', 'TN', 'Montgomery'),
  new IdValue('127', 'TN', 'Moore'),
  new IdValue('129', 'TN', 'Morgan'),
  new IdValue('131', 'TN', 'Obion'),
  new IdValue('133', 'TN', 'Overton'),
  new IdValue('135', 'TN', 'Perry'),
  new IdValue('137', 'TN', 'Pickett'),
  new IdValue('139', 'TN', 'Polk'),
  new IdValue('141', 'TN', 'Putnam'),
  new IdValue('143', 'TN', 'Rhea'),
  new IdValue('145', 'TN', 'Roane'),
  new IdValue('147', 'TN', 'Robertson'),
  new IdValue('149', 'TN', 'Rutherford'),
  new IdValue('151', 'TN', 'Scott'),
  new IdValue('153', 'TN', 'Sequatchie'),
  new IdValue('155', 'TN', 'Sevier'),
  new IdValue('157', 'TN', 'Shelby'),
  new IdValue('159', 'TN', 'Smith'),
  new IdValue('161', 'TN', 'Stewart'),
  new IdValue('163', 'TN', 'Sullivan'),
  new IdValue('165', 'TN', 'Sumner'),
  new IdValue('167', 'TN', 'Tipton'),
  new IdValue('169', 'TN', 'Trousdale'),
  new IdValue('171', 'TN', 'Unicoi'),
  new IdValue('173', 'TN', 'Union'),
  new IdValue('175', 'TN', 'Van Buren'),
  new IdValue('177', 'TN', 'Warren'),
  new IdValue('179', 'TN', 'Washington'),
  new IdValue('181', 'TN', 'Wayne'),
  new IdValue('183', 'TN', 'Weakley'),
  new IdValue('185', 'TN', 'White'),
  new IdValue('187', 'TN', 'Williamson'),
  new IdValue('189', 'TN', 'Wilson'),
  new IdValue('1', 'TX', 'Anderson'),
  new IdValue('3', 'TX', 'Andrews'),
  new IdValue('5', 'TX', 'Angelina'),
  new IdValue('7', 'TX', 'Aransas'),
  new IdValue('9', 'TX', 'Archer'),
  new IdValue('11', 'TX', 'Armstrong'),
  new IdValue('13', 'TX', 'Atascosa'),
  new IdValue('15', 'TX', 'Austin'),
  new IdValue('17', 'TX', 'Bailey'),
  new IdValue('19', 'TX', 'Bandera'),
  new IdValue('21', 'TX', 'Bastrop'),
  new IdValue('23', 'TX', 'Baylor'),
  new IdValue('25', 'TX', 'Bee'),
  new IdValue('27', 'TX', 'Bell'),
  new IdValue('29', 'TX', 'Bexar'),
  new IdValue('31', 'TX', 'Blanco'),
  new IdValue('33', 'TX', 'Borden'),
  new IdValue('35', 'TX', 'Bosque'),
  new IdValue('37', 'TX', 'Bowie'),
  new IdValue('39', 'TX', 'Brazoria'),
  new IdValue('41', 'TX', 'Brazos'),
  new IdValue('43', 'TX', 'Brewster'),
  new IdValue('45', 'TX', 'Briscoe'),
  new IdValue('47', 'TX', 'Brooks'),
  new IdValue('49', 'TX', 'Brown'),
  new IdValue('51', 'TX', 'Burleson'),
  new IdValue('53', 'TX', 'Burnet'),
  new IdValue('55', 'TX', 'Caldwell'),
  new IdValue('57', 'TX', 'Calhoun'),
  new IdValue('59', 'TX', 'Callahan'),
  new IdValue('61', 'TX', 'Cameron'),
  new IdValue('63', 'TX', 'Camp'),
  new IdValue('65', 'TX', 'Carson'),
  new IdValue('67', 'TX', 'Cass'),
  new IdValue('69', 'TX', 'Castro'),
  new IdValue('71', 'TX', 'Chambers'),
  new IdValue('73', 'TX', 'Cherokee'),
  new IdValue('75', 'TX', 'Childress'),
  new IdValue('77', 'TX', 'Clay'),
  new IdValue('79', 'TX', 'Cochran'),
  new IdValue('81', 'TX', 'Coke'),
  new IdValue('83', 'TX', 'Coleman'),
  new IdValue('85', 'TX', 'Collin'),
  new IdValue('87', 'TX', 'Collingsworth'),
  new IdValue('89', 'TX', 'Colorado'),
  new IdValue('91', 'TX', 'Comal'),
  new IdValue('93', 'TX', 'Comanche'),
  new IdValue('95', 'TX', 'Concho'),
  new IdValue('97', 'TX', 'Cooke'),
  new IdValue('99', 'TX', 'Coryell'),
  new IdValue('101', 'TX', 'Cottle'),
  new IdValue('103', 'TX', 'Crane'),
  new IdValue('105', 'TX', 'Crockett'),
  new IdValue('107', 'TX', 'Crosby'),
  new IdValue('109', 'TX', 'Culberson'),
  new IdValue('111', 'TX', 'Dallam'),
  new IdValue('113', 'TX', 'Dallas'),
  new IdValue('115', 'TX', 'Dawson'),
  new IdValue('117', 'TX', 'Deaf Smith'),
  new IdValue('119', 'TX', 'Delta'),
  new IdValue('121', 'TX', 'Denton'),
  new IdValue('123', 'TX', 'DeWitt'),
  new IdValue('125', 'TX', 'Dickens'),
  new IdValue('127', 'TX', 'Dimmit'),
  new IdValue('129', 'TX', 'Donley'),
  new IdValue('131', 'TX', 'Duval'),
  new IdValue('133', 'TX', 'Eastland'),
  new IdValue('135', 'TX', 'Ector'),
  new IdValue('137', 'TX', 'Edwards'),
  new IdValue('141', 'TX', 'El Paso'),
  new IdValue('139', 'TX', 'Ellis'),
  new IdValue('143', 'TX', 'Erath'),
  new IdValue('145', 'TX', 'Falls'),
  new IdValue('147', 'TX', 'Fannin'),
  new IdValue('149', 'TX', 'Fayette'),
  new IdValue('151', 'TX', 'Fisher'),
  new IdValue('153', 'TX', 'Floyd'),
  new IdValue('155', 'TX', 'Foard'),
  new IdValue('157', 'TX', 'Fort Bend'),
  new IdValue('159', 'TX', 'Franklin'),
  new IdValue('161', 'TX', 'Freestone'),
  new IdValue('163', 'TX', 'Frio'),
  new IdValue('165', 'TX', 'Gaines'),
  new IdValue('167', 'TX', 'Galveston'),
  new IdValue('169', 'TX', 'Garza'),
  new IdValue('171', 'TX', 'Gillespie'),
  new IdValue('173', 'TX', 'Glasscock'),
  new IdValue('175', 'TX', 'Goliad'),
  new IdValue('177', 'TX', 'Gonzales'),
  new IdValue('179', 'TX', 'Gray'),
  new IdValue('181', 'TX', 'Grayson'),
  new IdValue('183', 'TX', 'Gregg'),
  new IdValue('185', 'TX', 'Grimes'),
  new IdValue('187', 'TX', 'Guadalupe'),
  new IdValue('189', 'TX', 'Hale'),
  new IdValue('191', 'TX', 'Hall'),
  new IdValue('193', 'TX', 'Hamilton'),
  new IdValue('195', 'TX', 'Hansford'),
  new IdValue('197', 'TX', 'Hardeman'),
  new IdValue('199', 'TX', 'Hardin'),
  new IdValue('201', 'TX', 'Harris'),
  new IdValue('203', 'TX', 'Harrison'),
  new IdValue('205', 'TX', 'Hartley'),
  new IdValue('207', 'TX', 'Haskell'),
  new IdValue('209', 'TX', 'Hays'),
  new IdValue('211', 'TX', 'Hemphill'),
  new IdValue('213', 'TX', 'Henderson'),
  new IdValue('215', 'TX', 'Hidalgo'),
  new IdValue('217', 'TX', 'Hill'),
  new IdValue('219', 'TX', 'Hockley'),
  new IdValue('221', 'TX', 'Hood'),
  new IdValue('223', 'TX', 'Hopkins'),
  new IdValue('225', 'TX', 'Houston'),
  new IdValue('227', 'TX', 'Howard'),
  new IdValue('229', 'TX', 'Hudspeth'),
  new IdValue('231', 'TX', 'Hunt'),
  new IdValue('233', 'TX', 'Hutchinson'),
  new IdValue('235', 'TX', 'Irion'),
  new IdValue('237', 'TX', 'Jack'),
  new IdValue('239', 'TX', 'Jackson'),
  new IdValue('241', 'TX', 'Jasper'),
  new IdValue('243', 'TX', 'Jeff Davis'),
  new IdValue('245', 'TX', 'Jefferson'),
  new IdValue('247', 'TX', 'Jim Hogg'),
  new IdValue('249', 'TX', 'Jim Wells'),
  new IdValue('251', 'TX', 'Johnson'),
  new IdValue('253', 'TX', 'Jones'),
  new IdValue('255', 'TX', 'Karnes'),
  new IdValue('257', 'TX', 'Kaufman'),
  new IdValue('259', 'TX', 'Kendall'),
  new IdValue('261', 'TX', 'Kenedy'),
  new IdValue('263', 'TX', 'Kent'),
  new IdValue('265', 'TX', 'Kerr'),
  new IdValue('267', 'TX', 'Kimble'),
  new IdValue('269', 'TX', 'King'),
  new IdValue('271', 'TX', 'Kinney'),
  new IdValue('273', 'TX', 'Kleberg'),
  new IdValue('275', 'TX', 'Knox'),
  new IdValue('283', 'TX', 'La Salle'),
  new IdValue('277', 'TX', 'Lamar'),
  new IdValue('279', 'TX', 'Lamb'),
  new IdValue('281', 'TX', 'Lampasas'),
  new IdValue('285', 'TX', 'Lavaca'),
  new IdValue('287', 'TX', 'Lee'),
  new IdValue('289', 'TX', 'Leon'),
  new IdValue('291', 'TX', 'Liberty'),
  new IdValue('293', 'TX', 'Limestone'),
  new IdValue('295', 'TX', 'Lipscomb'),
  new IdValue('297', 'TX', 'Live Oak'),
  new IdValue('299', 'TX', 'Llano'),
  new IdValue('301', 'TX', 'Loving'),
  new IdValue('303', 'TX', 'Lubbock'),
  new IdValue('305', 'TX', 'Lynn'),
  new IdValue('313', 'TX', 'Madison'),
  new IdValue('315', 'TX', 'Marion'),
  new IdValue('317', 'TX', 'Martin'),
  new IdValue('319', 'TX', 'Mason'),
  new IdValue('321', 'TX', 'Matagorda'),
  new IdValue('323', 'TX', 'Maverick'),
  new IdValue('307', 'TX', 'McCulloch'),
  new IdValue('309', 'TX', 'McLennan'),
  new IdValue('311', 'TX', 'McMullen'),
  new IdValue('325', 'TX', 'Medina'),
  new IdValue('327', 'TX', 'Menard'),
  new IdValue('329', 'TX', 'Midland'),
  new IdValue('331', 'TX', 'Milam'),
  new IdValue('333', 'TX', 'Mills'),
  new IdValue('335', 'TX', 'Mitchell'),
  new IdValue('337', 'TX', 'Montague'),
  new IdValue('339', 'TX', 'Montgomery'),
  new IdValue('341', 'TX', 'Moore'),
  new IdValue('343', 'TX', 'Morris'),
  new IdValue('345', 'TX', 'Motley'),
  new IdValue('347', 'TX', 'Nacogdoches'),
  new IdValue('349', 'TX', 'Navarro'),
  new IdValue('351', 'TX', 'Newton'),
  new IdValue('353', 'TX', 'Nolan'),
  new IdValue('355', 'TX', 'Nueces'),
  new IdValue('357', 'TX', 'Ochiltree'),
  new IdValue('359', 'TX', 'Oldham'),
  new IdValue('361', 'TX', 'Orange'),
  new IdValue('363', 'TX', 'Palo Pinto'),
  new IdValue('365', 'TX', 'Panola'),
  new IdValue('367', 'TX', 'Parker'),
  new IdValue('369', 'TX', 'Parmer'),
  new IdValue('371', 'TX', 'Pecos'),
  new IdValue('373', 'TX', 'Polk'),
  new IdValue('375', 'TX', 'Potter'),
  new IdValue('377', 'TX', 'Presidio'),
  new IdValue('379', 'TX', 'Rains'),
  new IdValue('381', 'TX', 'Randall'),
  new IdValue('383', 'TX', 'Reagan'),
  new IdValue('385', 'TX', 'Real'),
  new IdValue('387', 'TX', 'Red River'),
  new IdValue('389', 'TX', 'Reeves'),
  new IdValue('391', 'TX', 'Refugio'),
  new IdValue('393', 'TX', 'Roberts'),
  new IdValue('395', 'TX', 'Robertson'),
  new IdValue('397', 'TX', 'Rockwall'),
  new IdValue('399', 'TX', 'Runnels'),
  new IdValue('401', 'TX', 'Rusk'),
  new IdValue('403', 'TX', 'Sabine'),
  new IdValue('405', 'TX', 'San Augustine'),
  new IdValue('407', 'TX', 'San Jacinto'),
  new IdValue('409', 'TX', 'San Patricio'),
  new IdValue('411', 'TX', 'San Saba'),
  new IdValue('413', 'TX', 'Schleicher'),
  new IdValue('415', 'TX', 'Scurry'),
  new IdValue('417', 'TX', 'Shackelford'),
  new IdValue('419', 'TX', 'Shelby'),
  new IdValue('421', 'TX', 'Sherman'),
  new IdValue('423', 'TX', 'Smith'),
  new IdValue('425', 'TX', 'Somervell'),
  new IdValue('427', 'TX', 'Starr'),
  new IdValue('429', 'TX', 'Stephens'),
  new IdValue('431', 'TX', 'Sterling'),
  new IdValue('433', 'TX', 'Stonewall'),
  new IdValue('435', 'TX', 'Sutton'),
  new IdValue('437', 'TX', 'Swisher'),
  new IdValue('439', 'TX', 'Tarrant'),
  new IdValue('441', 'TX', 'Taylor'),
  new IdValue('443', 'TX', 'Terrell'),
  new IdValue('445', 'TX', 'Terry'),
  new IdValue('447', 'TX', 'Throckmorton'),
  new IdValue('449', 'TX', 'Titus'),
  new IdValue('451', 'TX', 'Tom Green'),
  new IdValue('453', 'TX', 'Travis'),
  new IdValue('455', 'TX', 'Trinity'),
  new IdValue('457', 'TX', 'Tyler'),
  new IdValue('459', 'TX', 'Upshur'),
  new IdValue('461', 'TX', 'Upton'),
  new IdValue('463', 'TX', 'Uvalde'),
  new IdValue('465', 'TX', 'Val Verde'),
  new IdValue('467', 'TX', 'Van Zandt'),
  new IdValue('469', 'TX', 'Victoria'),
  new IdValue('471', 'TX', 'Walker'),
  new IdValue('473', 'TX', 'Waller'),
  new IdValue('475', 'TX', 'Ward'),
  new IdValue('477', 'TX', 'Washington'),
  new IdValue('479', 'TX', 'Webb'),
  new IdValue('481', 'TX', 'Wharton'),
  new IdValue('483', 'TX', 'Wheeler'),
  new IdValue('485', 'TX', 'Wichita'),
  new IdValue('487', 'TX', 'Wilbarger'),
  new IdValue('489', 'TX', 'Willacy'),
  new IdValue('491', 'TX', 'Williamson'),
  new IdValue('493', 'TX', 'Wilson'),
  new IdValue('495', 'TX', 'Winkler'),
  new IdValue('497', 'TX', 'Wise'),
  new IdValue('499', 'TX', 'Wood'),
  new IdValue('501', 'TX', 'Yoakum'),
  new IdValue('503', 'TX', 'Young'),
  new IdValue('505', 'TX', 'Zapata'),
  new IdValue('507', 'TX', 'Zavala'),
  new IdValue('1', 'UT', 'Beaver'),
  new IdValue('3', 'UT', 'Box Elder'),
  new IdValue('5', 'UT', 'Cache'),
  new IdValue('7', 'UT', 'Carbon'),
  new IdValue('9', 'UT', 'Daggett'),
  new IdValue('11', 'UT', 'Davis'),
  new IdValue('13', 'UT', 'Duchesne'),
  new IdValue('15', 'UT', 'Emery'),
  new IdValue('17', 'UT', 'Garfield'),
  new IdValue('19', 'UT', 'Grand'),
  new IdValue('21', 'UT', 'Iron'),
  new IdValue('23', 'UT', 'Juab'),
  new IdValue('25', 'UT', 'Kane'),
  new IdValue('27', 'UT', 'Millard'),
  new IdValue('29', 'UT', 'Morgan'),
  new IdValue('31', 'UT', 'Piute'),
  new IdValue('33', 'UT', 'Rich'),
  new IdValue('35', 'UT', 'Salt Lake'),
  new IdValue('37', 'UT', 'San Juan'),
  new IdValue('39', 'UT', 'Sanpete'),
  new IdValue('41', 'UT', 'Sevier'),
  new IdValue('43', 'UT', 'Summit'),
  new IdValue('45', 'UT', 'Tooele'),
  new IdValue('47', 'UT', 'Uintah'),
  new IdValue('49', 'UT', 'Utah'),
  new IdValue('51', 'UT', 'Wasatch'),
  new IdValue('53', 'UT', 'Washington'),
  new IdValue('55', 'UT', 'Wayne'),
  new IdValue('57', 'UT', 'Weber'),
  new IdValue('1', 'VA', 'Accomack'),
  new IdValue('3', 'VA', 'Albemarle'),
  new IdValue('510', 'VA', 'Alexandria City'),
  new IdValue('5', 'VA', 'Alleghany'),
  new IdValue('7', 'VA', 'Amelia'),
  new IdValue('9', 'VA', 'Amherst'),
  new IdValue('11', 'VA', 'Appomattox'),
  new IdValue('13', 'VA', 'Arlington'),
  new IdValue('15', 'VA', 'Augusta'),
  new IdValue('17', 'VA', 'Bath'),
  new IdValue('19', 'VA', 'Bedford'),
  new IdValue('21', 'VA', 'Bland'),
  new IdValue('23', 'VA', 'Botetourt'),
  new IdValue('520', 'VA', 'Bristol'),
  new IdValue('25', 'VA', 'Brunswick'),
  new IdValue('27', 'VA', 'Buchanan'),
  new IdValue('29', 'VA', 'Buckingham'),
  new IdValue('530', 'VA', 'Buena Vista'),
  new IdValue('31', 'VA', 'Campbell'),
  new IdValue('33', 'VA', 'Caroline'),
  new IdValue('35', 'VA', 'Carroll'),
  new IdValue('36', 'VA', 'Charles City'),
  new IdValue('37', 'VA', 'Charlotte'),
  new IdValue('540', 'VA', 'Charlottesville'),
  new IdValue('550', 'VA', 'Chesapeake City'),
  new IdValue('41', 'VA', 'Chesterfield'),
  new IdValue('43', 'VA', 'Clarke'),
  new IdValue('570', 'VA', 'Colonial Height'),
  new IdValue('580', 'VA', 'Covington'),
  new IdValue('45', 'VA', 'Craig'),
  new IdValue('47', 'VA', 'Culpeper'),
  new IdValue('49', 'VA', 'Cumberland'),
  new IdValue('590', 'VA', 'Danville'),
  new IdValue('51', 'VA', 'Dickenson'),
  new IdValue('53', 'VA', 'Dinwiddie'),
  new IdValue('595', 'VA', 'Emporia'),
  new IdValue('57', 'VA', 'Essex'),
  new IdValue('59', 'VA', 'Fairfax'),
  new IdValue('600', 'VA', 'Fairfax City'),
  new IdValue('610', 'VA', 'Falls Church'),
  new IdValue('61', 'VA', 'Fauquier'),
  new IdValue('63', 'VA', 'Floyd'),
  new IdValue('65', 'VA', 'Fluvanna'),
  new IdValue('67', 'VA', 'Franklin'),
  new IdValue('620', 'VA', 'Franklin City'),
  new IdValue('69', 'VA', 'Frederick'),
  new IdValue('630', 'VA', 'Fredericksburg'),
  new IdValue('640', 'VA', 'Galax'),
  new IdValue('71', 'VA', 'Giles'),
  new IdValue('73', 'VA', 'Gloucester'),
  new IdValue('75', 'VA', 'Goochland'),
  new IdValue('77', 'VA', 'Grayson'),
  new IdValue('79', 'VA', 'Greene'),
  new IdValue('81', 'VA', 'Greensville'),
  new IdValue('83', 'VA', 'Halifax'),
  new IdValue('650', 'VA', 'Hampton'),
  new IdValue('85', 'VA', 'Hanover'),
  new IdValue('660', 'VA', 'Harrisonburg'),
  new IdValue('87', 'VA', 'Henrico'),
  new IdValue('89', 'VA', 'Henry'),
  new IdValue('91', 'VA', 'Highland'),
  new IdValue('670', 'VA', 'Hopewell'),
  new IdValue('93', 'VA', 'Isle of Wight'),
  new IdValue('95', 'VA', 'James City'),
  new IdValue('97', 'VA', 'King and Queen'),
  new IdValue('99', 'VA', 'King George'),
  new IdValue('101', 'VA', 'King William'),
  new IdValue('103', 'VA', 'Lancaster'),
  new IdValue('105', 'VA', 'Lee'),
  new IdValue('678', 'VA', 'Lexington'),
  new IdValue('107', 'VA', 'Loudoun'),
  new IdValue('109', 'VA', 'Louisa'),
  new IdValue('111', 'VA', 'Lunenburg'),
  new IdValue('680', 'VA', 'Lynchburg City'),
  new IdValue('113', 'VA', 'Madison'),
  new IdValue('683', 'VA', 'Manassas'),
  new IdValue('685', 'VA', 'Manassas Park'),
  new IdValue('690', 'VA', 'Martinsville'),
  new IdValue('115', 'VA', 'Mathews'),
  new IdValue('117', 'VA', 'Mecklenburg'),
  new IdValue('119', 'VA', 'Middlesex'),
  new IdValue('121', 'VA', 'Montgomery'),
  new IdValue('125', 'VA', 'Nelson'),
  new IdValue('127', 'VA', 'New Kent'),
  new IdValue('700', 'VA', 'Newport News'),
  new IdValue('710', 'VA', 'Norfolk'),
  new IdValue('131', 'VA', 'Northampton'),
  new IdValue('133', 'VA', 'Northumberland'),
  new IdValue('720', 'VA', 'Norton'),
  new IdValue('135', 'VA', 'Nottoway'),
  new IdValue('137', 'VA', 'Orange'),
  new IdValue('139', 'VA', 'Page'),
  new IdValue('141', 'VA', 'Patrick'),
  new IdValue('730', 'VA', 'Petersburg'),
  new IdValue('143', 'VA', 'Pittsylvania'),
  new IdValue('735', 'VA', 'Poquoson'),
  new IdValue('740', 'VA', 'Portsmouth'),
  new IdValue('145', 'VA', 'Powhatan'),
  new IdValue('147', 'VA', 'Prince Edward'),
  new IdValue('149', 'VA', 'Prince George'),
  new IdValue('153', 'VA', 'Prince William'),
  new IdValue('155', 'VA', 'Pulaski'),
  new IdValue('750', 'VA', 'Radford'),
  new IdValue('157', 'VA', 'Rappahannock'),
  new IdValue('159', 'VA', 'Richmond'),
  new IdValue('760', 'VA', 'Richmond City'),
  new IdValue('161', 'VA', 'Roanoke'),
  new IdValue('770', 'VA', 'Roanoke City'),
  new IdValue('163', 'VA', 'Rockbridge'),
  new IdValue('165', 'VA', 'Rockingham'),
  new IdValue('167', 'VA', 'Russell'),
  new IdValue('775', 'VA', 'Salem'),
  new IdValue('169', 'VA', 'Scott'),
  new IdValue('171', 'VA', 'Shenandoah'),
  new IdValue('173', 'VA', 'Smyth'),
  new IdValue('175', 'VA', 'Southampton'),
  new IdValue('177', 'VA', 'Spotsylvania'),
  new IdValue('179', 'VA', 'Stafford'),
  new IdValue('790', 'VA', 'Staunton'),
  new IdValue('800', 'VA', 'Suffolk City'),
  new IdValue('181', 'VA', 'Surry'),
  new IdValue('183', 'VA', 'Sussex'),
  new IdValue('185', 'VA', 'Tazewell'),
  new IdValue('810', 'VA', 'Virginia Beach City'),
  new IdValue('187', 'VA', 'Warren'),
  new IdValue('191', 'VA', 'Washington'),
  new IdValue('820', 'VA', 'Waynesboro'),
  new IdValue('193', 'VA', 'Westmoreland'),
  new IdValue('830', 'VA', 'Williamsburg'),
  new IdValue('840', 'VA', 'Winchester City'),
  new IdValue('195', 'VA', 'Wise'),
  new IdValue('197', 'VA', 'Wythe'),
  new IdValue('199', 'VA', 'York'),
  new IdValue('10', 'VI', 'St. Croix'),
  new IdValue('20', 'VI', 'St. John'),
  new IdValue('30', 'VI', 'St. Thomas'),
  new IdValue('1', 'VT', 'Addison'),
  new IdValue('3', 'VT', 'Bennington'),
  new IdValue('5', 'VT', 'Caledonia'),
  new IdValue('7', 'VT', 'Chittenden'),
  new IdValue('9', 'VT', 'Essex'),
  new IdValue('11', 'VT', 'Franklin'),
  new IdValue('13', 'VT', 'Grand Isle'),
  new IdValue('15', 'VT', 'Lamoille'),
  new IdValue('17', 'VT', 'Orange'),
  new IdValue('19', 'VT', 'Orleans'),
  new IdValue('21', 'VT', 'Rutland'),
  new IdValue('23', 'VT', 'Washington'),
  new IdValue('25', 'VT', 'Windham'),
  new IdValue('27', 'VT', 'Windsor'),
  new IdValue('1', 'WA', 'Adams'),
  new IdValue('3', 'WA', 'Asotin'),
  new IdValue('5', 'WA', 'Benton'),
  new IdValue('7', 'WA', 'Chelan'),
  new IdValue('9', 'WA', 'Clallam'),
  new IdValue('11', 'WA', 'Clark'),
  new IdValue('13', 'WA', 'Columbia'),
  new IdValue('15', 'WA', 'Cowlitz'),
  new IdValue('17', 'WA', 'Douglas'),
  new IdValue('19', 'WA', 'Ferry'),
  new IdValue('21', 'WA', 'Franklin'),
  new IdValue('23', 'WA', 'Garfield'),
  new IdValue('25', 'WA', 'Grant'),
  new IdValue('27', 'WA', 'Grays Harbor'),
  new IdValue('29', 'WA', 'Island'),
  new IdValue('31', 'WA', 'Jefferson'),
  new IdValue('33', 'WA', 'King'),
  new IdValue('35', 'WA', 'Kitsap'),
  new IdValue('37', 'WA', 'Kittitas'),
  new IdValue('39', 'WA', 'Klickitat'),
  new IdValue('41', 'WA', 'Lewis'),
  new IdValue('43', 'WA', 'Lincoln'),
  new IdValue('45', 'WA', 'Mason'),
  new IdValue('47', 'WA', 'Okanogan'),
  new IdValue('49', 'WA', 'Pacific'),
  new IdValue('51', 'WA', 'Pend Oreille'),
  new IdValue('53', 'WA', 'Pierce'),
  new IdValue('55', 'WA', 'San Juan'),
  new IdValue('57', 'WA', 'Skagit'),
  new IdValue('59', 'WA', 'Skamania'),
  new IdValue('61', 'WA', 'Snohomish'),
  new IdValue('63', 'WA', 'Spokane'),
  new IdValue('65', 'WA', 'Stevens'),
  new IdValue('67', 'WA', 'Thurston'),
  new IdValue('69', 'WA', 'Wahkiakum'),
  new IdValue('71', 'WA', 'Walla Walla'),
  new IdValue('73', 'WA', 'Whatcom'),
  new IdValue('75', 'WA', 'Whitman'),
  new IdValue('77', 'WA', 'Yakima'),
  new IdValue('1', 'WI', 'Adams'),
  new IdValue('3', 'WI', 'Ashland'),
  new IdValue('5', 'WI', 'Barron'),
  new IdValue('7', 'WI', 'Bayfield'),
  new IdValue('9', 'WI', 'Brown'),
  new IdValue('11', 'WI', 'Buffalo'),
  new IdValue('13', 'WI', 'Burnett'),
  new IdValue('15', 'WI', 'Calumet'),
  new IdValue('17', 'WI', 'Chippewa'),
  new IdValue('19', 'WI', 'Clark'),
  new IdValue('21', 'WI', 'Columbia'),
  new IdValue('23', 'WI', 'Crawford'),
  new IdValue('25', 'WI', 'Dane'),
  new IdValue('27', 'WI', 'Dodge'),
  new IdValue('29', 'WI', 'Door'),
  new IdValue('31', 'WI', 'Douglas'),
  new IdValue('33', 'WI', 'Dunn'),
  new IdValue('35', 'WI', 'Eau Claire'),
  new IdValue('37', 'WI', 'Florence'),
  new IdValue('39', 'WI', 'Fond du Lac'),
  new IdValue('41', 'WI', 'Forest'),
  new IdValue('43', 'WI', 'Grant'),
  new IdValue('45', 'WI', 'Green'),
  new IdValue('47', 'WI', 'Green Lake'),
  new IdValue('49', 'WI', 'Iowa'),
  new IdValue('51', 'WI', 'Iron'),
  new IdValue('53', 'WI', 'Jackson'),
  new IdValue('55', 'WI', 'Jefferson'),
  new IdValue('57', 'WI', 'Juneau'),
  new IdValue('59', 'WI', 'Kenosha'),
  new IdValue('61', 'WI', 'Kewaunee'),
  new IdValue('63', 'WI', 'La Crosse'),
  new IdValue('65', 'WI', 'Lafayette'),
  new IdValue('67', 'WI', 'Langlade'),
  new IdValue('69', 'WI', 'Lincoln'),
  new IdValue('71', 'WI', 'Manitowoc'),
  new IdValue('73', 'WI', 'Marathon'),
  new IdValue('75', 'WI', 'Marinette'),
  new IdValue('77', 'WI', 'Marquette'),
  new IdValue('78', 'WI', 'Menominee'),
  new IdValue('79', 'WI', 'Milwaukee'),
  new IdValue('81', 'WI', 'Monroe'),
  new IdValue('83', 'WI', 'Oconto'),
  new IdValue('85', 'WI', 'Oneida'),
  new IdValue('87', 'WI', 'Outagamie'),
  new IdValue('89', 'WI', 'Ozaukee'),
  new IdValue('91', 'WI', 'Pepin'),
  new IdValue('93', 'WI', 'Pierce'),
  new IdValue('95', 'WI', 'Polk'),
  new IdValue('97', 'WI', 'Portage'),
  new IdValue('99', 'WI', 'Price'),
  new IdValue('101', 'WI', 'Racine'),
  new IdValue('103', 'WI', 'Richland'),
  new IdValue('105', 'WI', 'Rock'),
  new IdValue('107', 'WI', 'Rusk'),
  new IdValue('111', 'WI', 'Sauk'),
  new IdValue('113', 'WI', 'Sawyer'),
  new IdValue('115', 'WI', 'Shawano'),
  new IdValue('117', 'WI', 'Sheboygan'),
  new IdValue('109', 'WI', 'St. Croix'),
  new IdValue('119', 'WI', 'Taylor'),
  new IdValue('121', 'WI', 'Trempealeau'),
  new IdValue('123', 'WI', 'Vernon'),
  new IdValue('125', 'WI', 'Vilas'),
  new IdValue('127', 'WI', 'Walworth'),
  new IdValue('129', 'WI', 'Washburn'),
  new IdValue('131', 'WI', 'Washington'),
  new IdValue('133', 'WI', 'Waukesha'),
  new IdValue('135', 'WI', 'Waupaca'),
  new IdValue('137', 'WI', 'Waushara'),
  new IdValue('139', 'WI', 'Winnebago'),
  new IdValue('141', 'WI', 'Wood'),
  new IdValue('1', 'WV', 'Barbour'),
  new IdValue('3', 'WV', 'Berkeley'),
  new IdValue('5', 'WV', 'Boone'),
  new IdValue('7', 'WV', 'Braxton'),
  new IdValue('9', 'WV', 'Brooke'),
  new IdValue('11', 'WV', 'Cabell'),
  new IdValue('13', 'WV', 'Calhoun'),
  new IdValue('15', 'WV', 'Clay'),
  new IdValue('17', 'WV', 'Doddridge'),
  new IdValue('19', 'WV', 'Fayette'),
  new IdValue('21', 'WV', 'Gilmer'),
  new IdValue('23', 'WV', 'Grant'),
  new IdValue('25', 'WV', 'Greenbrier'),
  new IdValue('27', 'WV', 'Hampshire'),
  new IdValue('29', 'WV', 'Hancock'),
  new IdValue('31', 'WV', 'Hardy'),
  new IdValue('33', 'WV', 'Harrison'),
  new IdValue('35', 'WV', 'Jackson'),
  new IdValue('37', 'WV', 'Jefferson'),
  new IdValue('39', 'WV', 'Kanawha'),
  new IdValue('41', 'WV', 'Lewis'),
  new IdValue('43', 'WV', 'Lincoln'),
  new IdValue('45', 'WV', 'Logan'),
  new IdValue('49', 'WV', 'Marion'),
  new IdValue('51', 'WV', 'Marshall'),
  new IdValue('53', 'WV', 'Mason'),
  new IdValue('47', 'WV', 'McDowell'),
  new IdValue('55', 'WV', 'Mercer'),
  new IdValue('57', 'WV', 'Mineral'),
  new IdValue('59', 'WV', 'Mingo'),
  new IdValue('61', 'WV', 'Monongalia'),
  new IdValue('63', 'WV', 'Monroe'),
  new IdValue('65', 'WV', 'Morgan'),
  new IdValue('67', 'WV', 'Nicholas'),
  new IdValue('69', 'WV', 'Ohio'),
  new IdValue('71', 'WV', 'Pendleton'),
  new IdValue('73', 'WV', 'Pleasants'),
  new IdValue('75', 'WV', 'Pocahontas'),
  new IdValue('77', 'WV', 'Preston'),
  new IdValue('79', 'WV', 'Putnam'),
  new IdValue('81', 'WV', 'Raleigh'),
  new IdValue('83', 'WV', 'Randolph'),
  new IdValue('85', 'WV', 'Ritchie'),
  new IdValue('87', 'WV', 'Roane'),
  new IdValue('89', 'WV', 'Summers'),
  new IdValue('91', 'WV', 'Taylor'),
  new IdValue('93', 'WV', 'Tucker'),
  new IdValue('95', 'WV', 'Tyler'),
  new IdValue('97', 'WV', 'Upshur'),
  new IdValue('99', 'WV', 'Wayne'),
  new IdValue('101', 'WV', 'Webster'),
  new IdValue('103', 'WV', 'Wetzel'),
  new IdValue('105', 'WV', 'Wirt'),
  new IdValue('107', 'WV', 'Wood'),
  new IdValue('109', 'WV', 'Wyoming'),
  new IdValue('1', 'WY', 'Albany'),
  new IdValue('3', 'WY', 'Big Horn'),
  new IdValue('5', 'WY', 'Campbell'),
  new IdValue('7', 'WY', 'Carbon'),
  new IdValue('9', 'WY', 'Converse'),
  new IdValue('11', 'WY', 'Crook'),
  new IdValue('13', 'WY', 'Fremont'),
  new IdValue('15', 'WY', 'Goshen'),
  new IdValue('17', 'WY', 'Hot Springs'),
  new IdValue('19', 'WY', 'Johnson'),
  new IdValue('21', 'WY', 'Laramie'),
  new IdValue('23', 'WY', 'Lincoln'),
  new IdValue('25', 'WY', 'Natrona'),
  new IdValue('27', 'WY', 'Niobrara'),
  new IdValue('29', 'WY', 'Park'),
  new IdValue('31', 'WY', 'Platte'),
  new IdValue('33', 'WY', 'Sheridan'),
  new IdValue('35', 'WY', 'Sublette'),
  new IdValue('37', 'WY', 'Sweetwater'),
  new IdValue('39', 'WY', 'Teton'),
  new IdValue('41', 'WY', 'Uinta'),
  new IdValue('43', 'WY', 'Washakie'),
  new IdValue('45', 'WY', 'Weston'),
];

/**
 * List of Countries - Can be removed from lookups call later.
 */
export const countries: IdValue<string>[] = [
  new IdValue('US', 'US', 'United States'),
  new IdValue('AF', 'AF', 'Afghanistan'),
  new IdValue('AX', 'AX', 'Åland Islands'),
  new IdValue('AL', 'AL', 'Albania'),
  new IdValue('DZ', 'DZ', 'Algeria'),
  new IdValue('AD', 'AD', 'Andorra'),
  new IdValue('AO', 'AO', 'Angola'),
  new IdValue('AI', 'AI', 'Anguilla'),
  new IdValue('AG', 'AG', 'Antigua and Barbuda'),
  new IdValue('AR', 'AR', 'Argentina'),
  new IdValue('AM', 'AM', 'Armenia'),
  new IdValue('AW', 'AW', 'Aruba'),
  new IdValue('AU', 'AU', 'Australia'),
  new IdValue('AT', 'AT', 'Austria'),
  new IdValue('AZ', 'AZ', 'Azerbaijan'),
  new IdValue('BS', 'BS', 'Bahamas'),
  new IdValue('BH', 'BH', 'Bahrain'),
  new IdValue('BD', 'BD', 'Bangladesh'),
  new IdValue('BB', 'BB', 'Barbados'),
  new IdValue('BY', 'BY', 'Belarus'),
  new IdValue('BE', 'BE', 'Belgium'),
  new IdValue('BZ', 'BZ', 'Belize'),
  new IdValue('BJ', 'BJ', 'Benin'),
  new IdValue('BM', 'BM', 'Bermuda'),
  new IdValue('BT', 'BT', 'Bhutan'),
  new IdValue('BO', 'BO', 'Bolivia'),
  new IdValue('BQ', 'BQ', 'Bonaire, Sint Eustatius and Saba'),
  new IdValue('BA', 'BA', 'Bosnia and Herzegovina'),
  new IdValue('BW', 'BW', 'Botswana'),
  new IdValue('BV', 'BV', 'Bouvet Island'),
  new IdValue('BR', 'BR', 'Brazil'),
  new IdValue('IO', 'IO', 'British Indian Ocean Territory'),
  new IdValue('VG', 'VG', 'British Virgin Islands'),
  new IdValue('BN', 'BN', 'Brunei'),
  new IdValue('BG', 'BG', 'Bulgaria'),
  new IdValue('BF', 'BF', 'Burkina Faso'),
  new IdValue('BI', 'BI', 'Burundi'),
  new IdValue('KH', 'KH', 'Cambodia'),
  new IdValue('CM', 'CM', 'Cameroon'),
  new IdValue('CA', 'CA', 'Canada'),
  new IdValue('CV', 'CV', 'Cape Verde'),
  new IdValue('KY', 'KY', 'Cayman Islands'),
  new IdValue('CF', 'CF', 'Central African Republic'),
  new IdValue('TD', 'TD', 'Chad'),
  new IdValue('CL', 'CL', 'Chile'),
  new IdValue('CN', 'CN', 'China'),
  new IdValue('CX', 'CX', 'Christmas Island'),
  new IdValue('CC', 'CC', 'Cocos (Keeling) Islands'),
  new IdValue('CO', 'CO', 'Colombia'),
  new IdValue('KM', 'KM', 'Comoros'),
  new IdValue('CG', 'CG', 'Congo'),
  new IdValue('CK', 'CK', 'Cook Islands'),
  new IdValue('CR', 'CR', 'Costa Rica'),
  // eslint-disable-next-line quotes
  new IdValue('CI', 'CI', "Côte d'Ivoire"),
  new IdValue('HR', 'HR', 'Croatia'),
  new IdValue('CU', 'CU', 'Cuba'),
  new IdValue('CW', 'CW', 'Curaçao'),
  new IdValue('CY', 'CY', 'Cyprus'),
  new IdValue('CZ', 'CZ', 'Czech Republic'),
  new IdValue('CD', 'CD', 'Democratic Republic of the Congo'),
  new IdValue('DK', 'DK', 'Denmark'),
  new IdValue('DJ', 'DJ', 'Djibouti'),
  new IdValue('DM', 'DM', 'Dominica'),
  new IdValue('DO', 'DO', 'Dominican Republic'),
  new IdValue('TL', 'TL', 'East Timor'),
  new IdValue('EC', 'EC', 'Ecuador'),
  new IdValue('EG', 'EG', 'Egypt'),
  new IdValue('SV', 'SV', 'El Salvador'),
  new IdValue('GQ', 'GQ', 'Equatorial Guinea'),
  new IdValue('ER', 'ER', 'Eritrea'),
  new IdValue('EE', 'EE', 'Estonia'),
  new IdValue('SZ', 'SZ', 'Eswatini'),
  new IdValue('ET', 'ET', 'Ethiopia'),
  new IdValue('FK', 'FK', 'Falkland Islands'),
  new IdValue('FO', 'FO', 'Faroe Islands'),
  new IdValue('FJ', 'FJ', 'Fiji'),
  new IdValue('FI', 'FI', 'Finland'),
  new IdValue('FR', 'FR', 'France'),
  new IdValue('GF', 'GF', 'French Guiana'),
  new IdValue('PF', 'PF', 'French Polynesia'),
  new IdValue('TF', 'TF', 'French Southern Territories'),
  new IdValue('GA', 'GA', 'Gabon'),
  new IdValue('GM', 'GM', 'Gambia'),
  new IdValue('GE', 'GE', 'Georgia'),
  new IdValue('DE', 'DE', 'Germany'),
  new IdValue('GH', 'GH', 'Ghana'),
  new IdValue('GI', 'GI', 'Gibraltar'),
  new IdValue('GR', 'GR', 'Greece'),
  new IdValue('GL', 'GL', 'Greenland'),
  new IdValue('GD', 'GD', 'Grenada'),
  new IdValue('GP', 'GP', 'Guadeloupe'),
  new IdValue('GT', 'GT', 'Guatemala'),
  new IdValue('GG', 'GG', 'Guernsey'),
  new IdValue('GN', 'GN', 'Guinea'),
  new IdValue('GW', 'GW', 'Guinea-Bissau'),
  new IdValue('GY', 'GY', 'Guyana'),
  new IdValue('HT', 'HT', 'Haiti'),
  new IdValue('HM', 'HM', 'Heard Island and McDonald Islands'),
  new IdValue('HN', 'HN', 'Honduras'),
  new IdValue('HK', 'HK', 'Hong Kong'),
  new IdValue('HU', 'HU', 'Hungary'),
  new IdValue('IS', 'IS', 'Iceland'),
  new IdValue('IN', 'IN', 'India'),
  new IdValue('Id', 'Id', 'Indonesia'),
  new IdValue('IR', 'IR', 'Iran'),
  new IdValue('IQ', 'IQ', 'Iraq'),
  new IdValue('IE', 'IE', 'Ireland'),
  new IdValue('IM', 'IM', 'Isle of Man'),
  new IdValue('IL', 'IL', 'Israel'),
  new IdValue('IT', 'IT', 'Italy'),
  new IdValue('JM', 'JM', 'Jamaica'),
  new IdValue('JP', 'JP', 'Japan'),
  new IdValue('JE', 'JE', 'Jersey'),
  new IdValue('JO', 'JO', 'Jordan'),
  new IdValue('KZ', 'KZ', 'Kazakhstan'),
  new IdValue('KE', 'KE', 'Kenya'),
  new IdValue('KI', 'KI', 'Kiribati'),
  new IdValue('KW', 'KW', 'Kuwait'),
  new IdValue('KG', 'KG', 'Kyrgyzstan'),
  new IdValue('LA', 'LA', 'Laos'),
  new IdValue('LV', 'LV', 'Latvia'),
  new IdValue('LB', 'LB', 'Lebanon'),
  new IdValue('LS', 'LS', 'Lesotho'),
  new IdValue('LR', 'LR', 'Liberia'),
  new IdValue('LY', 'LY', 'Libya'),
  new IdValue('LI', 'LI', 'Liechtenstein'),
  new IdValue('LT', 'LT', 'Lithuania'),
  new IdValue('LU', 'LU', 'Luxembourg'),
  new IdValue('MO', 'MO', 'Macau'),
  new IdValue('MG', 'MG', 'Madagascar'),
  new IdValue('MW', 'MW', 'Malawi'),
  new IdValue('MY', 'MY', 'Malaysia'),
  new IdValue('MV', 'MV', 'Maldives'),
  new IdValue('ML', 'ML', 'Mali'),
  new IdValue('MT', 'MT', 'Malta'),
  new IdValue('MH', 'MH', 'Marshall Islands'),
  new IdValue('MQ', 'MQ', 'Martinique'),
  new IdValue('MR', 'MR', 'Mauritania'),
  new IdValue('MU', 'MU', 'Mauritius'),
  new IdValue('YT', 'YT', 'Mayotte'),
  new IdValue('MX', 'MX', 'Mexico'),
  new IdValue('FM', 'FM', 'Micronesia'),
  new IdValue('MD', 'MD', 'Moldova'),
  new IdValue('MC', 'MC', 'Monaco'),
  new IdValue('MN', 'MN', 'Mongolia'),
  new IdValue('ME', 'ME', 'Montenegro'),
  new IdValue('MS', 'MS', 'Montserrat'),
  new IdValue('MA', 'MA', 'Morocco'),
  new IdValue('MZ', 'MZ', 'Mozambique'),
  new IdValue('MM', 'MM', 'Myanmar'),
  new IdValue('NA', 'NA', 'Namibia'),
  new IdValue('NR', 'NR', 'Nauru'),
  new IdValue('NP', 'NP', 'Nepal'),
  new IdValue('NL', 'NL', 'Netherlands'),
  new IdValue('NC', 'NC', 'New Caledonia'),
  new IdValue('NZ', 'NZ', 'New Zealand'),
  new IdValue('NI', 'NI', 'Nicaragua'),
  new IdValue('NE', 'NE', 'Niger'),
  new IdValue('NG', 'NG', 'Nigeria'),
  new IdValue('NU', 'NU', 'Niue'),
  new IdValue('NF', 'NF', 'Norfolk Island'),
  new IdValue('KP', 'KP', 'North Korea'),
  new IdValue('MK', 'MK', 'North Macedonia'),
  new IdValue('NO', 'NO', 'Norway'),
  new IdValue('OM', 'OM', 'Oman'),
  new IdValue('PK', 'PK', 'Pakistan'),
  new IdValue('PW', 'PW', 'Palau'),
  new IdValue('PS', 'PS', 'Palestine'),
  new IdValue('PA', 'PA', 'Panama'),
  new IdValue('PG', 'PG', 'Papua New Guinea'),
  new IdValue('PY', 'PY', 'Paraguay'),
  new IdValue('PE', 'PE', 'Peru'),
  new IdValue('PH', 'PH', 'Philippines'),
  new IdValue('PN', 'PN', 'Pitcairn Islands'),
  new IdValue('PL', 'PL', 'Poland'),
  new IdValue('PT', 'PT', 'Portugal'),
  new IdValue('QA', 'QA', 'Qatar'),
  new IdValue('RE', 'RE', 'Réunion'),
  new IdValue('RO', 'RO', 'Romania'),
  new IdValue('RU', 'RU', 'Russia'),
  new IdValue('RW', 'RW', 'Rwanda'),
  new IdValue('BL', 'BL', 'Saint Barthélemy'),
  new IdValue('SH', 'SH', 'Saint Helena, Ascension and Tristan da Cunha'),
  new IdValue('KN', 'KN', 'Saint Kitts and Nevis'),
  new IdValue('LC', 'LC', 'Saint Lucia'),
  new IdValue('MF', 'MF', 'Saint Martin'),
  new IdValue('PM', 'PM', 'Saint Pierre and Miquelon'),
  new IdValue('VC', 'VC', 'Saint Vincent and the Grenadines'),
  new IdValue('WS', 'WS', 'Samoa'),
  new IdValue('SM', 'SM', 'San Marino'),
  new IdValue('ST', 'ST', 'São Tomé and Príncipe'),
  new IdValue('SA', 'SA', 'Saudi Arabia'),
  new IdValue('SN', 'SN', 'Senegal'),
  new IdValue('RS', 'RS', 'Serbia'),
  new IdValue('SC', 'SC', 'Seychelles'),
  new IdValue('SL', 'SL', 'Sierra Leone'),
  new IdValue('SG', 'SG', 'Singapore'),
  new IdValue('SX', 'SX', 'Sint Maarten'),
  new IdValue('SK', 'SK', 'Slovakia'),
  new IdValue('SI', 'SI', 'Slovenia'),
  new IdValue('SB', 'SB', 'Solomon Islands'),
  new IdValue('SO', 'SO', 'Somalia'),
  new IdValue('ZA', 'ZA', 'South Africa'),
  new IdValue('GS', 'GS', 'South Georgia and the South Sandwich Islands'),
  new IdValue('KR', 'KR', 'South Korea'),
  new IdValue('SS', 'SS', 'South Sudan'),
  new IdValue('ES', 'ES', 'Spain'),
  new IdValue('LK', 'LK', 'Sri Lanka'),
  new IdValue('SD', 'SD', 'Sudan'),
  new IdValue('SR', 'SR', 'Suriname'),
  new IdValue('SJ', 'SJ', 'Svalbard'),
  new IdValue('SE', 'SE', 'Sweden'),
  new IdValue('CH', 'CH', 'Switzerland'),
  new IdValue('SY', 'SY', 'Syria'),
  new IdValue('TW', 'TW', 'Taiwan'),
  new IdValue('TJ', 'TJ', 'Tajikistan'),
  new IdValue('TZ', 'TZ', 'Tanzania'),
  new IdValue('TH', 'TH', 'Thailand'),
  new IdValue('TG', 'TG', 'Togo'),
  new IdValue('TK', 'TK', 'Tokelau'),
  new IdValue('TO', 'TO', 'Tonga'),
  new IdValue('TT', 'TT', 'Trinidad and Tobago'),
  new IdValue('TN', 'TN', 'Tunisia'),
  new IdValue('TR', 'TR', 'Turkey'),
  new IdValue('TM', 'TM', 'Turkmenistan'),
  new IdValue('TC', 'TC', 'Turks and Caicos Islands'),
  new IdValue('TV', 'TV', 'Tuvalu'),
  new IdValue('UG', 'UG', 'Uganda'),
  new IdValue('UA', 'UA', 'Ukraine'),
  new IdValue('AE', 'AE', 'United Arab Emirates'),
  new IdValue('GB', 'GB', 'United Kingdom'),
  new IdValue('UM', 'UM', 'United States Minor Outlying Islands'),
  new IdValue('UY', 'UY', 'Uruguay'),
  new IdValue('UZ', 'UZ', 'Uzbekistan'),
  new IdValue('VU', 'VU', 'Vanuatu'),
  new IdValue('VA', 'VA', 'Vatican City'),
  new IdValue('VE', 'VE', 'Venezuela'),
  new IdValue('VN', 'VN', 'Vietnam'),
  new IdValue('WF', 'WF', 'Wallis and Futuna'),
  new IdValue('EH', 'EH', 'Western Sahara'),
  new IdValue('YE', 'YE', 'Yemen'),
  new IdValue('ZM', 'ZM', 'Zambia'),
  new IdValue('ZW', 'ZW', 'Zimbabwe'),
];

export const countriesWithSelectOption = [new IdValue(null, null, 'Select'), ...countries.map((t) => new IdValue(t.id, t.id, t.name))];
